{
  "landingCleanup": {
    "eyebrow": "Deine erste kleine gute Tat",
    "demo": "Zum Ausprobieren",
    "unit": "EP",
    "experience": "{{count}} Erfahrungspunkte in der Demo",
    "paper": "Papier aufheben und in die Tonne ziehen",
    "hint": "Mit der Maus ziehen · Auf dem Handy mit dem Finger",
    "keyboard": "Mit der Eingabe- oder Leertaste aufheben und einwerfen.",
    "photoCaption": "Deine gute Tat im Bild",
    "photoDone": "Foto aufgenommen",
    "uploadCaption": "Deine Tat wird hochgeladen …",
    "rewardCaption": "Kleine Tat. Gutes Gefühl.",
    "restart": "Neu starten",
    "continue": "Entdecke Goodvale",
    "status": {
      "ready": "Zieh das Papier in die Tonne.",
      "dragging": "Ab zur Tonne!",
      "release": "Loslassen – gut gemacht!",
      "photo": "Ein Foto hält deine gute Tat fest.",
      "upload": "Deine Tat landet bei Goodvale.",
      "complete": "Dein Einsatz macht einen Unterschied."
    },
    "note": "Interaktive Demo · Echte Taten erhalten EP nach ihrer Bestätigung."
  },
  "partnerTargeting": {
    "summary": "Deine Zielgruppe",
    "reset": "Auswahl zurücksetzen",
    "noRestrictions": "Alle Nutzer mit Zugang zu Partnerangeboten können dein Angebot nutzen.",
    "experience": "Wie viel Erfahrung ist nötig?",
    "experienceHelp": "Wähle einen Mindestrang. Alle höheren Ränge sind ebenfalls zugelassen.",
    "everyone": "Alle",
    "noMinimum": "Kein Mindestrang",
    "fromXp": "ab {{value}} XP",
    "rankLink": "Rangsystem ansehen ↗",
    "ranks": { "E": "Entdecker", "D": "Pionier", "C": "Hüter", "B": "Meister", "A": "Elite", "S": "Legende" },
    "trust": "Wie viel Vertrauen ist nötig?",
    "trustHelp": "Karma zeigt das Vertrauen in einen Nutzer. Wähle eine Stufe statt einer Zahl.",
    "platformAccess": "Kein Zusatzminimum",
    "fromKarma": "ab +{{value}} Karma",
    "customKarma": "Eigener Mindestwert: {{value}} Karma · unten anpassbar",
    "category": "Erfahrung in einer bestimmten Kategorie",
    "categoryHelp": "Optional: Sprich Nutzer an, die in einem Bereich aktiv sind.",
    "categoryToggle": "Kategorie voraussetzen",
    "selectedCategory": "Gewählte Kategorie",
    "change": "Ändern",
    "categoryLevel": "Erfahrung in der Kategorie",
    "categoryLevelValue": "Ab Level {{level}} · {{xp}} Kategorie-XP nötig",
    "categoryStages": { "0": "Erste Erfahrung", "1": "Fortgeschritten", "2": "Spezialisiert" },
    "fromLevel": "ab Level {{value}}",
    "customCategoryLevel": "Eigenes Kategorielevel: {{value}} · unten anpassbar",
    "event": "Teilnahme an einer Aktion",
    "eventHelp": "Optional: Eine bestätigte gute Tat bei einer bestimmten Aktion voraussetzen.",
    "eventToggle": "Teilnahme voraussetzen",
    "noEvents": "Aktuell stehen keine Aktionen zur Auswahl.",
    "selectEvent": "Welche Aktion?",
    "savedEvent": "Gespeicherte Aktion",
    "advanced": "Erweiterte Einstellungen",
    "advancedHelp": "Bei Bedarf kannst du genaue Mindestwerte ergänzen. Sie gelten zusätzlich zu deiner Auswahl oben.",
    "customActive": "Eigene Werte aktiv",
    "minLevel": "Mindestlevel insgesamt",
    "minGlobalExperience": "Mindest-XP insgesamt",
    "minKarma": "Eigener Karma-Mindestwert",
    "minCategoryLevel": "Eigenes Mindestlevel in der Kategorie",
    "minCategoryExperience": "Mindest-XP in der Kategorie",
    "noExtraMinimum": "Kein zusätzliches Minimum",
    "rankSummary": "Rang {{rank}} und höher",
    "karmaSummary": "Karma ab {{value}}",
    "levelValue": "Level {{value}}+",
    "minLevelSummary": "Gesamtlevel {{value}}+",
    "minGlobalExperienceSummary": "Gesamt-XP {{value}}+",
    "minCategoryExperienceSummary": "Kategorie-XP {{value}}+",
    "reach": "Anteil der qualifizierten Nutzer",
    "audienceShort": "Die Reichweite passt sich deiner Auswahl automatisch an.",
    "howCounted": "Wie wird die Zielgruppe gezählt?"
  },
  "partnerPass": {
    "eyebrow": "Verifikation abgeschlossen",
    "title": "Pass erfolgreich verifiziert",
    "subtitle": "Kundeninformationen und persönliche Vorteile auf einen Blick.",
    "profile": "Verifiziertes Profil",
    "valid": "Gültiger Pass",
    "noGuild": "Keine Gilde",
    "karma": "Karma",
    "security": "Signatur geprüft · Zeitstempel gültig",
    "benefitsEyebrow": "Persönliche Vorteile",
    "benefits": "Angebote & Boni",
    "available_one": "{{count}} Angebot kann jetzt eingelöst werden.",
    "available_other": "{{count}} Angebote können jetzt eingelöst werden.",
    "eligible": "Jetzt einlösbar",
    "unavailable": "Nicht verfügbar",
    "discount": "Rabatt",
    "emptyTitle": "Noch keine Angebote",
    "emptyDescription": "Aktuell sind keine Angebote für diesen Pass hinterlegt.",
    "frequency": {
      "Unlimited": "Unbegrenzt",
      "Daily": "Täglich",
      "Weekly": "Wöchentlich",
      "Monthly": "Monatlich",
      "Yearly": "Jährlich",
      "Once": "Einmalig",
      "OncePerDay": "1× täglich",
      "OncePerWeek": "1× wöchentlich",
      "OncePerMonth": "1× monatlich",
      "OnceEver": "Einmalig",
      "EveryXDays": "In regelmäßigen Abständen"
    }
  },
  "partnerApprovalEmail": {
    "deliveryFailed": "Der Partner wurde freigeschaltet, aber die Bestätigungsmail konnte nicht versendet werden. Bitte prüfe den Mailversand und informiere den Partner."
  },
  "partnerOfferSetup": {
    "redemptionMode": "Einmalig oder mehrfach einlösbar",
    "onceTitle": "Einmalig",
    "multiple": "Mehrfach",
    "multipleHelp": "Nutzer können das Angebot wiederholt einlösen. Häufigkeit und Limits legst du unten fest.",
    "audienceLoading": "Zielgruppe wird berechnet …",
    "audienceError": "Zielgruppe aktuell nicht verfügbar",
    "audienceCount": "{{qualified}} von {{total}} Nutzern qualifizieren sich",
    "audienceHelp": "Aktuell freigeschaltete Nutzer der Plattform mit Zugang zu Partnerangeboten. Alle gewählten Voraussetzungen müssen gemeinsam erfüllt sein. Einlösehäufigkeit, Kontingente und Angebotszeitraum sind hier nicht berücksichtigt.",
    "rankHelp": "Ränge zeigen die gesammelte Erfahrung: F ist der Einstieg, danach folgen E, D, C, B, A und S. Der gewählte Rang und alle höheren Ränge sind zugelassen.",
    "rankLink": "Ränge und Aufstieg erklären lassen ↗",
    "progressHelp": "Level und Gesamt-XP beschreiben den allgemeinen Fortschritt. Kategorielevel und Kategorie-XP beziehen sich nur auf die ausgewählte Kategorie. Leere Felder schränken die Zielgruppe nicht zusätzlich ein.",
    "karmaHelp": "Karma beschreibt das Vertrauen in einen Nutzer. {{neutral}}: 0; {{honorable}}: ab {{honorableValue}}; {{trusted}}: ab {{trustedValue}}; {{veryTrusted}}: ab {{veryTrustedValue}}; {{exemplary}}: ab {{exemplaryValue}}. Partnerangebote sind nur über {{restriction}} Karma zugänglich.",
    "once": "Einmalig pro Nutzer",
    "onceHelp": "Jeder Nutzer kann dieses Angebot insgesamt einmal einlösen. Eine Häufigkeit entfällt."
  },
  "partnerDiscovery": {
    "tab_available": "Verfügbar",
    "tab_history": "Historie",
    "view": "Ansehen",
    "title": "Partner",
    "available": "Für mich verfügbar",
    "description": "Diese Partnerangebote kannst du aktuell nutzen. Rang, Level, Karma, Kategorie-Fortschritt, Erfolge, Gültigkeit und bisherige Einlösungen werden berücksichtigt. Die Verfügbarkeit wird beim Einlösen erneut geprüft.",
    "all": "Alle Angebote",
    "both": "Vor Ort & digital",
    "history": "Einlösungshistorie",
    "details": "Angebot beim Partner ansehen",
    "validUntil": "Gültig bis {{date}}",
    "count_one": "{{count}} verfügbares Angebot",
    "count_other": "{{count}} verfügbare Angebote",
    "error": "Deine verfügbaren Partnerangebote konnten nicht geladen werden.",
    "empty": "Aktuell keine Angebote für dich verfügbar",
    "emptyHint": "Derzeit ist kein aktives Angebot unter deinen aktuellen Voraussetzungen und Einlöselimits verfügbar. Schau später wieder vorbei.",
    "noResults": "Keine passenden Angebote"
  },
  "redemptionHistory": {
    "title": "Einlösungen",
    "subtitle": "Deine Partnerangebote",
    "description": "Hier findest du deine eingelösten Vorteile und digitalen Gutscheine wieder.",
    "map": "Partner auf der Karte entdecken",
    "search": "Partner oder Angebot suchen",
    "channel": "Einlösungsart",
    "all": "Alle Einlösungen",
    "onsite": "Vor Ort",
    "digital": "Digital",
    "copied": "Gutscheincode kopiert.",
    "copyError": "Kopieren nicht möglich. Bitte markiere und kopiere den Code.",
    "loading": "Einlösungen werden geladen …",
    "error": "Deine Einlösungen konnten nicht geladen werden.",
    "retry": "Erneut versuchen",
    "empty": "Noch keine Einlösungen",
    "emptyHint": "Entdecke Partner auf der Weltkarte und löse dein erstes Angebot ein.",
    "noResults": "Keine passenden Einlösungen",
    "adjustFilters": "Passe deine Suche oder den Filter an.",
    "count_one": "{{count}} Einlösung",
    "count_other": "{{count}} Einlösungen",
    "cancelled": "Storniert",
    "confirmed": "Eingelöst",
    "code": "Dein Gutscheincode",
    "copy": "Code kopieren",
    "showCode": "Code anzeigen",
    "hideCode": "Code ausblenden",
    "shop": "Zum Webshop",
    "more": "Weitere anzeigen",
    "limit": "Angezeigt werden deine letzten 500 Einlösungen."
  },
  "heroic_approval": {
    "title": "Gute Tat bestätigt!",
    "message": "Deine gute Tat wurde geprüft und bestätigt. Diese Belohnungen wurden dir gutgeschrieben:",
    "category": "Kategorie",
    "performed_at": "Durchgeführt am",
    "milestones": "Neue Kategorie-Meilensteine",
    "category_level": "Kategorie-Level {{level}} erreicht",
    "badge_label": "Abzeichen {{category}}, Level {{level}}",
    "continue": "Weiter",
    "setting": "Popups bei bestätigten guten Taten anzeigen"
  },
  "category_milestones": {
    "titles": {
      "MOBILITY_OUTDOOR": [
        "Wegfreund",
        "Wegbegleiter",
        "Pfadfinder",
        "Wegbereiter",
        "Wegekundiger",
        "Hüter der Pfade",
        "Nordstern der Gemeinschaft"
      ],
      "HEALTH_WELLNESS": [
        "Kraftquelle",
        "Alltagsstütze",
        "Wohlfühlbegleiter",
        "Hüter des Wohlbefindens",
        "Quelle der Zuversicht",
        "Anker des Alltags",
        "Herz der Fürsorge"
      ],
      "ENTERTAINMENT_GASTRO": [
        "Geselliger Gast",
        "Gastgeber",
        "Stimmungsmacher",
        "Brückenbauer",
        "Seele der Begegnung",
        "Hüter der Gemeinschaftsfeste",
        "Zentrum der Begegnung"
      ],
      "HARDWARE_FITNESS": [
        "Bewegungsfreund",
        "Trainingsbegleiter",
        "Motivator",
        "Antrieb der Gruppe",
        "Kraftspender",
        "Hüter der Bewegung",
        "Unermüdlicher Antrieb"
      ],
      "ECO_NATURE": [
        "Naturfreund",
        "Naturpfleger",
        "Umweltbewahrer",
        "Hüter des Grüns",
        "Stimme der Natur",
        "Wächter der Lebensräume",
        "Wurzel der Welt"
      ],
      "TECH_EDUCATION": [
        "Wissbegieriger",
        "Wissender",
        "Lernbegleiter",
        "Wissensvermittler",
        "Brücke zum Wissen",
        "Hüter des Lernens",
        "Leuchtfeuer des Wissens"
      ],
      "CRAFTING_REPAIR": [
        "Tüftler",
        "Handwerkslehrling",
        "Werkzeugkenner",
        "Bewahrer der Dinge",
        "Handwerksmeister",
        "Hüter des Handwerks",
        "Seele der Dinge"
      ],
      "FOOD_GROCERIES": [
        "Küchenhelfer",
        "Kochlehrling",
        "Nahversorger",
        "Hüter der Tafel",
        "Herz der Versorgung",
        "Bewahrer der Ernte",
        "Legende der Versorgung"
      ],
      "LOGISTICS_RETAIL": [
        "Flinker Bote",
        "Versorgungsbote",
        "Lokaler Händler",
        "Koordinator der Wege",
        "Stütze der Versorgung",
        "Hüter der Handelswege",
        "Seele der Versorgung"
      ],
      "SOCIAL_COMMUNITY": [
        "Gute Seele",
        "Organisator",
        "Stütze der Gemeinschaft",
        "Verbinder der Herzen",
        "Herz der Gemeinschaft",
        "Hüter des Miteinanders",
        "Seele der Gemeinschaft"
      ]
    },
    "collection": "Kategorie-Titel & Abzeichen",
    "possible_titles": "Mögliche Titel",
    "active": "Profil-Titel",
    "none": "Kein Titel",
    "clear": "Titel entfernen",
    "select": "Im Profil anzeigen",
    "selected": "Ausgewählt",
    "locked": "Noch gesperrt",
    "level": "Level {{level}}",
    "unlocked_count": "{{count}} von 7 freigeschaltet",
    "save_error": "Der Titel konnte nicht gespeichert werden."
  },
  "level_up": {
    "eyebrow": "Ein neuer Meilenstein",
    "level": "Level",
    "level_label": "Level {{level}} erreicht",
    "title": "Levelaufstieg!",
    "message": "Dein Charakter hat Level {{level}} erreicht! Danke für deinen wertvollen Beitrag zu unserer Gemeinschaft, unserer Welt und zu Goodvale. Mit deinem neuen Level könnten weitere Partnerbelohnungen für dich verfügbar sein. Schau nach, was Partner in deiner Nähe anbieten!",
    "continue": "Weiter geht’s!",
    "find_partners": "Partner in der Nähe entdecken",
    "setting_hint": "Zeigt ein Popup, wenn dein Charakter ein neues Level erreicht."
  },
  "profile_identity": {
    "abilities": "Deine Fähigkeiten & Boni"
  },
  "adventureFlow": {
    "kicker": "So funktioniert Goodvale",
    "title": "In drei Schritten zum Fortschritt",
    "steps": [
      {
        "title": "Gutes tun",
        "body": "Hilf deiner Umgebung: Sammle Müll, unterstütze Nachbarn oder gib Wissen weiter. Auch kleine Alltagshilfen zählen."
      },
      {
        "title": "Tat einreichen",
        "body": "Beschreibe deine tatsächlich geleistete gute Tat in Goodvale und ergänze den nötigen Nachweis."
      },
      {
        "title": "Bestätigung erhalten",
        "body": "Unabhängige Prüfer bewerten deine Einreichung. Nach der Bestätigung erhältst du Erfahrungspunkte und entwickelst deinen Charakter weiter."
      }
    ]
  },
  "flyers": {
    "kicker": "Zum Entdecken & Weitergeben",
    "meta": "PDF · 1 Seite · Deutsch",
    "download": "Flyer herunterladen",
    "open": "Vorschau öffnen (neuer Tab)",
    "partner": {
      "title": "Der Partner-Flyer",
      "body": "Alle Vorteile und die Einlösung anschaulich auf einer Seite. Lade den Flyer in deiner Sprache herunter oder teile ihn mit deinem Team.",
      "alt": "Vorschau des Goodvale-Partner-Flyers"
    }
  },
  "partnersPage": {
    "nav": "Partner",
    "learnMore": "Partner werden & Flyer ansehen",
    "kicker": "Gemeinsam etwas bewegen",
    "title": "Gratis Partner werden. Gemeinsam die Welt verbessern.",
    "register": "Kostenlos als Partner registrieren",
    "benefits": [
      {
        "title": "Neue Kunden erreichen",
        "body": "Dein Profil und deine Angebote machen deinen Betrieb sichtbar. Ein attraktiver Vorteil kann zum ersten Besuch und zum Wiederkommen motivieren."
      },
      {
        "title": "Dein Angebot, deine Regeln",
        "body": "Du bestimmst Rabatt, Extra oder Service sowie Voraussetzungen, Laufzeit und Einlöselimits. Die Teilnahme ist kostenlos; dein Beitrag ist dein selbst gewähltes Angebot."
      },
      {
        "title": "Einfach einlösen",
        "body": "Vor Ort scannt dein Team den QR-Pass im Partnerportal. Digitale Angebote lassen sich in der App einlösen. Goodvale prüft die Voraussetzungen und speichert die Einlösung."
      }
    ],
    "howTitle": "So wird aus Engagement ein Besuch",
    "exampleNote": "Illustratives Beispiel. Angebot und Einlöseart legst du fest. Nach Registrierung und Freischaltung kannst du loslegen.",
    "flyerKicker": "Zum Mitnehmen & Weitergeben",
    "flyerTitle": "Der Partner-Flyer",
    "flyerBody": "Alle Vorteile und der Ablauf anschaulich auf einer Seite. Lade den Flyer herunter oder öffne die Vorschau in voller Größe.",
    "flyerMeta": "PDF · 1 Seite · Deutsch · 15 MB",
    "previewAlt": "Vorschau des Goodvale-Partner-Flyers mit Vorteilen und Einlösebeispiel",
    "download": "Flyer herunterladen",
    "open": "PDF öffnen (neuer Tab)"
  },
  "class_change": {
    "once": "Einmalige Gelegenheit",
    "until": "Bis {{date}}",
    "deadline": "Einmaliger Wechsel möglich bis {{date}}.",
    "saving": "Wird gespeichert …",
    "retry": "Erneut versuchen"
  },
  "ui_text": {
    "admin_dashboard": {
      "partner_applications_stat": "Partner Bewerbungen",
      "no_appeals": "Keine offenen Einsprüche vorhanden.",
      "no_moderator_applications": "Keine offenen Moderatoren-Bewerbungen vorhanden.",
      "partner_applications": "Partner-Bewerbungen",
      "all_partners": "Alle Partner",
      "unlock": "Freischalten",
      "no_partner_applications": "Keine offenen Partner-Bewerbungen zur Freischaltung vorhanden.",
      "recent_users": "Neueste Benutzer",
      "all_users": "Alle Benutzer",
      "banned": "Gesperrt",
      "active": "Aktiv",
      "no_users": "Keine neuen Benutzer gefunden.",
      "audit_errors": "Audit-Log Fehler & Systemereignisse",
      "no_audit_entries": "Keine Fehler- oder Sanktionseinträge vorhanden."
    },
    "admin_class_category": {
      "no_categories": "Keine Kategorien vorhanden.",
      "cancel": "Abbrechen",
      "save": "Speichern",
      "parallel_deed_slot": "Paralleler Gute-Taten-Slot",
      "save_perk": "Perk Speichern"
    },
    "partner_offer_editor": {
      "loading_offer": "Lade Angebotsdaten …",
      "partner_location": "Partner-Standort",
      "place_pin": "Klicke auf die Karte, um den Pin zu platzieren",
      "no_restriction": "Keine Einschränkung",
      "no_requirement": "Keine Voraussetzung",
      "day_interval": "Abstand in Tagen (z.B. alle 14 Tage)"
    },
    "guild_members_admin": {
      "loading": "Lade Mitglieder & Antragsverwaltung...",
      "loading_applications": "Lade offene Bewerbungen...",
      "cancel": "Abbrechen"
    },
    "guild_branding": {
      "save": "Änderungen speichern"
    },
    "admin_partners": {
      "all_partners": "Alle Partner",
      "no_pending_applications": "Alle eingegangenen Partneranträge wurden bereits bearbeitet.",
      "all_categories": "Alle Kategorien",
      "no_partners": "Keine Partnerbetriebe gefunden.",
      "map_location": "Standort auf Karte (Optional)"
    },
    "guild_detail_misc": {
      "cancel": "Abbrechen",
      "close": "Schließen"
    },
    "admin_tribunal_moderators": {
      "reason": "Begründung (wird der nutzenden Person mitgeteilt):",
      "cancel": "Abbrechen"
    },
    "register_misc": {
      "active": "Aktiv"
    },
    "partner_pos_misc": {
      "rank": "RANG",
      "redeeming": "Wird eingelöst..."
    },
    "karma_admin_panel": {
      "cancel": "Abbrechen",
      "profile": "Profil"
    },
    "admin_user_detail": {
      "back_to_list": "Zurück zur Liste"
    },
    "login_misc": {
      "welcome_back": "Willkommen zurück"
    },
    "heroic_actions_misc": {
      "next": "Weiter →",
      "rules_contributions_title": "Nachvollziehbare Beiträge",
      "rules_contributions_intro": "Beschreibe deine eigene Tätigkeit, ihren Zeitpunkt und ihre Wirkung. Die Einschätzung von Zeit und Einsatz sowie Planung und Abstimmung dient als Orientierung; die endgültige Bewertung erfolgt in der Prüfung.",
      "rules_evidence_title": "Nachweise & Rückfragen",
      "rules_slots_title": "Slots & Wartezeiten",
      "rules_slots_intro": "Einzelaktionen und aktive Gruppenanmeldungen teilen sich deine Slots. Offene Aktionen und laufende Wartezeiten belegen jeweils einen Slot. Rückzug oder Abbruch geben den Slot sofort frei."
    },
    "landing_misc": {
      "small_deeds_big": "Kleine Taten. Große"
    },
    "admin_partner_card": {
      "location_recorded": "Standort erfasst"
    },
    "avatar_uploader_misc": {
      "cancel": "Abbrechen"
    },
    "submissions_filter_misc": {
      "none": "Keine"
    }
  },
  "guild_rooms": {
    "change_room": "Raum wechseln",
    "content": "Rauminhalt",
    "locked": "Noch nicht freigeschaltet",
    "news": "Neuigkeiten",
    "roster": "Mitglieder",
    "stammtisch": "Stammtisch",
    "bounties": "Gruppenaktionen",
    "design": "Raumstil",
    "settings": "Verwaltung"
  },
  "cookie": {
    "title": "Datenschutz & Tracking-Einstellungen",
    "description": "Du entscheidest getrennt über Umami-Nutzungsstatistiken (selbst gehostet bei Hetzner) und Sentry-Fehlerdiagnose im Browser. Beide sind freiwillig und zunächst ausgeschaltet. Du kannst ablehnen oder deine Auswahl später unter Datenschutz ändern.",
    "accept_all": "Alle erlauben",
    "decline_all": "Alle ablehnen",
    "settings": "Einstellungen",
    "save": "Einstellungen speichern",
    "privacy_policy": "Datenschutzerklärung",
    "essential_title": "Essenzielle Funktionen",
    "essential_desc": "Session, Sprach- und Theme-Einstellungen. Immer aktiv.",
    "analytics_title": "Umami Analytics (Web-Tracking)",
    "analytics_desc": "Seitenaufrufe, Verweisquellen und technische Browserdaten zur Verbesserung von Goodvale.",
    "status_enabled": "Aktiviert",
    "status_disabled": "Deaktiviert",
    "reopen_tooltip": "Cookie- & Tracking-Einstellungen anpassen",
    "diagnostics_title": "Sentry (Fehlerdiagnose)",
    "diagnostics_desc": "Fehlermeldungen und technische Diagnoseinformationen zur Fehlerbehebung. Unabhängig von Umami wählbar.",
    "always_active": "Immer aktiv"
  },
  "hero_card": {
    "level": "Level",
    "actions": "Gute Taten",
    "loading": "QR-Code wird geladen …",
    "unavailable": "QR-Code gerade nicht verfügbar",
    "retry": "Erneut laden",
    "refreshes": "Erneuert sich automatisch"
  },
  "dialogs": {
    "close": "Schließen",
    "cancel": "Abbrechen",
    "ok": "Verstanden",
    "confirm": "Bestätigen",
    "submit": "Absenden",
    "reason": "Deine Begründung",
    "placeholder": "Schreibe hier deine Begründung …",
    "minimum": "{{current}} / {{count}} Zeichen mindestens",
    "alert_title": "Hinweis",
    "confirm_title": "Aktion bestätigen",
    "prompt_title": "Begründung hinzufügen",
    "motivation": "Deine Motivation",
    "apply": "Bewerbung senden",
    "delete_account": "Konto endgültig löschen",
    "confirmation_phrase": "Bestätigungsphrase"
  },
  "app": {
    "title": "Goodvale"
  },
  "world": {
    "nav": {
      "overview": "Übersicht",
      "heroic": "Gute Tat",
      "events": "Events",
      "chat": "Chat",
      "profile": "Profil"
    }
  },
  "settings": {
    "language": "Sprache",
    "theme": "Design"
  },
  "common": {
    "login": "Anmelden",
    "register": "Registrieren",
    "novice": "Novize",
    "error": "Fehler beim Laden der Daten.",
    "retry": "Erneut versuchen",
    "refresh": "Aktualisieren",
    "cancel": "Abbrechen",
    "close": "Schließen",
    "copy": "Kopieren",
    "loading": "Lädt…",
    "loadMore": "Mehr laden",
    "pagination": "Seiten",
    "prev": "Zurück",
    "previous": "Zurück",
    "next": "Weiter",
    "latitude": "Breitengrad",
    "longitude": "Längengrad",
    "gps": {
      "notSupported": "GPS wird von diesem Browser nicht unterstützt.",
      "error": "Standort konnte nicht ermittelt werden.",
      "useCurrent": "GPS-Ortung"
    }
  },
  "nav": {
    "moderation": "Moderation",
    "map": "Karte",
    "faq": "FAQ",
    "help": "Hilfe",
    "logout": "Abmelden",
    "mechanics": "Mechanik",
    "profile": "Mein Profil",
    "chats": "Chats",
    "heroic_slots": "Meine Slots",
    "language": "Sprache",
    "legal": "Rechtliches",
    "settings": "Einstellungen",
    "system_config": "System-Konfiguration",
    "heroic_actions": "Gute Taten",
    "categories": "Kategorien"
  },
  "karma": {
    "marker_exemplary": "Vertrauensanker",
    "marker_exemplary_detail": "Ab hier gilt die höchste Vertrauensstufe.",
    "marker_very_trusted": "Hoffnungsträger",
    "marker_very_trusted_detail": "Ab hier beginnt die nächste positive Vertrauensstufe.",
    "marker_saint": "Vertrauensvoll",
    "marker_saint_detail": "Ab hier beginnt die Stufe Vertrauensvoll.",
    "marker_honorable": "Verlässlich",
    "marker_honorable_detail": "Ab hier beginnt die Stufe Verlässlich.",
    "marker_neutral": "Neutral",
    "marker_partner": "Partnervorteile gesperrt",
    "marker_suspension": "Kontosperre",
    "marker_suspension_detail": "Ab {{suspension}} für {{months}} Kalendermonat(e).",
    "tier_trusted": "Vertrauensvoll",
    "tier_trusted_desc": "Hohes Vertrauen durch verlässliches Engagement.",
    "tier_very_trusted": "Hoffnungsträger",
    "tier_very_trusted_desc": "Du hast durch beständiges Engagement viel Vertrauen aufgebaut.",
    "tier_exemplary": "Vertrauensanker",
    "tier_exemplary_desc": "Du hast die höchste Vertrauensstufe erreicht.",
    "tier_honorable": "Verlässlich",
    "tier_honorable_desc": "Deine bestätigten guten Taten zeigen, dass man sich auf dich verlassen kann.",
    "tier_trusty": "Zuverlässiger Gefährte",
    "tier_neutral": "Neutraler Reisender",
    "tier_warned": "Leicht Verwarnt",
    "tier_banned": "Konto gesperrt",
    "tier_restricted": "Temporäre Kontosperre",
    "tier_released": "Partnervorteile gesperrt",
    "reason": "Begründung / Nachricht (5–1000 Zeichen)",
    "saving": "Wird gespeichert …",
    "search": "Person suchen"
  },
  "avatar": {
    "title": "Profilbild anpassen",
    "upload_btn": "Neues Bild hochladen",
    "cropping_hint": "Bild verschieben und mit dem Regler zoomen. Der sichtbare Ausschnitt wird gespeichert.",
    "zoom": "Zoom",
    "preview": "Vorschau des Profilausschnitts",
    "no_image": "Kein Bild",
    "invalid_file": "Bitte wähle ein gültiges JPG-, PNG- oder WebP-Bild aus.",
    "save": "Speichern",
    "uploading": "Wird hochgeladen...",
    "success": "Profilbild erfolgreich aktualisiert!",
    "error": "Fehler beim Hochladen des Profilbilds."
  },
  "tavern": {
    "subtitle": "Was die Welt bewegt.",
    "description": "Hier erfährst du, was auf Goodvale passiert: Neuigkeiten, aktuelle Events und Entwicklungen aus der Community.",
    "filterLabel": "Beiträge filtern",
    "filters": {
      "all": "Alle",
      "news": "Neuigkeiten",
      "events": "Events",
      "community": "Community"
    },
    "loadError": "Neuigkeiten konnten nicht geladen werden.",
    "loading": "Schenke Getränke ein...",
    "detail": {
      "unavailable": "Diese System-News konnten nicht geladen werden.",
      "footer": "Neuigkeiten aus GuildWorld"
    },
    "editor": {
      "formatting": "Textformatierung",
      "bold": "Fett",
      "italic": "Kursiv",
      "underline": "Unterstrichen",
      "heading": "Überschrift",
      "bulletList": "Aufzählung",
      "orderedList": "Nummerierung",
      "quote": "Zitat",
      "link": "Link",
      "unlink": "Link entfernen",
      "undo": "Rückgängig",
      "redo": "Wiederholen",
      "linkUrl": "Link-Adresse",
      "apply": "Übernehmen",
      "invalidLink": "Bitte https://, http:// oder mailto: verwenden."
    },
    "admin": {
      "createNews": "System-News erstellen",
      "editNews": "System-News bearbeiten",
      "saveChanges": "Änderungen speichern",
      "newsTitle": "Titel der System-News",
      "newsContent": "Inhalt der Ankündigung...",
      "publish": "Ankündigung veröffentlichen",
      "publishing": "Wird veröffentlicht...",
      "success": "System-News erfolgreich veröffentlicht!",
      "error": "Fehler beim Veröffentlichen der System-News.",
      "newsTitlePlaceholder": "z. B. Wartungsarbeiten am Wochenende",
      "newsContentPlaceholder": "Inhalt der Ankündigung…",
      "cancel": "Abbrechen"
    },
    "feed": {
      "adventurerJoinedTag": "NEUE ABENTEURER:IN",
      "heroicActionApproved": "{{name}} hat die gute Tat ‚{{title}}‘ bestätigt bekommen",
      "heroicActionTag": "Bestätigte gute Tat",
      "systemNewsTag": "System News",
      "partnerJoinedTag": "Neue:r Partner:in",
      "openOnMap": "Auf Karte zeigen",
      "showInCalendar": "Im Kalender markieren",
      "viewProfile": "Profil ansehen"
    },
    "author": "Von: {{name}}"
  },
  "guilds": {
    "page_status": "Seite {{current}} von {{total}}",
    "members": "Mitglieder",
    "memberStatus": "Mitglied ✓",
    "manageGuild": "Verwalten",
    "decorations": {
      "stages": {
        "0": "Gründung",
        "1": "Anerkannt",
        "2": "Angesehen",
        "3": "Berühmt"
      },
      "details": {
        "0": "Holzrahmen & Laternen",
        "1": "Bronzeverzierungen",
        "2": "Steinbögen & Bronzebeschläge",
        "3": "Gold & farbiges Glas",
        "4": "Leuchtende Runen"
      }
    },
    "join": {
      "label": "Beitreten",
      "pending": "Anfrage ausstehend",
      "noUser": "Keine angemeldete Person gefunden.",
      "success": "Bewerbung erfolgreich eingereicht!",
      "error": "Beitritt fehlgeschlagen. Bitte versuche es erneut."
    },
    "memberBanner": {
      "description": "Du bist Mitglied von {{name}}. Gestaltet eure Welt gemeinsam durch gute Taten!"
    },
    "createModal": {
      "cancel": "Abbrechen",
      "descTooLong": "Beschreibung darf max. 300 Zeichen haben.",
      "latitudeRequired": "Breitengrad ist erforderlich.",
      "invalidLatitude": "Ungültiger Breitengrad (-90 bis 90).",
      "longitudeRequired": "Längengrad ist erforderlich.",
      "invalidLongitude": "Ungültiger Längengrad (-180 bis 180)."
    },
    "createPage": {
      "requirementsTitle": "Voraussetzungen für die Gründung",
      "actionsProgress": "{{required}} bestätigte eigene gute Taten (aktuell: {{current}})",
      "requirementsUnavailable": "Die Gründungsvoraussetzungen konnten nicht geladen werden. Bitte versuche es später erneut.",
      "requirementsLoading": "Gründungsvoraussetzungen werden geladen…"
    },
    "house_public": "Öffentlich",
    "verwalten": "Verwalten"
  },
  "share": {
    "title": "Freunde einladen",
    "copy_link": "Link kopieren",
    "link_copied": "Kopiert!",
    "via_email": "Per E-Mail einladen",
    "via_telegram": "Über Telegram teilen",
    "via_whatsapp": "Über WhatsApp teilen",
    "native_share": "Über andere Apps teilen",
    "invite_subject": "Einladung zu Goodvale",
    "invite_text": "Tritt Goodvale bei und mache die Welt zu einem besseren Ort! Registriere dich hier:"
  },
  "pos": {
    "error_empty_token": "Bitte einen gültigen QR-Code eingeben oder scannen.",
    "verification_failed": "Verifikation fehlgeschlagen.",
    "network_error": "Fehler bei der Kommunikation mit dem Server.",
    "redeem_failed": "Einlösung fehlgeschlagen.",
    "redeem_error": "Fehler beim Einlösen des Angebots.",
    "verifying_state": "Kryptographische Signatur wird geprüft...",
    "align_qr": "QR-Pass vorhalten",
    "manual_token_label": "QR-Code manuell einfügen / Scanner-Eingabe",
    "verify_btn": "Prüfen",
    "verification_failed_title": "Verifikation Abgewiesen",
    "redeem_success_title": "Angebot erfolgreich eingelöst!",
    "verified_badge": "PASS VERIFIZIERT • ZEITSTEMPEL GÜLTIG",
    "scan_next": "Nächsten Kunden scannen",
    "offers_evaluation_title": "Verfügbare Angebote & Boni",
    "redeem_button": "Einlösen",
    "standby_title": "Warte auf Scan-Vorgang",
    "camera_active": "OPTISCHER KAMERA-SCANNER",
    "camera_paused": "SCANNER PAUSIERT",
    "camera_loading": "Kamera wird initialisiert …",
    "camera_permission_denied": "Kamera-Zugriff verweigert oder nicht verfügbar. Bitte erlaube den Kamera-Zugriff im Browser.",
    "camera_start_btn": "Kamera aktivieren",
    "camera_start_prompt": "Scanner antippen, um die Kamera zu starten",
    "camera_stop_btn": "Kamera pausieren",
    "camera_switch_btn": "Kamera wechseln"
  },
  "qr_pass": {
    "title": "Dynamischer Ausweis-QR-Code",
    "signed_badge": "Signiert (HMAC-SHA256)",
    "validity_label": "Pass-Gültigkeit",
    "security_hint": "Kryptographisch mit Zeitstempel gesichert gegen Weitergabe & Bildschirmfotos. Partnerbetriebe scannen diesen Code für Vor-Ort-Boni.",
    "refresh_btn": "Code erneuern",
    "copy_token": "QR-Code kopieren",
    "copied": "Kopiert!",
    "click_to_enlarge": "Klicken zum Vergrößern",
    "enlarge_btn": "Vergrößern",
    "refresh": "QR-Code aktualisieren",
    "enlarge": "Grossansicht",
    "valid_until": "Gültig für",
    "anti_tamper": "HMAC Signatur verifiziert",
    "close": "Schließen",
    "loading": "Ausweis wird geladen …",
    "unavailable": "Kein gültiger QR-Ausweis verfügbar.",
    "retry": "Erneut laden"
  },
  "profile_v2": {
    "loading": "Profil wird geladen …",
    "load_error": "Profil konnte nicht geladen werden.",
    "show_qr": "QR-Pass zeigen",
    "days_active": "Tage aktiv",
    "confirmed_days": "Tage mit bestätigten guten Taten",
    "public_profile": "Öffentliches Profil",
    "bio": "Bio",
    "save": "Speichern",
    "saved": "Profil gespeichert.",
    "save_error": "Profil konnte nicht gespeichert werden.",
    "messages": "Nachrichten",
    "notifications": "Benachrichtigungen",
    "language": "Sprache",
    "theme": "Design",
    "dark": "Dunkel",
    "light": "Hell",
    "moderator_prompt": "Warum möchtest du moderieren?",
    "moderator_sent": "Bewerbung eingereicht.",
    "moderator_error": "Bewerbung konnte nicht eingereicht werden.",
    "apply": "Bewerben",
    "redemptions": "Eingelöste Partnerangebote",
    "no_redemptions": "Noch keine Angebote eingelöst.",
    "data_rights": "Datenschutz",
    "data_rights_help": "Lade eine maschinenlesbare Kopie deiner Daten herunter oder anonymisiere dein Konto. Nach der Anonymisierung ist keine Anmeldung mehr möglich; zwingend aufzubewahrende Prüf- und Sicherheitsprotokolle bleiben ohne deine Kontaktdaten bestehen.",
    "export": "Daten exportieren",
    "export_error": "Datenexport fehlgeschlagen.",
    "delete": "Konto anonymisieren",
    "delete_phrase_prompt": "Gib zur Bestätigung LÖSCHEN ein.",
    "delete_phrase": "LÖSCHEN",
    "delete_phrase_wrong": "Bestätigung stimmt nicht überein.",
    "delete_error": "Das Konto konnte nicht anonymisiert werden.",
    "change_password": "Passwort ändern",
    "current_password": "Aktuelles Passwort",
    "new_password": "Neues Passwort",
    "confirm_password": "Neues Passwort bestätigen",
    "password_changed": "Passwort erfolgreich geändert.",
    "password_mismatch": "Die neuen Passwörter stimmen nicht überein.",
    "password_min_length": "Das neue Passwort muss mindestens 8 Zeichen lang sein.",
    "password_change_error": "Passwort konnte nicht geändert werden."
  },
  "map_v2": {
    "legend": "Weltkarte",
    "partners": "Partnerangebote",
    "guild_members": "{{count}} Mitglieder",
    "partner_category": "Partner · {{category}}"
  },
  "chats_v2": {
    "permission_label": "Wer darf mir Nachrichten schreiben?",
    "permission_everyone": "Alle",
    "permission_nobody": "Niemand",
    "open_profile": "Öffentliches Profil von {{name}} öffnen",
    "title": "Direktnachrichten",
    "empty": "Noch keine Direktnachrichten.",
    "start": "Schreibe die erste Nachricht.",
    "you": "Du",
    "message": "Nachricht schreiben …",
    "select": "Wähle eine Unterhaltung aus.",
    "load_error": "Nachrichten konnten nicht geladen werden.",
    "send_error": "Nachricht konnte nicht gesendet werden."
  },
  "game_mechanics": {
    "title": "So funktioniert Goodvale",
    "decision": {
      "title": "Entscheidungsregel",
      "text": "Alle erforderlichen Stimmen werden abgewartet; danach entscheidet die Mehrheit. Bei genau einer erforderlichen Prüfung genügt eine Ablehnung. Ein 1:1 bei zwei Prüfungen löst automatisch eine dritte Stichprüfung aus. Die einreichende Person sieht keine Einzelstimmen, sondern nur den laufenden und den endgültigen Status."
    },
    "groups": {
      "title": "Gruppenaktionen"
    },
    "privacy": {
      "title": "Beweise und Einspruch",
      "text": "Beweise werden verschlüsselt gespeichert, nur der einreichenden Person, zugewiesenen Prüfenden und Admins zugänglich gemacht, protokolliert und nach der Aufbewahrungsfrist gelöscht. Gegen eine Ablehnung kann innerhalb der eingestellten Frist Einspruch erhoben werden; eine angenommene Beschwerde startet eine unabhängige neue Prüfrunde."
    },
    "removed": {
      "title": "Bewusst nicht Teil des Modells"
    },
    "ai_abuse": {
      "title": "Fairplay und KI-Missbrauch"
    },
    "karma": {
      "kicker": "VERTRAUEN UND FOLGEN",
      "neutral": {
        "range": "0 bis {{maximum}}",
        "text": "Partnervorteile bleiben verfügbar, sofern die übrigen Anforderungen des Angebots erfüllt sind."
      },
      "partner": {
        "range": "{{partner}} bis {{partnerEnd}}",
        "title": "Partnervorteile gesperrt",
        "text": "Rabatte und Angebote von Partnern können nicht genutzt werden."
      },
      "xp": {
        "range": "{{xp}} bis {{xpEnd}}"
      },
      "tribunal": {
        "range": "Ab {{tribunalLoss}}"
      },
      "suspension": {
        "range": "{{suspension}} bis {{minimum}}",
        "title": "Temporäre Kontosperre"
      }
    },
    "hero_title": "So funktioniert <emphasis>Goodvale</emphasis>",
    "flow_title": "Der Weg einer guten Tat",
    "start_title": "Bereit für deine erste gute Tat?",
    "flow_description": "Vom freiwilligen Einsatz bis zur verifizierten Belohnung: Das System ist unabhängig, manipulationssicher und transparent.",
    "flow_kicker": "KLARE ABLÄUFE",
    "principles_kicker": "REGELWERK & GEMEINSCHAFT",
    "start_kicker": "DEIN ABENTEUER WARTET"
  },
  "player_progress": {
    "level_progress": "Level-Fortschritt",
    "max_short": "Max",
    "max_level_reached": "Maximallevel erreicht",
    "open_statistics": "Level-Statistik öffnen"
  },
  "level_statistics": {
    "title": "Level-Statistik",
    "subtitle_short": "Dein Fortschritt auf einen Blick",
    "back": "Zur Übersicht",
    "loading": "Level-Statistik wird geladen …",
    "error": "Deine Level-Statistik konnte nicht geladen werden.",
    "retry": "Erneut versuchen",
    "current_level": "Aktuelles Level",
    "total_xp": "Erfahrung insgesamt",
    "approved_deeds": "Bestätigte gute Taten",
    "next_level_title": "Fortschritt zum nächsten Level",
    "progress_title": "Fortschritt über die Zeit",
    "chart_caption": "Durch bestätigte gute Taten verdiente Erfahrung je Monat",
    "chart_aria": "Monatlich verdiente Erfahrung der letzten zwölf Monate"
  },
  "slotsPage": {
    "goodContactsReady": "Gute Kontakte verfügbar – unter Meine Slots einsetzbar",
    "skipCooldown": "Mit Guten Kontakten freigeben",
    "cooldownFrom": "Wartezeit von:",
    "untitledAction": "Gute Tat",
    "skippingCooldown": "Slot wird freigegeben …",
    "skipUsed": "Gute Kontakte diese Woche verbraucht",
    "slotReleased": "Slot freigegeben!",
    "overview": "Dein Überblick",
    "title": "Meine Slots",
    "subtitle": "Deine offenen Einreichungen und die nächste verfügbare gute Tat.",
    "openSubmissions": "Deine Slots",
    "slot": "Slot {{number}}",
    "free": "Frei",
    "createSubmission": "Gute Tat einreichen",
    "tapToStart": "Slot nutzen",
    "submittedAt": "Eingereicht am",
    "viewSubmission": "Einreichung ansehen",
    "groupActive": "Gruppenquest aktiv",
    "cooldown": "Wartezeit",
    "freeAfterCooldown": "Danach ist dieser Slot wieder frei.",
    "groupCooldown": "Gruppen-Wartezeit",
    "registeredAt": "Angemeldet am",
    "viewGroup": "Gruppenquest ansehen"
  },
  "dashboard_v2": {
    "back": "Dashboard",
    "ready": "Bereit",
    "countdown_days": "{{days}}T {{hours}}Std",
    "day_short": "T",
    "start_action": "Gute Tat starten",
    "experience": "Erfahrung",
    "next_action_in": "Nächste gute Tat",
    "action_slots": "Slots",
    "slots_free": "{{count}} frei",
    "slots_full": "Alle Slots belegt",
    "approved_count": "{{count}} bestätigte gute Taten",
    "categories_specialization": "Kategorien & Spezialisierung",
    "show_more": "Mehr anzeigen",
    "show_less": "Weniger anzeigen",
    "all_categories": "Alle Kategorien",
    "talent_stage": "Stufe {{rank}}",
    "level_short": "Lv.",
    "experience_value": "{{value}} Erfahrung",
    "until_level": "{{value}} bis Level {{level}}",
    "level_value": "Lv. {{level}}",
    "change_avatar": "Profilbild ändern",
    "profile_picture_alt": "Profilbild von {{name}}",
    "change_banner": "Eigenes Banner hochladen",
    "upload_error": "Das Bild konnte nicht gespeichert werden.",
    "action_panel_title": "Deine nächste gute Tat",
    "action_cta_title": "Bereit, etwas zu bewegen?",
    "action_cta_text": "Dokumentiere eine freiwillige gute Tat und reiche einen nachvollziehbaren Beleg zur unabhängigen Prüfung ein.",
    "class_quotes": {
      "SCOUT": "Der Horizont gehört denen, die aufbrechen.",
      "MEDIC": "Wo Hoffnung lebt, beginnt Heilung.",
      "SOCIAL": "Eine Geschichte verbindet mehr als tausend Wege.",
      "TANK": "Stärke wächst mit jeder Wiederholung.",
      "ENVIRONMENT": "Wer der Natur zuhört, findet seinen Weg.",
      "TECH": "Wissen öffnet Türen, die Kraft nicht bewegen kann.",
      "CRAFTER": "Großes entsteht aus Geduld, Feuer und Handwerk.",
      "NUTRITION": "Jede Entdeckung beginnt mit einer guten Mischung.",
      "LOGISTICS": "Der kürzeste Weg ist der, den niemand übersieht.",
      "GUARDIAN": "Ehre zeigt sich dort, wo Schutz gebraucht wird."
    },
    "welcome": "Willkommen, {{name}}",
    "submit_action": "Gute Tat einreichen",
    "quick_submission": "Schnell Einreichung",
    "quick_actions": "Schnellzugriff",
    "level": "Level",
    "approved": "Bestätigt",
    "pending": "In Prüfung",
    "category_progress": "Kategorie-Fortschritt",
    "category_level": "Level {{level}}",
    "no_category_progress": "Noch kein Kategorie-Fortschritt. Deine erste bestätigte gute Tat startet ihn.",
    "recent_actions": "Letzte gute Taten",
    "latest_action": "Letzte gute Tat",
    "show_all": "Alle anzeigen",
    "no_actions": "Du hast noch keine gute Tat eingereicht.",
    "active_events": "Aktive Systemaktionen",
    "rules_title": "Fair & freiwillig",
    "rules_text": "Belohnt werden eigener Aufwand und nachvollziehbare Wirkung. Keine gefährlichen Tätigkeiten, kein Geld- oder Warenwert und keine verdeckten Partneraufträge.",
    "read_faq": "Regeln und Datenschutz lesen",
    "apply_moderator": "Als Moderator bewerben",
    "moderator_sent": "Deine Moderatorbewerbung wurde eingereicht.",
    "moderator_error": "Die Bewerbung konnte nicht eingereicht werden.",
    "load_error": "Das Dashboard konnte nicht geladen werden.",
    "status_Approved": "Bestätigt",
    "status_Rejected": "Abgelehnt",
    "status_AwaitingEvidence": "Beweis fehlt"
  },
  "partner_offers": {
    "title": "Partnerangebote",
    "backend_restart_required": "Reaktivieren ist erst nach einem Neustart des Backend-Servers verfügbar.",
    "redeemable_at": "Einlösbar bei",
    "redeemable_at_placeholder": "z. B. im Geschäft an der Kasse",
    "redemption_time": "Einlösezeiten",
    "redemption_time_placeholder": "z. B. Mo–Fr, 9–18 Uhr",
    "offer": "Angebot",
    "not_found": "Angebot nicht gefunden.",
    "location_invalid": "Ungültige Koordinaten eingegeben.",
    "redemption_channel_title": "Einlöseart / Kanal *",
    "type_onsite": "Vor Ort",
    "type_digital": "Digital / Online",
    "type_both": "Vor Ort & Digital",
    "freq_daily": "1x täglich",
    "freq_weekly": "1x pro Kalenderwoche",
    "freq_monthly": "1x pro Kalendermonat",
    "freq_quarterly": "1x pro Quartal",
    "freq_yearly": "1x pro Jahr",
    "freq_every_x_days": "Alle {{days}} Tage",
    "freq_interval": "Nach Zeitintervall",
    "freq_unlimited": "Beliebig oft einlösbar",
    "valid_from": "Ab {{date}}",
    "valid_until": "Bis {{date}}",
    "always_valid": "Dauerhaft aktiv",
    "new_offer_btn": "Neues Angebot erstellen",
    "empty_title": "Noch keine Angebote definiert",
    "edit": "Bearbeiten",
    "edit_title": "Angebot bearbeiten",
    "delete": "Löschen",
    "confirm_delete": "Möchtest du dieses Angebot wirklich entfernen?",
    "modal_title": "Neues Angebot erstellen",
    "form_title": "Titel des Angebots",
    "form_desc": "Beschreibung",
    "location_title": "Angebotsstandort *",
    "location_help": "Dieser Standort wird als Partnerangebot auf der Karte angezeigt.",
    "use_location": "Aktuellen Standort verwenden",
    "form_latitude": "Breitengrad",
    "form_longitude": "Längengrad",
    "location_required": "Bitte gib einen gültigen Angebotsstandort an.",
    "location_error": "Der aktuelle Standort konnte nicht ermittelt werden.",
    "map_location": "Auf der Karte sichtbar",
    "form_discount": "Rabatt in %",
    "use_partner_location": "Partner-Standort übernehmen",
    "partner_has_no_coords": "Im Partnerprofil ist noch kein Standardstandort hinterlegt.",
    "back_to_offers": "Zurück zur Übersicht",
    "save": "Speichern",
    "saving": "Speichert …",
    "cancel": "Abbrechen",
    "validation_required": "Bitte Titel, Einlösebedingungen und die Verantwortungsbestätigung ausfüllen.",
    "form_category": "Kategorie",
    "form_category_level": "Kategorie-Level",
    "form_achievement": "Bestätigte gute Tat",
    "form_type": "Typ",
    "type_discount": "Prozent-Rabatt",
    "type_goodie": "Gratis-Zugabe",
    "type_service": "Dienstleistung",
    "type_voucher": "Gutschein",
    "requirements_title": "Freischaltbedingungen",
    "requirements_help": "Alle gesetzten Bedingungen müssen erfüllt sein. Leere Felder werden nicht geprüft.",
    "limits_title": "Einlöselimits",
    "form_frequency": "Häufigkeit",
    "form_interval": "Abstand in Tagen",
    "form_max_user": "Maximum pro Person",
    "form_max_total": "Gesamtkontingent",
    "frequency_Unlimited": "Unbegrenzt",
    "frequency_OnceEver": "Einmalig",
    "frequency_OncePerDay": "Einmal täglich",
    "frequency_OncePerWeek": "Einmal wöchentlich",
    "frequency_OncePerMonth": "Einmal monatlich",
    "frequency_OncePerYear": "Einmal jährlich",
    "frequency_EveryXDays": "Alle X Tage",
    "none": "Keine",
    "req_achievement": "Gute Tat: {{title}}",
    "load_error": "Angebote konnten nicht geladen werden.",
    "save_error": "Angebot konnte nicht gespeichert werden.",
    "delete_error": "Angebot konnte nicht gelöscht werden."
  },
  "errors": {
    "multitasking_notice": " + Multitasking"
  },
  "error": {
    "title": "Systemfehler",
    "reload": "App neu laden"
  },
  "register": {
    "legal_required": "Bitte bestätige Volljährigkeit und Nutzungsbedingungen.",
    "legal_accept": "Ich bin mindestens 18 Jahre alt und akzeptiere die Nutzungsbedingungen.",
    "legal_terms": "Nutzungsbedingungen",
    "eyebrow": "Werde Teil der Welt",
    "field_business_bio": "Unternehmensbeschreibung (optional)",
    "field_location": "Standort",
    "required_mark": "Pflichtfeld",
    "field_business_bio_placeholder": "Beschreibe kurz deinen Betrieb, dein Angebot und deine Mission...",
    "title": "Goodvale",
    "subtitle": "Registrierung",
    "role_adventurer_sub": "Spielkonto",
    "role_partner_sub": "Unternehmen",
    "field_username": "Benutzername",
    "field_email": "E-Mail Adresse",
    "field_password": "Passwort",
    "field_required": "ist erforderlich.",
    "classesTitle": "Wähle deinen Weg",
    "field_business_name": "Unternehmensname",
    "field_category": "Branche / Kategorie",
    "field_tax_id": "UID / Steuernummer",
    "btn_create": "Konto Erstellen",
    "btn_apply": "Konto beantragen (Admin Review)",
    "btn_loading": "Registrierung läuft...",
    "review_notice": "Um die Sicherheit unseres Ökosystems zu gewährleisten, können Partnerkonten nicht automatisch erstellt werden. Dein Antrag wird nach dem Absenden manuell vom",
    "review_notice_bold": "System-Admin",
    "review_notice_end": "geprüft und freigeschaltet.",
    "success_adventurer": "Konto erstellt! Du kannst dich jetzt einloggen.",
    "success_partner": "Antrag gestellt! Der System-Admin wird deinen Account freischalten.",
    "success_login_link": "Jetzt anmelden",
    "already_registered": "Bereits registriert?",
    "login_link": "Hier anmelden",
    "classes_retry": "Erneut laden"
  },
  "login": {
    "title": "Goodvale",
    "emailLabel": "E-Mail Adresse",
    "passwordLabel": "Passwort",
    "forgotPasswordLink": "Passwort vergessen?",
    "submit": "Anmelden",
    "loading": "Anmelden…",
    "noAccount": "Noch kein Konto?",
    "registerLink": "Jetzt registrieren",
    "error": {
      "pendingApproval": "Konto wartet auf Freischaltung durch den System-Admin.",
      "generic": "Ein Fehler ist aufgetreten. Bitte überprüfe deine Anmeldedaten."
    }
  },
  "forgotPassword": {
    "eyebrow": "Konto-Wiederherstellung",
    "title": "Passwort zurücksetzen",
    "subtitle": "Gib deine E-Mail-Adresse ein, um einen Reset-Link zu erhalten.",
    "emailLabel": "E-Mail Adresse",
    "emailRequired": "Bitte gib deine E-Mail-Adresse ein.",
    "submit": "Reset-Link anfordern",
    "loading": "Wird gesendet…",
    "backToLogin": "Zurück zur Anmeldung",
    "successTitle": "Anfrage gesendet",
    "successMessage": "Falls ein Konto mit dieser E-Mail-Adresse existiert, wurde eine Anleitung zum Zurücksetzen generiert."
  },
  "resetPassword": {
    "eyebrow": "Neues Passwort festlegen",
    "title": "Passwort ändern",
    "subtitle": "Gib dein neues Passwort ein, um deinen Zugang wiederherzustellen.",
    "newPasswordLabel": "Neues Passwort",
    "confirmPasswordLabel": "Passwort bestätigen",
    "missingToken": "Ungültiger oder fehlender Token. Bitte fordere einen neuen Link an.",
    "passwordRequired": "Bitte gib ein neues Passwort ein.",
    "passwordMinLength": "Das Passwort muss mindestens 8 Zeichen lang sein.",
    "passwordMismatch": "Die Passwörter stimmen nicht überein.",
    "submit": "Passwort speichern",
    "loading": "Wird gespeichert…",
    "successTitle": "Passwort aktualisiert",
    "successMessage": "Dein Passwort wurde erfolgreich geändert. Du kannst dich jetzt anmelden.",
    "loginNow": "Jetzt anmelden"
  },
  "public_profile": {
    "title": "Öffentliches Profil",
    "designations": "Bezeichnungen",
    "load_error": "Profil konnte nicht geladen werden.",
    "no_bio_short": "Keine Beschreibung hinterlegt",
    "heroic_actions_approved": "Bestätigt",
    "heroic_actions_submitted": "Eingereicht",
    "close": "Schließen",
    "level": "Lvl {{level}}",
    "member_since": "Mitglied seit: {{date}}",
    "community": "In der Gemeinschaft",
    "admin_tools": "Verwaltung · Nur für berechtigte Admins",
    "view": "Profil ansehen",
    "retry": "Erneut versuchen",
    "loading": "Profil wird geladen …"
  },
  "location_picker": {
    "title": "Standort auf der Karte wählen *",
    "required": "Bitte wähle einen Standort auf der Karte.",
    "locate": "Karte zu meinem Standort bewegen",
    "failed": "Standort nicht verfügbar. Bewege die Karte zum gewünschten Ort.",
    "center": "Kartenmitte als Standort auswählen",
    "selected": "Ausgewählter Standort",
    "loading": "Standort wird gesucht …"
  },
  "admin_partners": {
    "nav_title": "Partner & Anfragen",
    "title": "Partner & Partneranfragen",
    "subtitle": "Prüfe neue Partnerregistrierungen und verwalte bestehende Partnerbetriebe.",
    "refresh": "Aktualisieren",
    "loading": "Partneranfragen werden geladen …",
    "empty": "Keine offenen Partneranfragen.",
    "username": "Benutzername",
    "email": "E-Mail",
    "category": "Kategorie",
    "vatId": "Umsatzsteuer-ID",
    "created": "Registriert am",
    "approve": "Freigeben",
    "reject": "Ablehnen und löschen",
    "processing": "Anfrage wird bearbeitet …",
    "reject_confirm": "Partneranfrage von {{name}} ablehnen? Das Partnerprofil und das zugehörige Benutzerkonto werden dabei endgültig gelöscht.",
    "approved": "{{name}} wurde als Partner freigeschaltet.",
    "rejected": "Die Registrierung von {{name}} wurde abgelehnt und gelöscht."
  },
  "admin_nav": {
    "dashboard": "Dashboard & Übersicht",
    "settings": "System-Einstellungen",
    "events": "Events",
    "appeals": "Einsprüche",
    "profile": "Mein Profil",
    "logout": "Abmelden"
  },
  "xp_audit": {
    "status": "Status",
    "pending": "Offen",
    "approved": "Freigegeben",
    "rejected": "Abgelehnt",
    "all": "Alle",
    "empty": "Keine Prüffälle vorhanden.",
    "detail": "Prüffall",
    "threshold": "Schwelle",
    "held_awards": "Zurückgehaltene Belohnungen",
    "reason": "Begründung",
    "reason_required": "Bitte eine Begründung mit mindestens drei Zeichen eingeben.",
    "close": "Schließen",
    "previous": "Zurück",
    "next": "Weiter",
    "decision_error": "Die Entscheidung konnte nicht gespeichert werden."
  },
  "admin_tribunal_moderators": {
    "tab_applications": "Offene Bewerbungen",
    "tab_moderators": "Aktive Moderatoren",
    "no_applications": "Keine offenen Bewerbungen vorhanden.",
    "search_placeholder": "Moderatoren nach Name oder E-Mail filtern...",
    "reviews_count": "{{count}} Prüfungen durchgeführt",
    "joined": "Dabei seit {{date}}",
    "motivation_label": "Bewerbungsmotivation",
    "no_motivation": "Keine Begründung angegeben.",
    "approve_btn": "Bewerbung annehmen",
    "reject_btn": "Bewerbung ablehnen",
    "revoke_btn": "Status entfernen",
    "revoke_confirm_title": "Moderator-Status entziehen?",
    "revoke_reason_placeholder": "Grund für den Entzug (optional)...",
    "approve_prompt": "Begründung für die Annahme (optional):",
    "reject_prompt": "Begründung für die Ablehnung:",
    "approved_success": "Bewerbung von {{name}} wurde angenommen. Moderator-Status wurde vergeben.",
    "rejected_success": "Bewerbung von {{name}} wurde abgelehnt.",
    "revoked_success": "Moderator-Status von {{name}} wurde erfolgreich entzogen.",
    "view_profile": "Profil"
  },
  "admin_karma": {
    "load_error": "Fehler beim Laden der Benutzer.",
    "pagination": "Seite {{page}} von {{total}}",
    "point_count": "{{count}} Punkte",
    "negative_points": "−{{count}} Punkte",
    "positive_points": "+{{count}} Punkte",
    "status_label": "Status",
    "no_reason": "Keine Begründung",
    "system_actor": "System",
    "pending_empty": "Keine ausstehenden Anfragen.",
    "approve_penalty": "Bestätigen",
    "reject_penalty": "Ablehnen",
    "subtitle": "Systemweites Reputations- und Vertrauensmanagement. Punktestand ({{minimum}} bis {{maximum}}), Schwellenwerte und Sanktionen.",
    "search_placeholder": "Benutzer nach Name oder E-Mail suchen...",
    "filter_all": "Alle Konten",
    "filter_trusty": "Vertrauenswürdig (> 0)",
    "filter_neutral": "Neutral (0)",
    "filter_negative": "Negativ (< 0)",
    "filter_banned": "Gesperrt",
    "user_details": "Benutzerdetails",
    "current_score": "Aktueller Punktestand",
    "tier_trusty": "Vertrauenswürdig",
    "tier_honorable": "Verlässlich",
    "tier_trusted": "Vertrauensvoll",
    "tier_very_trusted": "Hoffnungsträger",
    "tier_exemplary": "Vertrauensanker",
    "tier_neutral": "Neutral",
    "tier_warning": "Partnervorteile gesperrt",
    "tier_restricted": "Temporäre Sperre (≤ {{suspension}})",
    "tier_released": "Sperre abgelaufen; Partner gesperrt",
    "tier_banned": "Account gesperrt",
    "points_label": "Punkte (1–100)",
    "reason_label": "Begründung (Pflichtangabe, mind. 5 Zeichen)",
    "reason_placeholder_deduct": "z. B. Verstoß gegen Ehrenkodex, gefälschte Nachweise, unsportliches Verhalten...",
    "reason_placeholder_award": "z. B. Besondere Verdienste für die Community, Kulanz, Regelkorrektur...",
    "history_actor": "Durchgeführt von",
    "history_delta": "Änderung",
    "history_score": "Neuer Stand",
    "history_reason": "Begründung",
    "view_profile": "Öffentliches Profil ansehen",
    "close": "Schließen",
    "rules_range": "Spanne von {{minimum}} bis {{maximum}} Punkten"
  },
  "admin_settings": {
    "title": "System-Einstellungen",
    "subtitle": "Globale Spielregeln, Raten & Modifikatoren — flexibel konfigurierbar ohne Codeänderung.",
    "search_placeholder": "Einstellungen nach Schlüssel, Name oder Beschreibung filtern...",
    "filter_all": "Alle Einstellungen",
    "filter_custom": "Sonstige & Eigene",
    "add_setting_btn": "Neue Einstellung hinzufügen",
    "add_modal_title": "Neue System-Einstellung erstellen",
    "add_modal_desc": "Definiere einen neuen Konfigurationsschlüssel, der systemweit im Backend und Gameplay ausgewertet werden kann.",
    "key_label": "Schlüssel (Key)",
    "key_placeholder": "z. B. HeroicActionDailyLimit",
    "value_label": "Wert (Value)",
    "value_placeholder": "z.B. 1.25",
    "description_label": "Beschreibung (Zweck & Auswirkung)",
    "description_placeholder": "z. B. Mindestabstand zwischen zwei guten Taten",
    "btn_create": "Einstellung anlegen",
    "btn_cancel": "Abbrechen",
    "btn_save": "Speichern",
    "btn_save_all": "Alle Änderungen speichern ({{count}})",
    "btn_revert": "Verwerfen",
    "btn_delete": "Löschen",
    "delete_confirm": "Möchtest du die Einstellung '{{key}}' wirklich löschen?",
    "status_saving": "Speichert...",
    "status_saved": "Gespeichert",
    "table_header_key": "Einstellung / Schlüssel",
    "table_header_description": "Beschreibung & Zweck",
    "table_header_value": "Aktueller Wert",
    "table_header_actions": "Aktionen",
    "empty_search_title": "Keine passenden Einstellungen gefunden",
    "empty_search_desc": "Keine System-Einstellung entspricht deinen aktuellen Such- oder Filterkriterien.",
    "empty_reset_filter": "Filter zurücksetzen",
    "toast_save_success": "Einstellung '{{key}}' erfolgreich gespeichert.",
    "toast_save_all_success": "{{count}} Einstellungen erfolgreich aktualisiert.",
    "toast_create_success": "Neue System-Einstellung '{{key}}' erfolgreich angelegt.",
    "toast_delete_success": "Einstellung '{{key}}' erfolgreich entfernt.",
    "toast_error": "Fehler beim Ausführen der Aktion.",
    "badge_modified": "Geändert",
    "total_count": "{{count}} Einstellungen gesamt",
    "modified_count": "{{count}} ungespeichert",
    "quick_stats_total": "Gesamt",
    "quick_stats_modified": "Modifiziert"
  },
  "admin_events": {
    "title": "Events",
    "subtitle": "Steuerung der globalen Events zur Aktivierung der Community.",
    "create_btn": "Neues Event",
    "form_title": "Titel",
    "form_title_placeholder": "z.B. Woche des Waldes",
    "form_description": "Beschreibung",
    "form_description_placeholder": "Was bewirkt dieses Event?",
    "form_start": "Startdatum",
    "form_end": "Enddatum",
    "form_category": "Gute-Taten-Kategorie",
    "category_all": "Alle Kategorien",
    "form_is_recurring": "Wiederkehrend wöchentlich",
    "badge_recurring": "Wiederkehrend",
    "timeframe": "Zeitraum",
    "submit": "Event erstellen",
    "submitting": "Wird erstellt...",
    "update": "Änderungen speichern",
    "updating": "Wird gespeichert...",
    "cancel": "Abbrechen",
    "edit": "Bearbeiten",
    "delete": "Löschen",
    "delete_confirm": "Event löschen?",
    "delete_confirm_text": "Möchtest du dieses Event wirklich unwiderruflich löschen?",
    "delete_yes": "Ja, löschen",
    "badge_live": "Live",
    "badge_ended": "Beendet",
    "badge_upcoming": "Geplant",
    "ends_at": "Endet:",
    "starts_at": "Startet:",
    "empty": "Noch keine Events erstellt.",
    "load_error": "Events konnten nicht geladen werden.",
    "create_success": "Event erfolgreich erstellt!",
    "update_success": "Event erfolgreich aktualisiert!",
    "create_error": "Fehler beim Erstellen des Events.",
    "delete_success": "Event erfolgreich gelöscht.",
    "global_impact_title": "Globaler Impact",
    "global_impact_desc": "Events überschreiben temporär die System-Multiplikatoren für alle Spieler weltweit. Sie sind das mächtigste Werkzeug des Guild Masters, um gezielt Freiwillige in bestimmte Sektoren zu lenken."
  },
  "access": {
    "unauthorized_title": "Zugriff verweigert",
    "unauthorized_msg": "Du hast keine Berechtigung, diese Seite aufzurufen.",
    "unauthorized_required_role": "Benötigte Rolle: {{role}}",
    "unauthorized_back_login": "Zur Anmeldung",
    "not_logged_in_title": "Nicht angemeldet",
    "not_logged_in_msg": "Bitte melde dich an, um auf diesen Bereich zuzugreifen.",
    "role_systemadmin": "System-Admin",
    "role_partner": "Partner"
  },
  "nav_cross": {
    "goto_system_admin": "System-Admin Konsole"
  },
  "guild": {
    "apply_success": "Beitrittsanfrage erfolgreich übermittelt!",
    "load_more_news": "Ältere Aushänge laden",
    "load_older_messages": "Ältere Nachrichten laden",
    "loading_more": "Wird geladen…",
    "news_load_error": "Weitere Aushänge konnten nicht geladen werden.",
    "apply": "Beitrittsanfrage stellen",
    "applying": "Wird übermittelt …",
    "successor_title": "Nachfolger ernennen",
    "successor_select": "Nachfolger auswählen:",
    "successor_placeholder": "-- Wähle ein Mitglied --",
    "successor_submit": "Nachfolger ernennen & austreten",
    "successor_submitting": "Ernennen & Austreten...",
    "leave_error": "Austritt fehlgeschlagen.",
    "leaving": "Wird verlassen …",
    "detail_subtitle": "Gemeinsam mehr bewirken.",
    "unknown": "Unbekannt",
    "insert_emote": "Emote einfügen",
    "create_news_btn": "Neuer Aushang",
    "news_field_title": "Titel des Aushangs",
    "news_category": "Kategorie",
    "news_category_announcement": "Ankündigung",
    "news_category_event": "Event",
    "news_category_system": "System",
    "news_content": "Inhalt und Details",
    "news_pin": "Aushang oben anpinnen",
    "news_publish": "Veröffentlichen",
    "news_publish_success": "Aushang erfolgreich in Neuigkeiten veröffentlicht.",
    "news_publish_error": "Aushang konnte nicht erstellt werden.",
    "news_written_by": "Verfasst von:",
    "news_delete": "Aushang entfernen",
    "news_delete_success": "Aushang wurde entfernt.",
    "news_delete_error": "Aushang konnte nicht gelöscht werden.",
    "news_pinned": "Angepinnt",
    "no_news": "Noch keine Neuigkeiten vorhanden.",
    "view_member_profile": "Profil ansehen",
    "chat_member": "Chatten",
    "chat_with_member": "Mit {{name}} chatten",
    "open_chats": "Chats öffnen",
    "chat_live": "Live-Funk",
    "chat_for": "Mitglieder-Stammtisch von {{name}}",
    "chat_loading": "Stammtisch wird geladen …",
    "chat_empty": "Noch keine Gespräche am Stammtisch",
    "chat_placeholder": "Nachricht am Stammtisch teilen …",
    "chat_send": "Senden",
    "exclusive_emotes_active": "Stammtisch Plus aktiv",
    "chat_pinned": "Angeheftet",
    "chat_pin": "Nachricht anheften",
    "chat_unpin": "Anheftung entfernen",
    "chat_poll": "Umfrage",
    "chat_react": "Auf Nachricht reagieren",
    "chat_create_poll": "Umfrage erstellen",
    "chat_poll_option": "Option {{number}}",
    "chat_add_option": "Option hinzufügen",
    "chat_remove_option": "Letzte Option entfernen",
    "chat_post_poll": "Umfrage veröffentlichen",
    "emote_cat_all": "Alle",
    "emote_cat_combat": "Kampf",
    "emote_cat_magic": "Magie",
    "emote_cat_creatures": "Kreaturen",
    "emote_cat_mood": "Stimmung",
    "delete_news_confirm": "Möchtest du diesen Aushang wirklich entfernen?",
    "member_badge": "Mitglied",
    "member_profile": "Profil von {{name}} ansehen",
    "promote_admin_btn": "Admin",
    "promote_error": "Beförderung fehlgeschlagen."
  },
  "notifications": {
    "title": "Benachrichtigungen",
    "subtitle": "Verwalte deine In-App- und Push-Benachrichtigungen.",
    "mark_all_read": "Alle als gelesen markieren",
    "mark_as_read": "Gelesen markieren",
    "empty": "Keine neuen Benachrichtigungen",
    "empty_state": "Keine Benachrichtigungen vorhanden.",
    "view_all": "Alle anzeigen",
    "btn_read_all": "Alle gelesen",
    "btn_enable_push": "Push aktivieren",
    "btn_disable_push": "Push abmelden",
    "push_active": "Push aktiv",
    "push": {
      "requesting": "Fordere Berechtigung an...",
      "unsupported": "Push-Benachrichtigungen werden von diesem Browser nicht unterstützt.",
      "success": "Erfolgreich abonniert!",
      "failed": "Abonnement fehlgeschlagen.",
      "unsubscribing": "Deaktiviere Push-Benachrichtigungen...",
      "unsubscribed": "Push-Benachrichtigungen erfolgreich abgemeldet.",
      "unsub_failed": "Abmeldung der Push-Benachrichtigungen fehlgeschlagen."
    },
    "heroic_action": {
      "approved_title": "Gute Tat verifiziert",
      "rejected_title": "Gute Tat abgelehnt",
      "rejected_message": "Deine gute Tat ‚{{title}}‘ wurde nicht freigegeben. {{reason}}",
      "returned_title": "Gute Tat zur Überarbeitung zurückgeschickt",
      "returned_message": "Deine gute Tat ‚{{title}}‘ wurde zurückgeschickt. Grund: {{reason}}",
      "review_assigned_message": "Die gute Tat ‚{{title}}‘ wurde dir unabhängig zur Prüfung zugewiesen.",
      "appeal_pending_title": "Neuer Gute-Taten-Einspruch",
      "appeal_pending_message": "{{username}} hat gegen die Entscheidung zu ‚{{title}}‘ Einspruch erhoben.",
      "appeal_approved_title": "Einspruch angenommen",
      "appeal_rejected_title": "Einspruch abgelehnt",
      "appeal_rejected_message": "Der Einspruch wurde abgelehnt. {{reason}}"
    },
    "group_action": {
      "invited_title": "Einladung zu einer Gruppenaktion",
      "announced_title": "Neue Gruppenaktion",
      "cancelled_title": "Gruppenaktion abgesagt",
      "cancelled_message": "‚{{title}}‘ wurde abgesagt.",
      "approved_title": "Gruppenaktion verifiziert",
      "rejected_title": "Gruppenaktion abgelehnt",
      "rejected_message": "‚{{title}}‘ wurde nicht freigegeben. {{reason}}",
      "appeal_approved_title": "Gruppen-Einspruch angenommen",
      "appeal_approved_message": "Die Gruppenaktion wird erneut unabhängig geprüft.",
      "appeal_rejected_title": "Gruppen-Einspruch abgelehnt",
      "appeal_rejected_message": "Der Einspruch wurde abgelehnt. {{reason}}"
    },
    "moderator_approved": {
      "title": "Moderator-Zugang freigeschaltet",
      "message": "Deine Bewerbung wurde angenommen. Du kannst nun zugewiesene gute Taten prüfen."
    },
    "moderator_rejected": {
      "title": "Moderator-Bewerbung abgelehnt",
      "message": "Deine Bewerbung wurde abgelehnt. Begründung: {{reason}}"
    },
    "guild_join_request": {
      "title": "Neue Beitrittsanfrage",
      "message": "{{username}} hat eine Beitrittsanfrage für '{{guildName}}' eingereicht."
    },
    "registration_request": {
      "title": "Neue Registrierungsanfrage",
      "message": "Neue Registrierungsanfrage von {{role}} '{{org}}' ({{username}}) ausstehend."
    },
    "direct_chat_new": {
      "title": "Neue Direktnachricht",
      "message": "{{sender}}: {{message}}"
    },
    "event_started": {
      "title": "Neues Event gestartet!",
      "message": "Das Event '{{title}}' hat begonnen! Sichere dir tolle Boni."
    }
  },
  "talents": {
    "branches_count": "3 Zweige",
    "subtitle": "Wähle Fähigkeiten, die zu deinen guten Taten passen.",
    "modal_subtitle": "Du erhältst einen Startpunkt auf Level 0 und danach alle 10 Level einen weiteren, höchstens 10 insgesamt. Jede Fähigkeit hat bis zu drei Stufen.",
    "level_badge": "Level {{level}}",
    "available_points": "Verfügbare Punkte:",
    "branches": {
      "A": {
        "title": "Pfad der Effizienz"
      },
      "B": {
        "title": "Pfad des Fortschritts"
      },
      "C": {
        "title": "Pfad der Ehre"
      }
    },
    "skills": {
      "A_CONCENTRATION": {
        "title": "Konzentration",
        "rank1_title": "Konzentration",
        "rank2_title": "Meditation",
        "rank3_title": "Zen-Fokus",
        "rank1_value": "−10 % Wartezeit",
        "rank2_value": "−20 % Wartezeit",
        "rank3_value": "−30 % Wartezeit",
        "rank1": "Stufe 1: Die Wartezeit bis zu deiner nächsten Einreichung sinkt um 10 %.",
        "rank2": "Stufe 2: Die Wartezeit bis zu deiner nächsten Einreichung sinkt um 20 %.",
        "rank3": "Stufe 3: Die Wartezeit bis zu deiner nächsten Einreichung sinkt um 30 %."
      },
      "A_MULTITASKING": {
        "title": "Multitasking",
        "rank1_title": "Multitasking",
        "rank2_title": "Second Brain",
        "rank3_title": "Paralleles Bewusstsein",
        "rank1_value": "+1 Platz",
        "rank2_value": "+2 Plätze",
        "rank3_value": "+3 Plätze",
        "rank1": "Stufe 1: Du kannst 1 weitere gute Tat gleichzeitig einreichen.",
        "rank2": "Stufe 2: Du kannst 2 weitere gute Taten gleichzeitig einreichen.",
        "rank3": "Stufe 3: Du kannst 3 weitere gute Taten gleichzeitig einreichen."
      },
      "A_HEROIC_ACTION_SPONSOR": {
        "rank1_title": "Förderer",
        "rank2_title": "Gönner",
        "rank3_title": "Großmäzen"
      },
      "B_TREASURE_HUNTER": {
        "title": "Erfahrungssammler",
        "rank1_title": "Erfahrungssammler",
        "rank2_title": "Fortschrittsjäger",
        "rank3_title": "Erfahrungsmeister"
      },
      "B_BARTERER": {
        "title": "Chancenfinder",
        "rank1_title": "Chancenfinder",
        "rank2_title": "Wertschöpfer",
        "rank3_title": "Meister der Chancen"
      },
      "B_VERIFIED_PROOF": {
        "title": "Gemeinsinn",
        "rank1_title": "Gemeinsinn",
        "rank2_title": "Vorbild",
        "rank3_title": "Leuchtendes Vorbild"
      },
      "C_RESILIENCE": {
        "title": "Reines Gewissen",
        "rank1_title": "Reines Gewissen",
        "rank2_title": "Seelenruhe",
        "rank3_title": "Unantastbare Ehre"
      },
      "C_GROUP_MENTOR": {
        "title": "Gruppen-Mentor",
        "rank1_title": "Gruppen-Mentor",
        "rank2_title": "Leitwolf"
      },
      "C_GUILD_BENEFACTOR": {
        "title": "Gemeinschaftsstifter",
        "rank1_title": "Gemeinschaftsstifter",
        "rank2_title": "Vertrauensanker",
        "rank3_title": "Ewiger Pfeiler"
      }
    },
    "stats": {
      "number_locale": "de-DE",
      "description": "Beschreibung",
      "base": "Basis",
      "passive": "Passiv",
      "outside_category": "außerhalb {{category}}",
      "in_category": "in {{category}}",
      "category_bonus": "Bonus in deiner Kategorie",
      "points_invested": "{{count}} Punkte investiert",
      "heading": "Eigenschaften & Attribute",
      "breakdown_hint": "(ⓘ bewegen für Aufschlüsselung)",
      "active_count": "{{active}} / {{total}} Aktiv",
      "efficiency_heading": "Effizienz & Slots",
      "experience_heading": "Erfahrung & Boni",
      "info_aria": "Info: {{label}}",
      "base_bonus": "0% Bonus",
      "cooldown": {
        "label": "Wartezeit",
        "description": "Nach einer Belohnung beginnt die Wartezeit für den belegten Slot. Bei aktiven Gruppenquests läuft sie bereits ab der Anmeldung. Rückzug oder Abbruch geben den Slot frei. Alle Boni zusammen können die Wartezeit um höchstens 80 % verkürzen.",
        "talent": "-{{percent}}% (max -30%)"
      },
      "slots": {
        "label": "Slots",
        "count_one": "{{count}} Slot",
        "count_other": "{{count}} Slots",
        "description": "So viele einzelne gute Taten und Gruppenaktionen kannst du gleichzeitig offen haben.",
        "talent_one": "+{{count}} Slot (max +3)",
        "talent_other": "+{{count}} Slots (max +3)",
        "class_effect": "+{{count}} Slot"
      },
      "xp_bonus": {
        "talent": "+{{percent}}% (max +15%)"
      },
      "cat_xp_bonus": {
        "talent": "+{{total}}% (allgemein +{{general}}%, Kategorie +{{category}}%; max +30%)"
      },
      "gildex": {
        "effective": "{{percent}}% effektiv",
        "base_value": "{{percent}}% Basis",
        "talent": "+{{percent}}% relativ (max +30%)",
        "class_effect": "{{percent}} relativ"
      },
      "karma_rec": {
        "up_to": "bis +{{value}}",
        "base": "0 zusätzliche Erholung"
      },
      "party_ep": {
        "base": "0% Gruppenbonus",
        "talent": "+{{percent}}% (max +15% pro Mitglied)"
      }
    },
    "ui": {
      "rank2_fallback": "Ausdauer",
      "rank3_fallback": "Gelassenheit",
      "rank_points_max": "{{points}} Pkt (Max)",
      "next_point_xp": "Nächster Punkt: Lv. {{level}}",
      "back_to_overview": "Zurück zur Übersicht",
      "pts_unit": "Pkt",
      "points_ready_tip": "Bereit zur Investition",
      "no_points_tip": "Nächster Punkt beim Level-Aufstieg",
      "spent_points": "Investiert",
      "active_buffs_active": "Aktive Boni",
      "current_level_label": "Stufe",
      "max_level_reached": "Maximalstufe erreicht",
      "three_pillars_sub": "Effizienz • Fortschritt • Ehre",
      "available_short": "verfügbar",
      "not_unlocked_yet": "Noch nicht erlernt. Schalte Stufe 1 frei, um diesen Bonus zu aktivieren.",
      "tier": "Pfadabschnitt {{tier}}",
      "rank_badge": "Stufe {{current}} / {{max}}",
      "max_rank_reached": "✓ Maximalstufe erreicht (3/3)",
      "upgrade_to_rank": "Auf Stufe {{rank}} verbessern (1 Punkt)",
      "unlock_rank_1": "Stufe 1 freischalten (1 Punkt)",
      "upgrading": "Wird aufgewertet...",
      "next_rank": "Nächste Stufe ({{rank}}/{{max}}): {{desc}}",
      "close": "Schließen",
      "branch_badge": "Zweig {{branch}}",
      "branch": "Zweig",
      "origin_subtitle": "Wähle einen der drei Pfade",
      "current_stage": "Aktuelle Stufe",
      "next_stage": "Nächste Stufe",
      "locked_stage": "Gesperrt",
      "active_rank": "Aktiv",
      "all_branches": "Alle Pfade"
    },
    "path_names": {
      "A": "Effizienz",
      "B": "Fortschritt",
      "C": "Ehre"
    },
    "tree": {
      "learned": "Erlernt",
      "available": "Freischaltbar",
      "locked": "Gesperrt",
      "requires_skill": "Zuerst {{name}} auf Stufe {{rank}} bringen"
    }
  },
  "categories": {
    "ECO_NATURE": "Umwelt & Natur",
    "CRAFTING_REPAIR": "Handwerk & Reparatur",
    "SOCIAL_COMMUNITY": "Soziales & Gemeinschaft"
  },
  "classes": {
    "roles": {
      "ENVIRONMENT": "Umwelt & Natur",
      "CRAFTER": "Handwerk & Reparatur",
      "GUARDIAN": "Soziales & Gemeinschaft"
    },
    "lines": {
      "SCOUT": "Hilfe, die Menschen in Bewegung bringt.",
      "MEDIC": "Fürsorge im Alltag.",
      "SOCIAL": "Gemeinschaft ermöglichen.",
      "TANK": "Anpacken, wenn Hilfe gebraucht wird.",
      "ENVIRONMENT": "Natur schützen und Orte pflegen.",
      "TECH": "Wissen teilen und Technik erklären.",
      "CRAFTER": "Reparieren statt wegwerfen.",
      "NUTRITION": "Mit Lebensmitteln helfen.",
      "LOGISTICS": "Hilfe gut organisieren.",
      "GUARDIAN": "Sicher begleiten und unterstützen."
    },
    "descriptions": {
      "SCOUT": "Du begleitest Menschen auf Wegen, unterstützt bei Fahrten oder machst Bewegung draußen leichter.",
      "MEDIC": "Du hilfst bei Angeboten für Gesundheit und Wohlbefinden und unterstützt Menschen mit Aufmerksamkeit und Zeit.",
      "SOCIAL": "Du hilfst bei Begegnungen, Veranstaltungen und gemeinsamen Aktivitäten, die Menschen verbinden.",
      "TANK": "Du unterstützt bei körperlichen Aufgaben, Bewegung und Sport. Dein Einsatz macht praktische Hilfe möglich.",
      "ENVIRONMENT": "Du sammelst Müll, pflegst Grünflächen oder hilfst bei Aktionen für Natur und Umwelt.",
      "TECH": "Du unterstützt beim Lernen, erklärst digitale Werkzeuge oder löst technische Alltagsprobleme.",
      "CRAFTER": "Du setzt Dinge instand, baust Nützliches oder gibst handwerkliches Wissen weiter.",
      "NUTRITION": "Du hilfst beim Einkauf, bei der Zubereitung oder bei der Weitergabe von Lebensmitteln.",
      "LOGISTICS": "Du planst Wege, transportierst Dinge und sorgst dafür, dass Unterstützung dort ankommt, wo sie gebraucht wird.",
      "GUARDIAN": "Du hilfst Menschen, sich sicherer zu bewegen, und übernimmst verlässliche Aufgaben für die Gemeinschaft."
    }
  },
  "perks": {
    "CLASS_V2_SCOUT_ABILITY": "Du musst zwischen zwei Einreichungen 10 % kürzer warten.",
    "CLASS_V2_TANK_ABILITY": "Du kannst eine weitere gute Tat gleichzeitig einreichen.",
    "CLASS_V2_CRAFTER_ABILITY": "Du kannst eine abgelehnte eigene Einzelaktion einmal überarbeiten und erneut prüfen lassen.",
    "CLASS_V2_LOGISTICS_ABILITY": "Einmal pro Kalenderwoche kannst du die Wartezeit bis zur nächsten Einreichung überspringen. Ein freier Platz ist weiterhin nötig.",
    "titles": {
      "CLASS_V2_SCOUT_CATEGORY": "Bonus in deiner Kategorie",
      "CLASS_V2_SCOUT_ABILITY": "Kürzere Wartezeit",
      "CLASS_V2_TANK_CATEGORY": "Bonus in deiner Kategorie",
      "CLASS_V2_TANK_ABILITY": "Mehr gleichzeitige Einreichungen",
      "CLASS_V2_GUARDIAN_CATEGORY": "Bonus in deiner Kategorie",
      "CLASS_V2_CRAFTER_CATEGORY": "Bonus in deiner Kategorie",
      "CLASS_V2_CRAFTER_ABILITY": "Zweite Prüfungschance",
      "CLASS_V2_SOCIAL_CATEGORY": "Bonus in deiner Kategorie",
      "CLASS_V2_SOCIAL_ABILITY": "Bonus für Gruppen",
      "CLASS_V2_LOGISTICS_CATEGORY": "Bonus in deiner Kategorie",
      "CLASS_V2_LOGISTICS_ABILITY": "Wartezeit überspringen",
      "CLASS_V2_NUTRITION_CATEGORY": "Bonus in deiner Kategorie",
      "CLASS_V2_TECH_CATEGORY": "Bonus in deiner Kategorie",
      "CLASS_V2_ENVIRONMENT_CATEGORY": "Bonus in deiner Kategorie",
      "CLASS_V2_MEDIC_CATEGORY": "Bonus in deiner Kategorie"
    }
  },
  "api": {
    "guild_unlock": {
      "requires_stammtisch": "Schalte zuerst den Stammtisch frei.",
      "requires_group_actions": "Schalte zuerst die Gruppenaktionen frei."
    },
    "messages": {
      "settings_anti_cheat_invalid": "Ungültige Anti-Cheat-Schwelle oder Zeitspanne.",
      "partner_redemption_details_length": "Einlöseort und Einlösezeit dürfen jeweils höchstens 250 Zeichen lang sein.",
      "guild_application_status_invalid": "Ungültiger Bewerbungsstatus.",
      "guild_application_already_decided": "Diese Bewerbung wurde bereits bearbeitet.",
      "auth_direct_message_setting_invalid": "Ungültige Einstellung für Direktnachrichten.",
      "direct_chat_recipient_privacy": "Diese Person nimmt keine Direktnachrichten von dir an.",
      "guild_statistics_period_invalid": "Invalid period",
      "heroic_draft_too_long": "Entwurf ist zu lang.",
      "heroic_category_invalid": "Ungültige Kategorie. Die Kategorie 'Allgemein' kann nicht für gute Taten gewählt werden.",
      "heroic_assessment_invalid": "Ungültige Einstufung.",
      "heroic_draft_not_found": "Entwurf nicht gefunden.",
      "heroic_draft_not_open": "Diese gute Tat ist kein Entwurf mehr.",
      "heroic_draft_load_failed": "Entwurf konnte nicht geladen werden.",
      "heroic_draft_delete_only": "Nur Entwürfe können gelöscht werden.",
      "heroic_already_submitted": "Diese gute Tat wurde bereits eingereicht.",
      "heroic_resubmit_status_invalid": "Nur zurückgezogene oder zurückgeschickte gute Taten können erneut eingereicht werden.",
      "heroic_delete_admin_only": "Nur aktive System-Admins dürfen Einreichungen löschen.",
      "heroic_submission_not_found": "Einreichung nicht gefunden.",
      "heroic_reward_disposition_required": "Bitte wählen, ob Belohnungen behalten oder zurückgerechnet werden sollen.",
      "heroic_evidence_cleanup_failed": "Die Einreichung wurde gelöscht. Mindestens eine verschlüsselte Beweisdatei konnte nicht entfernt werden; die Speicherpfade sind für die Bereinigung im Admin-Audit protokolliert.",
      "heroic_recalculate_approved_only": "Nur bestätigte Einreichungen können neu berechnet werden.",
      "heroic_historical_bonus_missing": "Für diese ältere Einreichung fehlen gespeicherte Bonusdaten.",
      "heroic_group_bonus_missing": "Der gespeicherte Gruppenbonus fehlt.",
      "heroic_group_bonuses_incomplete": "Die gespeicherten Gruppenboni sind unvollständig.",
      "heroic_category_progress_missing": "Der Kategorie-Fortschritt fehlt.",
      "heroic_list_admin_only": "Nur System-Admins dürfen alle Einreichungen sehen.",
      "heroic_return_reason_required": "Ein Grund mit höchstens 2.000 Zeichen ist erforderlich.",
      "heroic_own_group_review_forbidden": "Eigene Gruppenaktionen oder Aktionen mit eigener Teilnahme dürfen nicht geprüft werden.",
      "heroic_rewarded_return_forbidden": "Eine bereits belohnte Einreichung kann nicht zurückgeschickt werden.",
      "heroic_reason_too_long": "Die Begründung darf höchstens 2.000 Zeichen lang sein.",
      "heroic_admin_not_found": "Admin nicht gefunden.",
      "heroic_restart_admin_only": "Nur aktive System-Admins dürfen eine Prüfrunde neu starten.",
      "heroic_review_round_stale": "Die Prüfrunde ist nicht mehr aktuell oder die Einreichung ist nicht mehr in Prüfung.",
      "heroic_own_action_restart_forbidden": "Eigene gute Taten dürfen nicht neu zur Prüfung gestartet werden.",
      "heroic_own_group_restart_forbidden": "Eigene Gruppenaktionen oder Aktionen mit eigener Teilnahme dürfen nicht neu zur Prüfung gestartet werden.",
      "heroic_review_round_no_votes": "Diese Prüfrunde enthält noch keine Stimmen.",
      "heroic_review_round_changed": "Seit dem Laden der Einreichung wurden weitere Stimmen abgegeben. Bitte die Seite neu laden.",
      "heroic_rewarded_restart_forbidden": "Eine bereits belohnte Einreichung kann nicht neu zur Prüfung gestartet werden.",
      "heroic_already_reviewed_round": "Du hast diese Einreichung in der aktuellen Prüfrunde bereits geprüft.",
      "heroic_category_select_required": "Bitte eine gültige Kategorie auswählen.",
      "heroic_category_locked": "Die Kategorie wurde durch die erste Prüfung festgelegt und kann in dieser Prüfrunde nicht mehr geändert werden.",
      "heroic_withdraw_before_evidence_removal": "Ziehe die Einreichung zuerst zurück, um bisherige Nachweise zu entfernen.",
      "passwort_und_neues_passwort_erforderlich": "Bitte alle Passwortfelder ausfüllen.",
      "group_action_title_length": "Der Titel muss zwischen 1 und 150 Zeichen lang sein.",
      "group_action_description_length": "Die Beschreibung muss zwischen 1 und 2.000 Zeichen lang sein.",
      "group_action_declarations_required": "Bitte bestätige alle Erklärungen für Organisatoren.",
      "group_action_commercial_work": "Diese Aktion deutet auf kommerzielle Tätigkeit oder den Ersatz bezahlter Arbeit hin.",
      "group_action_category_invalid": "Bitte wähle eine gültige Kategorie für die Gruppenaktion.",
      "group_action_difficulty_invalid": "Bitte wähle eine gültige Einschätzung für Zeit und Einsatz.",
      "group_action_complexity_invalid": "Bitte wähle eine gültige Einschätzung für Planung und Abstimmung.",
      "group_action_scheduled_future": "Der Termin muss in der Zukunft liegen.",
      "group_action_deadline_future": "Der Anmeldeschluss muss in der Zukunft liegen.",
      "group_action_deadline_after_schedule": "Der Anmeldeschluss darf nicht nach dem Termin liegen.",
      "group_action_participants_range": "Die Teilnehmerzahl muss zwischen 2 und 500 liegen.",
      "event_category_invalid": "Bitte wähle eine gültige Event-Kategorie.",
      "passwort_erfolgreich_geaendert": "Passwort erfolgreich geändert.",
      "aktuelles_passwort_falsch": "Das aktuelle Passwort ist falsch.",
      "passwort_zu_kurz": "Das Passwort muss mindestens 8 Zeichen lang sein.",
      "location_required": "Bitte wähle einen Standort auf der Karte.",
      "administrator_nicht_gefunden_30": "Administrator nicht gefunden.",
      "aktueller_benutzer_nicht_gefun_104": "Aktueller Benutzer nicht gefunden.",
      "anfrage_konnte_nicht_gestellt__28": "Anfrage konnte nicht gestellt werden (z.B. User geblockt).",
      "angebot_erfolgreich_gel_scht_57": "Angebot erfolgreich gelöscht.",
      "angebot_nicht_gefunden_oder_ke_56": "Angebot nicht gefunden oder keine Berechtigung.",
      "aushang_erfolgreich_entfernt_34": "Aushang erfolgreich entfernt.",
      "beitrittsanfrage_erfolgreich_b_29": "Beitrittsanfrage erfolgreich übermittelt.",
      "benutzer_nicht_gefunden_1": "Benutzer nicht gefunden.",
      "benutzer_nicht_gefunden_37": "Benutzer nicht gefunden.",
      "benutzername_e_mail_passwort_u_4": "Benutzername, E-Mail, Passwort und Firmenname sind erforderlich.",
      "benutzerprofil_nicht_gefunden_99": "Benutzerprofil nicht gefunden.",
      "beschreibung_darf_max_300_zeic_24": "Beschreibung darf max. 300 Zeichen haben.",
      "das_bild_darf_maximal_5_mb_gro_94": "Das Bild darf maximal 5 MB groß sein.",
      "das_enddatum_muss_nach_dem_sta_17": "Das Enddatum muss nach dem Startdatum liegen.",
      "das_enddatum_muss_nach_dem_sta_20": "Das Enddatum muss nach dem Startdatum liegen.",
      "das_icon_darf_maximal_2mb_g": "Das Icon darf maximal 2MB groß sein.",
      "die_datei_ist_kein_g_ltiges_bi_76": "Die Datei ist kein gültiges Bildformat.",
      "die_datei_ist_kein_g_ltiges_bi_97": "Die Datei ist kein gültiges Bildformat.",
      "dieser_benutzer_erfordert_kein_2": "Dieser Benutzer erfordert keine Freigabe.",
      "du_kannst_nur_f_r_dein_eigenes_27": "Du kannst nur für dein eigenes Profil eine Beitrittsanfrage senden.",
      "ein_benutzer_mit_dieser_e_mail_5": "Ein Benutzer mit dieser E-Mail oder diesem Benutzernamen existiert bereits.",
      "ein_titel_ist_erforderlich_16": "Ein Titel ist erforderlich.",
      "ein_titel_ist_erforderlich_19": "Ein Titel ist erforderlich.",
      "einstellung_erfolgreich_geloescht": "Einstellung erfolgreich gelöscht.",
      "einstellung_erfolgreich_gespeichert": "Einstellung erfolgreich gespeichert.",
      "einstellung_nicht_gefunden": "Einstellung wurde nicht gefunden.",
      "einstellungsschluessel_darf_nicht_leer_sein": "Einstellungsschlüssel darf nicht leer sein.",
      "event_erfolgreich_gel_scht_22": "Event erfolgreich gelöscht.",
      "event_nicht_gefunden_15": "Event nicht gefunden.",
      "event_nicht_gefunden_18": "Event nicht gefunden.",
      "event_nicht_gefunden_21": "Event nicht gefunden.",
      "ffentliches_benutzerprofil_nic_101": "Öffentliches Benutzerprofil nicht gefunden.",
      "icon_nicht_gefunden": "Icon nicht gefunden.",
      "kategorie_erfolgreich_archivie_10": "Kategorie erfolgreich archiviert (Soft Delete).",
      "kategorie_erfolgreich_wiederhe_11": "Kategorie erfolgreich wiederhergestellt.",
      "keine_bilddatei_bermittelt_72": "Keine Bilddatei übermittelt.",
      "keine_bilddatei_bermittelt_93": "Keine Bilddatei übermittelt.",
      "keine_datei_ausgew_hlt_44": "Keine Datei ausgewählt.",
      "konto_wartet_auf_freischaltung_14": "Konto wartet auf Freischaltung durch den System-Admin.",
      "nur_jpg_png_und_webp_formate_s_95": "Nur JPG, PNG und WEBP Formate sind erlaubt.",
      "nur_png_dateien_erlaubt": "Nur PNG-Dateien sind für Icons erlaubt.",
      "partnerprofil_erfolgreich_aktu_60": "Partnerprofil erfolgreich aktualisiert.",
      "partnerprofil_nicht_gefunden_61": "Partnerprofil nicht gefunden.",
      "profil_konnte_nicht_aktualisie_100": "Profil konnte nicht aktualisiert werden.",
      "profil_konnte_nicht_aktualisie_62": "Profil konnte nicht aktualisiert werden.",
      "profilbeschreibung_erfolgreich_91": "Profilbeschreibung erfolgreich aktualisiert.",
      "profilbild_erfolgreich_aktualisiert": "Profilbild erfolgreich aktualisiert.",
      "profilbild_nicht_gefunden_103": "Profilbild nicht gefunden.",
      "push_abonnement_erfolgreich_re_48": "Push-Abonnement erfolgreich registriert.",
      "qr_token_darf_nicht_leer_sein_50": "QR-Code darf nicht leer sein.",
      "sowohl_breitengrad_als_auch_l__41": "Sowohl Breitengrad als auch Längengrad müssen angegeben werden.",
      "suchbegriff_darf_nicht_leer_se_3": "Suchbegriff darf nicht leer sein.",
      "suchbegriff_darf_nicht_leer_se_98": "Suchbegriff darf nicht leer sein.",
      "titel_ist_erforderlich_54": "Titel ist erforderlich.",
      "titel_und_inhalt_sind_erforder_87": "Titel und Inhalt sind erforderlich.",
      "ung_ltige_benutzer_identifikat_49": "Ungültige Benutzer-Identifikation.",
      "ung_ltige_benutzer_identifikat_51": "Ungültige Benutzer-Identifikation.",
      "ung_ltige_benutzer_identifikat_52": "Ungültige Benutzer-Identifikation.",
      "ung_ltige_benutzer_identifikat_53": "Ungültige Benutzer-Identifikation.",
      "ung_ltige_benutzer_identifikat_55": "Ungültige Benutzer-Identifikation.",
      "ung_ltige_benutzer_identifikat_58": "Ungültige Benutzer-Identifikation.",
      "ung_ltige_benutzer_identifikat_59": "Ungültige Benutzer-Identifikation.",
      "ung_ltige_benutzer_identifikat_88": "Ungültige Benutzer-Identifikation.",
      "ung_ltige_benutzer_identifikat_89": "Ungültige Benutzer-Identifikation.",
      "ung_ltige_benutzer_identifikat_90": "Ungültige Benutzer-Identifikation.",
      "ung_ltige_benutzer_identifikat_92": "Ungültige Benutzer-Identifikation.",
      "ung_ltige_bilddatei_75": "Ungültige Bilddatei.",
      "ung_ltige_bilddatei_96": "Ungültige Bilddatei.",
      "ung_ltige_koordinaten_f_r_den__26": "Ungültige Koordinaten für den Standort.",
      "ung_ltige_push_subscription_da_47": "Ungültige Push-Subscription Daten.",
      "ung_ltiger_breitengrad_90_bis__42": "Ungültiger Breitengrad (-90 bis 90).",
      "ung_ltiger_dateiname_102": "Ungültiger Dateiname.",
      "ung_ltiger_dateiname_85": "Ungültiger Dateiname.",
      "ung_ltiger_l_ngengrad_180_bis__43": "Ungültiger Längengrad (-180 bis 180).",
      "ung_ltiger_status_erlaubt_appr_30": "Ungültiger Status. Erlaubt: Approved, Denied, Blocked.",
      "ungueltiger_schluessel": "Ungültiger Schlüssel.",
      "heroic_review_thresholds_invalid": "Die Moderationsschwellen sind ungültig.",
      "heroic_withdraw_own_only": "Du kannst nur eigene gute Taten zurückziehen.",
      "heroic_withdraw_pending_only": "Du kannst nur gute Taten zurückziehen, die sich in Prüfung befinden.",
      "heroic_parallel_limit": "Du kannst höchstens {{maxParallel}} gute Taten gleichzeitig bearbeiten.",
      "heroic_cooldown_active": "Du kannst nach der Abklingzeit von {{minutes}} Minuten eine weitere gute Tat beginnen.",
      "heroic_appeal_deadline_passed": "Die Einspruchsfrist von {{days}} Tagen ist abgelaufen.",
      "talent_prerequisite": "Investiere zuerst mindestens zwei Punkte in {{talent}} (Stufe 2/3).",
      "class_perk_category_not_found": "Die Kategorie wurde nicht gefunden.",
      "admin_partner_created": "Partnerbetrieb {{name}} erfolgreich erstellt.",
      "guild_application_status_changed": "Status der Bewerbung auf {{status}} geändert.",
      "admin_partner_deleted": "Partner erfolgreich gelöscht.",
      "admin_icon_uploaded": "Icon erfolgreich hochgeladen.",
      "admin_reason_required": "Bitte gib eine Begründung mit 5–1.000 Zeichen an.",
      "admin_delta_nonzero": "Die Anpassung darf nicht null sein.",
      "heroic_evidence_upload_missing": "Wähle eine Beweisdatei zum Hochladen aus.",
      "system_admin_transfer_required": "System-Admin-Konten müssen durch einen anderen Admin übertragen oder entfernt werden.",
      "heroic_player_not_found": "Spielende Person nicht gefunden.",
      "heroic_title_length": "Der Titel muss zwischen 1 und 150 Zeichen lang sein.",
      "heroic_description_length": "Die Beschreibung muss zwischen 1 und 2.000 Zeichen lang sein.",
      "heroic_difficulty_invalid": "Ungültige Einschätzung für Zeit und Einsatz.",
      "heroic_complexity_invalid": "Ungültige Einschätzung für Planung und Abstimmung.",
      "heroic_evidence_type_invalid": "Ungültiger Nachweistyp.",
      "heroic_future_date": "Das Datum der guten Tat darf nicht in der Zukunft liegen.",
      "heroic_evidence_upload_required": "Für diesen Nachweistyp muss eine Beweisdatei hochgeladen werden.",
      "heroic_event_inactive": "System-Event ist nicht aktiv.",
      "heroic_event_limit_reached": "Maximale Einreichungen für dieses System-Event erreicht.",
      "heroic_load_failed": "Gute Tat konnte nicht geladen werden.",
      "heroic_own_action_not_found": "Eigene gute Tat nicht gefunden.",
      "heroic_action_not_found": "Gute Tat nicht gefunden.",
      "heroic_resubmit_requires_withdrawal": "Nur zurückgezogene gute Taten können erneut eingereicht werden.",
      "heroic_evidence_required": "Für diesen Nachweistyp muss ein vorhandener oder neuer Nachweis verfügbar sein.",
      "heroic_progress_invalid": "Ungültige Fortschrittswerte.",
      "heroic_rejection_reason_required": "Bei einer Ablehnung ist eine Begründung erforderlich.",
      "heroic_rejection_reason_length": "Die Ablehnungsbegründung darf höchstens 2.000 Zeichen lang sein.",
      "heroic_review_closed": "Diese gute Tat ist nicht mehr in Prüfung.",
      "heroic_cannot_review_own": "Eigene gute Taten dürfen nicht geprüft werden.",
      "heroic_reviewer_not_found": "Prüfende Person nicht gefunden.",
      "heroic_review_not_assigned": "Diese gute Tat ist dir nicht zur Prüfung zugewiesen.",
      "heroic_review_own_participation": "Eigene gute Taten oder gute Taten mit eigener Teilnahme dürfen nicht geprüft werden.",
      "heroic_review_difficulty_required": "Bitte eine gültige Einschätzung für Zeit und Einsatz auswählen.",
      "heroic_review_complexity_required": "Bitte eine gültige Einschätzung für Planung und Abstimmung auswählen.",
      "heroic_group_two_participants_required": "Für eine Gruppenaktion sind mindestens zwei bestätigte Teilnehmer erforderlich.",
      "heroic_moderator_application_pending": "Deine Moderatorbewerbung wird bereits geprüft.",
      "heroic_moderator_motivation_length": "Die Motivation muss zwischen 20 und 2.000 Zeichen lang sein.",
      "heroic_moderator_decision_admin_only": "Nur System-Admins dürfen Moderatorbewerbungen entscheiden.",
      "heroic_moderator_application_missing": "Keine offene Bewerbung vorhanden.",
      "heroic_moderator_manage_admin_only": "Nur System-Admins dürfen Moderatorenrechte verwalten.",
      "heroic_appeal_reason_length": "Der Einspruch muss nachvollziehbar begründet sein und 20 bis 2000 Zeichen enthalten.",
      "heroic_appeal_participants_only": "Nur betroffene Teilnehmer dürfen Einspruch einlegen.",
      "heroic_appeal_rejected_only": "Einspruch ist nur gegen eine abgelehnte gute Tat möglich.",
      "heroic_appeal_evidence_missing": "Ein Einspruch ist ohne den ursprünglichen Beweis nicht prüfbar.",
      "heroic_appeal_limit_reached": "Für diese gute Tat ist kein weiterer Einspruch möglich.",
      "heroic_appeal_admin_only": "Nur System-Admins dürfen Einsprüche entscheiden.",
      "heroic_appeal_decision_reason_required": "Eine kurze Begründung der Einspruchsentscheidung ist erforderlich.",
      "heroic_appeal_not_found": "Einspruch nicht gefunden.",
      "heroic_appeal_already_decided": "Dieser Einspruch wurde bereits entschieden.",
      "heroic_action_state_changed": "Der Zustand der guten Tat hat sich bereits geändert.",
      "heroic_decision_own_action": "Eigene gute Taten oder Einsprüche eigener guter Taten dürfen nicht entschieden werden.",
      "heroic_evidence_privacy_required": "Vor dem Upload müssen die Datenschutzregeln für Beweise bestätigt werden.",
      "heroic_evidence_upload_closed": "Nach der endgültigen Entscheidung können keine Beweise mehr hinzugefügt werden.",
      "heroic_evidence_size": "Beweisdatei muss zwischen 1 Byte und 10 MB groß sein.",
      "heroic_evidence_format": "Dateityp oder Dateisignatur ist nicht erlaubt.",
      "heroic_evidence_reused": "Diese Beweisdatei wurde bereits für eine andere Einreichung verwendet.",
      "heroic_evidence_not_found": "Beweis nicht gefunden.",
      "heroic_evidence_file_missing": "Beweisdatei fehlt auf dem Server.",
      "heroic_evidence_delete_closed": "Beweise können nur vor Beginn der Prüfung gelöscht werden.",
      "heroic_evidence_forbidden": "Keine Berechtigung für diesen Beweis.",
      "heroic_evidence_storage_invalid": "Ungültiger Beweisspeicherpfad.",
      "partner_business_not_found": "Partnerbetrieb für diesen Account nicht gefunden.",
      "partner_offer_title_length": "Der Angebotstitel muss zwischen 1 und 150 Zeichen lang sein.",
      "partner_offer_description_length": "Die Angebotsbeschreibung darf höchstens 2.000 Zeichen lang sein.",
      "partner_offer_type_invalid": "Ungültiger Angebotstyp.",
      "partner_offer_discount_range": "Der Rabatt muss zwischen 0 und 100 Prozent liegen.",
      "partner_offer_redemption_type_invalid": "Ungültige Einlöseart (nur OnSite, Digital oder Both erlaubt).",
      "partner_offer_location_required": "Der Angebotsstandort ist für Vor-Ort-Angebote erforderlich.",
      "partner_offer_coordinates_invalid": "Ungültige Standortkoordinaten.",
      "partner_offer_code_length": "Der Gutscheincode darf höchstens 100 Zeichen lang sein.",
      "partner_offer_url_length": "Die Einlöse-URL darf höchstens 500 Zeichen lang sein.",
      "partner_offer_instructions_length": "Die Einlöse-Hinweise dürfen höchstens 1.000 Zeichen lang sein.",
      "partner_offer_rank_invalid": "Ungültiger Mindestrang.",
      "partner_offer_category_invalid": "Ungültige Angebotskategorie.",
      "partner_offer_progress_category_invalid": "Ungültige Fortschrittskategorie.",
      "partner_offer_progress_negative": "Fortschrittsvoraussetzungen dürfen nicht negativ sein.",
      "partner_offer_progress_category_required": "Für Kategorie-Fortschritt muss eine Kategorie gewählt werden.",
      "partner_offer_good_deed_requirement_missing": "Die gewählte Gute-Tat-Voraussetzung existiert nicht.",
      "partner_offer_frequency_invalid": "Ungültige Einlösefrequenz.",
      "partner_offer_day_interval_invalid": "Für ein Tagesintervall ist eine positive Tagesanzahl erforderlich.",
      "partner_offer_limit_invalid": "Einlöselimits müssen positiv sein.",
      "partner_company_name_length": "Der Firmenname muss zwischen 1 und 150 Zeichen lang sein.",
      "partner_category_invalid": "Ungültige Partnerkategorie.",
      "direct_chat_self": "Du kannst keine Nachrichten an dich selbst senden.",
      "direct_chat_message_length": "Nachricht darf maximal 1000 Zeichen lang sein.",
      "direct_chat_recipient_not_found": "Empfänger nicht gefunden.",
      "direct_chat_sender_not_found": "Absender nicht gefunden.",
      "direct_chat_account_suspended": "Dein Konto ist gesperrt. Du kannst keine Nachrichten senden.",
      "direct_chat_wait_one_second": "Spam-Schutz: Bitte warte eine Sekunde, bevor du die nächste Nachricht sendest.",
      "direct_chat_rate_limit": "Spam-Schutz: Du hast das Limit von 15 Direktnachrichten pro Minute überschritten. Bitte warte einen Moment.",
      "direct_chat_consecutive_limit": "Spam-Schutz: Du hast bereits 5 Nachrichten hintereinander an diese Person gesendet. Bitte warte auf eine Antwort.",
      "settings_nonnegative_integer_required": "Diese Einstellung muss eine nichtnegative ganze Zahl sein.",
      "settings_positive_value_required": "Diese Einstellung muss größer als null sein.",
      "settings_review_threshold_order": "Moderationsschwellen müssen aufsteigend sein: eine Prüfung ≤ zwei Prüfungen ≤ Admin-Prüfung.",
      "settings_evidence_retention_invalid": "Beweise müssen mindestens sieben Tage länger als die Einspruchsfrist aufbewahrt werden.",
      "class_perk_key_title_required": "Perk-Schlüssel und Titel sind erforderlich.",
      "class_perk_category_invalid": "Die Zielkategorie ist ungültig.",
      "class_perk_effect_required": "Der Wirkungstyp ist erforderlich.",
      "class_perk_effect_invalid": "Der Wirkungstyp ist ungültig.",
      "class_perk_value_range": "Der Wirkungswert muss zwischen 0 und 3 liegen.",
      "password_reset_email_unavailable": "E-Mail zum Zurücksetzen des Passworts ist derzeit nicht verfügbar.",
      "guild_chat_empty": "Bitte gib eine Nachricht ein.",
      "guild_chat_message_not_found": "Die Chat-Nachricht wurde nicht gefunden.",
      "guild_user_not_found": "Das Benutzerkonto wurde nicht gefunden.",
      "guild_reaction_invalid": "Wähle eine gültige Reaktion.",
      "guild_poll_invalid": "Gib eine Frage und 2–5 unterschiedliche Antwortmöglichkeiten ein.",
      "guild_poll_option_invalid": "Wähle eine gültige Antwortmöglichkeit.",
      "guild_emblem_invalid_format": "Verwende eine PNG-, JPG-, WEBP- oder SVG-Datei.",
      "guild_latitude_required": "Wähle einen Standort auf der Karte.",
      "guild_longitude_required": "Wähle einen Standort auf der Karte.",
      "guild_requester_not_found": "Dein Konto wurde nicht gefunden. Bitte melde dich erneut an.",
      "guild_cannot_promote_system_admin": "Die Rolle eines System-Admins kann nicht geändert werden.",
      "guild_account_unavailable": "Dieses Konto ist nicht aktiv oder gesperrt.",
      "group_action_registration_closed": "Die Anmeldung für diese Gruppenaktion ist geschlossen.",
      "group_action_deadline_passed": "Die Anmeldefrist ist abgelaufen.",
      "group_action_full": "Diese Gruppenaktion ist bereits voll.",
      "group_action_withdraw_closed": "Nach der Einreichung kannst du dich nicht mehr abmelden.",
      "group_action_registration_missing": "Du hast keine aktive Anmeldung für diese Aktion.",
      "group_action_confirmation_closed": "Die Teilnahme kann nicht mehr bestätigt werden.",
      "group_action_confirmation_too_early": "Bestätige die Teilnahme erst nach Beginn der Gruppenaktion.",
      "group_action_not_registered": "Du bist nicht für diese Gruppenaktion angemeldet.",
      "group_action_already_submitted": "Diese Gruppenaktion wurde bereits eingereicht oder geschlossen.",
      "group_action_submit_too_early": "Reiche die Aktion erst nach ihrem geplanten Beginn ein.",
      "group_action_two_confirmations_required": "Mindestens zwei Mitglieder müssen ihre Teilnahme bestätigen.",
      "group_action_future_date": "Das Datum darf nicht in der Zukunft liegen.",
      "group_action_date_before_schedule": "Das Ausführungsdatum liegt vor der geplanten Gruppenaktion.",
      "group_action_external_evidence_forbidden": "Externe Beweislinks sind nicht erlaubt. Lade eine verschlüsselte Datei hoch.",
      "group_action_evidence_required": "Eine verschlüsselte Beweisdatei ist erforderlich.",
      "group_action_cancel_closed": "Nur offene Gruppenaktionen können abgesagt werden.",
      "group_action_delete_closed": "Nur abgesagte Gruppenaktionen können gelöscht werden.",
      "group_action_not_found": "Die Gruppenaktion wurde nicht gefunden.",
      "group_action_parallel_limit": "Du hast dein Limit für parallele gute Taten erreicht.",
      "group_action_cooldown_active": "Du kannst nach Ablauf der Abklingzeit eine weitere gute Tat beginnen.",
      "guild_founder_not_found": "Dein Konto wurde nicht gefunden. Bitte melde dich erneut an.",
      "karma_penalty_invalid": "Bitte 1–100 Punkte und eine Begründung mit 5–1000 Zeichen angeben.",
      "account_not_deleted": "Nur bereits gelöschte Konten können endgültig entfernt werden.",
      "account_suspended": "Dieses Konto wurde gesperrt.",
      "account_suspended_reason": "Dieses Konto wurde gesperrt. Grund: {{reason}}",
      "account_suspended_admin": "Dieses Konto wurde durch die Administration gesperrt. Ein genauer Grund ist nicht hinterlegt.",
      "das_banner_darf_maximal_8_mb_gross_sein": "Das Banner darf maximal 8 MB groß sein.",
      "banner_erfolgreich_aktualisiert": "Banner erfolgreich aktualisiert.",
      "class_skip_unavailable": "Gute Kontakte ist diese Woche nicht verfügbar.",
      "class_repair_only": "Nur Schmiede können gute Taten reparieren.",
      "class_repair_unavailable": "Nur eine abgelehnte, noch nicht reparierte gute Tat kann repariert werden.",
      "class_repair_individual": "Reparieren ist nur bei eigenen einzelnen guten Taten möglich.",
      "class_repair_appeal": "Während eines laufenden Einspruchs ist keine Reparatur möglich.",
      "class_repair_revision": "Bitte die Beschreibung überarbeiten (1–2000 Zeichen) oder einen neuen Nachweis hochladen.",
      "class_repair_slot": "Für die Reparatur ist ein freier Einreichungsslot erforderlich.",
      "class_repair_evidence": "Der ursprüngliche Nachweis ist abgelaufen. Bitte einen neuen Nachweis hochladen.",
      "email_bereits_registriert": "Diese E-Mail-Adresse ist bereits registriert.",
      "ungueltige_email_oder_passwort": "E-Mail/Benutzername oder Passwort ist nicht korrekt.",
      "benutzername_bereits_vergeben": "Dieser Benutzername ist bereits vergeben.",
      "pflichtfelder_ausfuellen": "Benutzername, E-Mail und Passwort sind erforderlich.",
      "ungueltige_partnerkategorie": "Die gewählte Partnerkategorie ist ungültig.",
      "passwort_zuruecksetzen_angefordert": "Falls ein Konto mit dieser E-Mail-Adresse existiert, wurde eine Anleitung zum Zurücksetzen generiert.",
      "passwort_erfolgreich_zurueckgesetzt": "Dein Passwort wurde erfolgreich geändert.",
      "reset_token_ungueltig_oder_abgelaufen": "Ungültiger oder abgelaufener Reset-Token.",
      "video_duration_invalid": "Das MP4-Video muss eine lesbare Dauer von höchstens 10 Sekunden haben.",
      "email_confirmation_required": "Bitte bestätige zuerst deine E-Mail-Adresse.",
      "email_confirmation_invalid": "Dieser Bestätigungslink ist ungültig, abgelaufen oder bereits verwendet. Bitte fordere bei Bedarf einen neuen Link an.",
      "email_delivery_failed": "Die Bestätigungsmail konnte nicht gesendet werden. Bitte fordere in einer Minute einen neuen Bestätigungslink an.",
      "group_xp_allocation_invalid": "Verteile genau 100 % in ganzen Prozent. Pro bestätigter Person sind 0 bis 50 % erlaubt; mindestens zwei Personen brauchen einen positiven Anteil.",
      "group_action_account_inactive": "Der Account ist nicht aktiv oder gesperrt."
    },
    "status": {
      "400": "Bitte überprüfe deine Eingaben.",
      "401": "Bitte melde dich erneut an.",
      "403": "Du hast keine Berechtigung für diese Aktion.",
      "404": "Der angeforderte Inhalt wurde nicht gefunden.",
      "409": "Die Aktion ist im aktuellen Zustand nicht möglich. Bitte lade die Daten neu.",
      "413": "Die Datei ist zu groß.",
      "415": "Dieses Dateiformat wird nicht unterstützt.",
      "422": "Bitte überprüfe deine Eingaben.",
      "429": "Zu viele Anfragen. Bitte warte einen Moment.",
      "500": "Ein Serverfehler ist aufgetreten. Bitte versuche es später erneut.",
      "502": "Der Server ist vorübergehend nicht erreichbar.",
      "503": "Dieser Dienst ist noch nicht konfiguriert oder derzeit nicht verfügbar.",
      "generic": "Die Anfrage konnte nicht verarbeitet werden.",
      "network": "Keine Verbindung zum Server. Bitte prüfe deine Internetverbindung.",
      "success": "Die Aktion wurde erfolgreich ausgeführt."
    }
  },
  "errorPage": {
    "notice": "Hinweis",
    "retry": "Erneut versuchen",
    "home": "Zur Übersicht",
    "back": "Zurück",
    "login": "Anmelden",
    "notFound": {
      "title": "Dieser Weg führt ins Leere.",
      "description": "Die Seite oder der angeforderte Inhalt wurde nicht gefunden. Kehre zur Übersicht zurück oder versuche es erneut."
    },
    "forbidden": {
      "title": "Dieser Bereich ist verschlossen.",
      "description": "Für diesen Inhalt fehlen dir die erforderlichen Berechtigungen."
    },
    "session": {
      "title": "Deine Reise wartet auf dich.",
      "description": "Bitte melde dich erneut an, um fortzufahren."
    },
    "unavailable": {
      "title": "Eine kurze Pause auf deiner Reise.",
      "description": "Der Inhalt konnte gerade nicht geladen werden. Bitte versuche es in einem Moment erneut."
    }
  },
  "faq_page": {
    "title": "Häufige Fragen"
  },
  "evidence_picker": {
    "label": "Nachweisart auswählen",
    "Video": "Kurzvideo",
    "SelfReport": "Kein visueller Nachweis",
    "Photo": "Foto",
    "PhotoGps": "Foto mit Standort",
    "Document": "Dokument",
    "recommended": "Empfohlen",
    "preview": "Vorschau: {{name}}"
  },
  "review_evidence": {
    "title": "Nachweise prüfen",
    "count_one": "{{count}} Datei",
    "count_other": "{{count}} Dateien",
    "before": "Vorher",
    "after": "Nachher",
    "activity": "Tätigkeit",
    "photos": "Fotos",
    "documents": "Dokumente",
    "other": "Weitere Nachweise",
    "assignment_hint": "Vorher / Nachher / Tätigkeit werden anhand der Dateinamen zugeordnet. Diese Angaben und „Direktaufnahme“ sind kein Echtheitsnachweis.",
    "failed": "Vorschau konnte nicht geladen werden.",
    "retry": "Erneut versuchen",
    "open": "In voller Größe öffnen",
    "preview": "Nachweis: {{name}}",
    "loading": "Vorschau wird geladen …",
    "document": "Dokument zur Prüfung",
    "load_document": "Dokument laden",
    "video": "Video",
    "photo": "Foto",
    "file": "Datei",
    "self_report": "Nachweistyp: Kein visueller Nachweis. Keine Datei erforderlich.",
    "empty": "Keine Beweisdatei vorhanden.",
    "play": "Video laden & abspielen",
    "upload_date": "Upload-Datum",
    "expiry_date": "Ablaufdatum",
    "deletion_prefix": "Löschung"
  },
  "admin_directory": {
    "delete_user": "Benutzerkonto löschen",
    "permanent_delete_user": "Endgültig löschen",
    "permanent_delete_confirm": "Das bereits gelöschte Konto „{{name}}“ und seine verknüpften Nutzerdaten vollständig aus der Datenbank entfernen? Dieser Vorgang kann nicht rückgängig gemacht werden.",
    "delete_confirm": "Benutzerkonto von „{{name}}“ endgültig löschen? Persönliche Daten werden entfernt und das Konto dauerhaft deaktiviert. Dieser Vorgang kann nicht rückgängig gemacht werden.",
    "users": "Alle User",
    "search": "Name oder E-Mail suchen",
    "loading": "Wird geladen …",
    "members": "Mitglieder",
    "details": "Details",
    "edit": "Details bearbeiten",
    "level": "Level",
    "active": "Aktiv",
    "banned": "Gesperrt",
    "manage": "User verwalten",
    "empty": "Keine Einträge",
    "previous": "Zurück",
    "next": "Weiter",
    "close": "Schließen",
    "profile": "Öffentliches Profil",
    "review": "Gute Taten prüfen",
    "suspension": "Kontosperre",
    "reason": "Begründung (wird protokolliert)",
    "ban": "Konto sperren",
    "unban": "Sperre aufheben",
    "reason_required": "Bitte eine Begründung mit 5–1000 Zeichen angeben.",
    "search_users": "Name oder E-Mail suchen …",
    "heroic_actions": "Gute Taten",
    "unlocks": "Freischaltungen & Käufe",
    "leader": "Leitung",
    "location": "Standort",
    "overview_tab": "Übersicht & Metriken",
    "unlocks_tab": "Shop & Freischaltungen",
    "ledger_tab": "Transaktions-Journal",
    "members_tab": "Mitglieder",
    "news_tab": "Aushänge & News",
    "weekly_activity": "Wöchentliche Aktivität",
    "yearly_activity": "Jährliche Aktivität",
    "group_actions": "Gruppenaktionen",
    "registered": "Registriert: {{date}}",
    "tab_overview": "Übersicht & Profil",
    "tab_suspension": "Kontosperre & Status",
    "tab_submissions": "Einreichungen",
    "tab_partner": "Partner-Einstellungen & Angebote",
    "level_num": "Stufe {{level}}",
    "confirmed": "bestätigt",
    "business_card_preview": "Visitenkarten-Vorschau:",
    "current_status": "Aktueller Kontostatus:",
    "suspension_placeholder": "Begründung für die Sperrung oder Entsperrung angeben (wird im Audit-Log gespeichert)...",
    "sysadmin_cannot_be_banned": "System-Administratoren können nicht gesperrt werden.",
    "rejection_reason": "Ablehnungsgrund:",
    "submitted_at": "Eingereicht am: {{date}}",
    "page_of": "Seite {{current}} von {{total}}",
    "sum_of_members": "Summe aller {{count}} Mitglieder",
    "weekly_since_monday": "Wöchentlich (seit Montag)",
    "thereof_group_actions": "davon {{count}} Gruppenaktionen",
    "this_calendar_year": "Dieses Kalenderjahr",
    "total_history": "Gesamt Historie",
    "view_profile": "Profil ansehen",
    "author": "Autor: {{name}}",
    "pinned": "• Angepinnt",
    "no_announcements": "Keine Aushänge vorhanden.",
    "heroic_actions_count": "{{count}} Gute Taten",
    "no_description": "Keine Beschreibung hinterlegt.",
    "purchases_count": "{{count}} Käufe"
  },
  "classesAndRanks": {
    "eyebrow": "Dein Weg durch Goodvale"
  },
  "ranksGuide": {
    "eyebrow": "Dein Fortschritt in Goodvale",
    "start": "Start",
    "dynamic": "Aktuelle Systemwerte",
    "defaults": "Standardwerte",
    "loadError": "Die Live-Konfiguration konnte nicht geladen werden. Es werden die Standardwerte angezeigt."
  },
  "landing": {
    "roles_intro": "So greifen gute Taten, ihre Prüfung, Gemeinschaft und Anerkennung ineinander.",
    "role_actions": [
      "Gutes tun",
      "Taten prüfen",
      "Gemeinsam handeln",
      "Engagement belohnen"
    ],
    "karma_kicker": "Vertrauen und Folgen",
    "start": "Jetzt beitreten",
    "more": "Wie es funktioniert",
    "classesTitle": "Wähle deinen Weg",
    "guildFeature": {
      "kicker": "Gemeinsam mehr bewegen"
    },
    "partnerFeature": {
      "kicker": "Lokale Wirkung belohnen",
      "title": "Partner geben guten Taten einen Mehrwert im Alltag.",
      "intro": "Unternehmen und Organisationen können Menschen unterstützen, die sich engagieren. Als Partner zeigst du dein Angebot auf Goodvale und legst selbst fest, welche verifizierten Leistungen dafür nötig sind. So wird aus Anerkennung ein konkreter Vorteil.",
      "action": "Als Partner registrieren"
    },
    "cta": "Jede Tat zählt. Fang heute an, etwas zu bewegen.",
    "categories_kicker": "Gute Taten im Alltag",
    "categories_title": "Entdecke die zehn Kategorien",
    "categories_description": "Vom Helfen beim Einkauf bis zum Umweltschutz: Jede Kategorie zeigt eine andere Möglichkeit, aktiv zu werden."
  },
  "partnerSettings": {
    "title": "Partnerbereich",
    "loadError": "Ladefehler",
    "required": "Erforderlich",
    "failed": "Fehler beim Speichern.",
    "pending": "In Prüfung",
    "vat": "UID / Steuernummer",
    "bio": "Unternehmensbeschreibung / Über uns",
    "create": "Neues Angebot",
    "company": "Unternehmen",
    "category": "Kategorie",
    "status": "Status",
    "active": "Aktiv",
    "inactive": "Inaktiv",
    "save": "Speichern",
    "saved": "Profil gespeichert.",
    "error": "Fehler beim Speichern.",
    "noOffers": "Keine Angebote vorhanden.",
    "loading": "Wird geladen…",
    "offers": "Angebote",
    "preview": "Vorschau"
  },
  "guild_treasury": {
    "error": "Ein Fehler ist aufgetreten.",
    "requires_boost": "Zuerst {{name}} freischalten",
    "already": "Wurde bereits freigeschaltet.",
    "shop_eyebrow": "GILDEN-SHOP",
    "balance": "Verfügbarer Saldo",
    "catalog": "Freischaltungen & Katalog",
    "unlocked": "Freigeschaltet",
    "unlock": "Freischalten",
    "ledger": "Transaktionshistorie (Ledger)",
    "empty": "Noch keine Transaktionen vorhanden.",
    "reward": "Belohnung",
    "purchase": "Kauf",
    "after": "Bestand danach"
  },
  "guildGildexTreasury": {
    "balance": "Aktueller Bestand",
    "payout": "Ausschüttung",
    "history": "Buchungsverlauf",
    "empty": "Noch keine Transaktionen vorhanden.",
    "reason": "Zweck",
    "amount": "Betrag",
    "date": "Datum"
  },
  "adminHeroicActions": {
    "restartReview": "Neue Prüfrunde starten",
    "restartReviewPrompt": "Bisherige Stimmen bleiben in der Historie, zählen aber nicht mehr. Die neue Prüfrunde verwendet die aktuellen Freigabeschwellen. Eine Begründung ist optional.",
    "restartReviewReason": "Begründung (optional)",
    "restartReviewSuccess": "Neue Prüfrunde gestartet.",
    "returnSubmission": "Zur Überarbeitung zurückschicken",
    "returnReason": "Grund für die Rückgabe an den Nutzer:",
    "backToSubmissions": "← Zurück zu den Einreichungen",
    "submissionDetails": "Einreichung prüfen",
    "proofSection": "Nachweise und Gruppendaten",
    "decisionSection": "Prüfung und Entscheidung",
    "submitterTitle": "Einreichende Person",
    "reviewContextTitle": "Visitenkarte und Einreichungshistorie",
    "reviewContextLoading": "Visitenkarte wird geladen …",
    "reviewContextError": "Visitenkarte und Historie konnten nicht geladen werden.",
    "reviewContextForbidden": "Für diese Einreichung liegt keine gültige Prüfzuweisung vor.",
    "reviewContextRetry": "Erneut laden",
    "showRecentActions": "Letzte 10 gute Taten anzeigen",
    "hideRecentActions": "Letzte gute Taten ausblenden",
    "recentActionsTitle": "Letzte 10 eingereichte gute Taten",
    "noRecentActions": "Keine früheren Einreichungen vorhanden.",
    "similarActionsNotice_one": "Bei einer früheren Einreichung gibt es Ähnlichkeiten im Namen oder in der Beschreibung:",
    "similarActionsNotice_other": "Bei {{count}} früheren Einreichungen gibt es Ähnlichkeiten im Namen oder in der Beschreibung:",
    "similarityCaution": "Bitte Datum und Nachweise prüfen; Ähnlichkeit allein belegt keine Doppeleinreichung.",
    "similarFields": "Ähnlich: {{fields}}",
    "similarTitle": "Name",
    "similarDescription": "Beschreibung",
    "and": "und",
    "loadingDetails": "Einreichung wird geladen …",
    "submissionNotFound": "Diese Einreichung wurde nicht gefunden.",
    "tableTitle": "Einreichung",
    "deleteRewards": "Belohnungen beim Löschen",
    "chooseDeleteMode": "Bitte auswählen",
    "keepRewards": "Belohnungen behalten",
    "reverseRewards": "Belohnungen zurückrechnen",
    "deleteSubmission": "Einreichung löschen",
    "deleted": "Einreichung gelöscht.",
    "deleteConfirmation": "„{{title}}“ einschließlich Nachweisen und Prüfungen endgültig löschen?",
    "reviewUnavailable": {
      "own": "Eigene Einreichungen können nicht selbst bestätigt werden. Eine andere zugewiesene prüfende Person muss sie prüfen.",
      "evidence": "Bestätigung erst nach erfolgreichem Hochladen der Nachweise möglich.",
      "status": "Dieser Status erlaubt keine weitere Bestätigung.",
      "already": "Du hast in dieser Prüfrunde bereits abgestimmt. Ein System-Admin kann bei Bedarf eine neue Prüfrunde starten."
    },
    "reviewCategory": "Kategorie",
    "queueScope": "Ansicht",
    "allSubmissions": "Alle Einreichungen",
    "assignedSubmissions": "Mir zugewiesene Prüfungen",
    "submissionsCount": "Einreichungen",
    "noSubmissions": "Keine Einreichungen gefunden",
    "allSubmissionsHint": "Hier werden Einreichungen aller Nutzer und Status angezeigt, auch mit ausstehendem oder fehlgeschlagenem Upload.",
    "awaitingUploadHint": "Der Beweis-Upload ist noch nicht abgeschlossen. Die Einreichung ist noch nicht zur Prüfung freigegeben.",
    "submittedAt": "Eingereicht am",
    "submissionStatuses": {
      "AwaitingEvidence": "Beweis fehlt / Upload ausstehend",
      "PendingReview": "In Prüfung",
      "Approved": "Bestätigt",
      "Rejected": "Abgelehnt",
      "Returned": "Zur Überarbeitung zurückgeschickt",
      "Withdrawn": "Zurückgezogen",
      "Draft": "Entwurf"
    },
    "review": "Gute Tat prüfen",
    "approve": "Bestätigen",
    "reject": "Ablehnen",
    "reason": "Begründung für Ablehnung",
    "noPending": "Keine offenen Einreichungen vorhanden",
    "noActions": "Keine offenen Einreichungen vorhanden",
    "noMatchingActions": "Keine Einreichungen entsprechen deinen aktuellen Filterkriterien.",
    "noPendingDesc": "Derzeit liegen keine zugewiesenen guten Taten zur Prüfung vor. Neue Einreichungen erscheinen hier automatisch.",
    "error": "Fehler beim Laden der guten Taten.",
    "saving": "Wird gespeichert…",
    "allCategories": "Alle Kategorien",
    "allDifficulties": "Alle Einsatzstufen",
    "resetFilters": "Filter zurücksetzen",
    "filterTitle": "Filter & Suche",
    "activeFilters": "aktiv",
    "filtersOpen": "Filter ausklappen",
    "filtersClosed": "Filter einklappen",
    "search": "Suche",
    "category": "Kategorie",
    "difficulty": "Zeit und Einsatz",
    "pendingCount": "{{count}} Gute Taten zur Prüfung",
    "singlePendingCount": "1 Gute Tat zur Prüfung",
    "noApplications": "Keine offenen Bewerbungen vorhanden.",
    "noMotivation": "Keine Motivation angegeben.",
    "appeals": "Einsprüche",
    "appealStatusLabels": {
      "Pending": "Einspruch offen",
      "Approved": "Einspruch angenommen",
      "Rejected": "Einspruch abgelehnt"
    },
    "noAppeals": "Keine offenen Einsprüche vorhanden.",
    "by": "von",
    "appealRound": "Prüfungsrunde",
    "newReview": "Erneut prüfen",
    "dismiss": "Verwerfen",
    "actions": "Offene gute Taten",
    "group": "Gruppe",
    "reviews": "Prüfungen",
    "binding": "Verbindliche Ersteinstufung",
    "afterBonus": "Nach Boni",
    "guidanceMulti": "Mehrere Prüfungen erforderlich für endgültige Freigabe.",
    "guidanceSingle": "Einzelprüfung ausreichend.",
    "classifyApprove": "Einstufen & Bestätigen",
    "confirm": "Bestätigen",
    "adminRequired": "Admin-Prüfung",
    "rejectReason": "Begründung für Ablehnung:",
    "reviewFailed": "Prüfung fehlgeschlagen.",
    "approved": "Angenommen",
    "denied": "Abgelehnt",
    "applicationFailed": "Entscheidung über Bewerbung fehlgeschlagen.",
    "appealApprovePrompt": "Begründung für Neuprüfung:",
    "appealRejectPrompt": "Begründung für Ablehnung des Einspruchs:",
    "appealFailed": "Entscheidung über Einspruch fehlgeschlagen."
  },
  "adminAppeals": {
    "title": "Einsprüche",
    "intro": "Offene Einsprüche gegen abgelehnte gute Taten.",
    "detailTitle": "Einspruch entscheiden",
    "back": "Alle Einsprüche",
    "pending": "Einspruch offen",
    "submitted": "Eingereicht am",
    "reason": "Begründung des Einspruchs",
    "viewSubmission": "Einreichung ansehen",
    "open": "Fall öffnen",
    "loading": "Einsprüche werden geladen …",
    "loadFailed": "Einsprüche konnten nicht geladen werden.",
    "noLongerPending": "Dieser Einspruch ist nicht mehr offen.",
    "accepted": "Der Einspruch wurde angenommen. Eine neue Prüfrunde beginnt.",
    "dismissed": "Der Einspruch wurde abgelehnt."
  },
  "quick_heroic_action": {
    "ability_available": "Diese Woche verfügbar.",
    "ability_used": "Verbraucht. Wieder verfügbar: {{date}}.",
    "back_to_dashboard": "← Dashboard",
    "eyebrow": "Gute Tat",
    "title": "Schnelleinreichung",
    "intro": "Nimm ein Bild oder Video auf, beschreibe es kurz und schicke es ab.",
    "notice": "Schnelleinreichungen können niedriger bewertet werden oder länger zur Verifizierung brauchen.",
    "recovery_error": "Deine letzte Einreichung konnte nicht geprüft werden. Öffne „Meine Einreichungen“, bevor du eine neue erstellst.",
    "invalid_file_type": "Bitte ein JPG-, PNG-, WebP-Bild oder MP4-Video auswählen.",
    "file_too_large": "Die Datei darf maximal 10 MB groß sein.",
    "evidence_missing": "Die Einreichung wurde erstellt, aber der Nachweis fehlt noch: {{message}}",
    "submission_failed": "Einreichung fehlgeschlagen.",
    "created_resume": "Deine Einreichung wurde bereits erstellt. Wähle die Nachweisdatei erneut aus, um den Upload fortzusetzen.",
    "success_title": "Einreichung abgeschickt",
    "success_body": "Dein Nachweis wurde hochgeladen und die gute Tat wird geprüft.",
    "view_submissions": "Meine Einreichungen ansehen",
    "evidence_heading": "Bild oder Video",
    "take_photo": "Foto aufnehmen",
    "record_video": "Video aufnehmen",
    "choose_file": "Datei auswählen",
    "description_label": "Kurze Beschreibung",
    "description_placeholder": "Was hast du getan?",
    "submitting": "Wird abgeschickt …",
    "retry_upload": "Nachweis erneut hochladen",
    "submit": "Jetzt abschicken",
    "manage_submission": "Einreichung und Nachweis dort verwalten",
    "full_form": "Ausführliche Gute Tat einreichen"
  },
  "heroicActions": {
    "draft": "Entwurf",
    "returnReason": "Grund für die Rückgabe",
    "addEvidenceOptional": "Weitere Nachweise ergänzen (optional)",
    "selectedUploadsHint": "Alle ausgewählten Dateien werden gemeinsam eingereicht. Du kannst weitere Nachweisarten ergänzen.",
    "choosePdfFiles": "PDF-Dokumente auswählen",
    "choosePhotos": "Fotos auswählen",
    "fileTypeMismatch": "Bitte wähle Dateien passend zum ausgewählten Nachweistyp.",
    "removeEvidence": "Nachweis entfernen",
    "removeEvidenceConfirm": "„{{name}}“ endgültig entfernen? Das Löschen gilt sofort, auch wenn du die Bearbeitung anschließend abbrichst.",
    "existingEvidence": "Bisherige Nachweise",
    "existingEvidenceHint": "Diese Nachweise bleiben beim Zurückziehen erhalten und werden bei erneuter Einreichung wieder verwendet. Du kannst weitere Dateien ergänzen.",
    "chooseFiles": "Fotos / Dateien auswählen",
    "removeFile": "Entfernen",
    "selectFilesFirst": "Bitte wähle mindestens eine Datei aus. Danach kannst du den Beweis hochladen.",
    "remainingEvidence": "Ein Teil der Beweise wurde hochgeladen. Die übrigen Dateien kannst du hier erneut hochladen.",
    "uploading": "Beweise werden hochgeladen …",
    "title": "Gute Tat",
    "back_to_overview": "Zur Übersicht guter Taten",
    "rules_title": "Hinweise & Regeln",
    "submissions_title": "Deine Einreichungen",
    "start_title": "Gute Tat starten",
    "pageSubtitle": "Kleine Taten. Große Wirkung.",
    "subtitle": "Auch kleine Hilfen zählen: jemandem zuhören, beim Tragen helfen oder Wissen teilen. Trage deine gute Tat ein.",
    "create": "Neue gute Tat",
    "newWithSlots": "Neue gute Tat ({{occupied}} / {{maximum}})",
    "newWithSlotsHint": "{{free}} freie Slots, {{occupied}} belegte Slots",
    "slots_full_title": "Gute Tat",
    "slots_full_banner_hint": "Entwurf möglich: Jetzt speichern und später einreichen.",
    "titlePlaceholder": "Titel",
    "descriptionPlaceholder": "Was hast du getan?",
    "estimate": "Schätze Zeit und Planung grob ein. Das Team prüft deine Angaben später.",
    "selfReport": "Kein visueller Nachweis",
    "photo": "Foto",
    "photoGps": "Foto mit Standort",
    "document": "Dokument",
    "privacy": "Ich bestätige, dass der Beweis keine unbeteiligten Personen, Kennzeichen, privaten Adressen oder sensiblen Dokumente zeigt. Die Datei wird verschlüsselt und nach Ablauf der Aufbewahrungsfrist gelöscht.",
    "submitting": "Wird eingereicht…",
    "submit": "Gute Tat einreichen",
    "privacyRequired": "Bitte Beweisdatei auswählen und die Datenschutzregeln bestätigen.",
    "gpsRequired": "Bitte aktiviere zuerst die GPS-Ortung.",
    "gpsActivate": "GPS-Ortung aktivieren",
    "gpsLoading": "Standort wird ermittelt…",
    "gpsReady": "GPS-Standort erfasst",
    "gpsError": "Standort konnte nicht ermittelt werden. Prüfe die Browserfreigabe und versuche es erneut.",
    "gpsUnsupported": "GPS wird von diesem Browser nicht unterstützt.",
    "dropTitle": "Datei hier ablegen",
    "dropHint": "oder klicken, um eine Datei auszuwählen",
    "selectedFile": "Ausgewählt",
    "submitted": "Gute Tat eingereicht und wartet auf Prüfung.",
    "successEyebrow": "Geschafft",
    "successTitle": "Gute Tat eingereicht!",
    "successDescription": "„{{title}}“ wurde erfolgreich eingereicht.",
    "successStatus": "Deine gute Tat wartet jetzt auf Prüfung.",
    "viewSubmission": "Einreichung ansehen",
    "closeSuccess": "Erfolgsmeldung schließen",
    "submitFailed": "Gute Tat konnte nicht eingereicht werden.",
    "mine": "Meine Einreichungen",
    "empty": "Noch keine guten Taten eingereicht.",
    "estimateShort": "Richtwert",
    "statusOpen": "Offen",
    "statusOpenOption": "Offen (In Prüfung & Nachweis)",
    "approved": "Bestätigt",
    "awaitingEvidence": "Die Einreichung ist gespeichert. Der Beweis-Upload ist noch nicht abgeschlossen.",
    "upload": "Beweis hochladen",
    "uploaded": "Beweis verschlüsselt hochgeladen.",
    "uploadFailed": "Upload fehlgeschlagen.",
    "appealPrompt": "Begründe deinen Einspruch (mindestens 20 Zeichen)",
    "appealSubmitted": "Einspruch eingereicht.",
    "appealFailed": "Einspruch konnte nicht eingereicht werden.",
    "appeal": "Einspruch einlegen",
    "appealStatus": "Einspruch",
    "erneut_versuchen": "Erneut versuchen",
    "details_erg_nzen_und": "Details ergänzen und erneut einreichen",
    "zur_ck": "Zurück",
    "einmalig_reparieren": "Einmalig reparieren",
    "abbrechen": "Abbrechen",
    "reparatur_bereits_ve": "Reparatur bereits verwendet.",
    "ich_lade_anschlie_en": "Ich lade anschließend einen neuen Nachweis hoch.",
    "setze_ein_zeichen_in": "Setze ein Zeichen für andere.",
    "berarbeite_die_anga": "Überarbeite die Angaben. Ohne neue Datei wird der vorhandene Nachweis weiterverwendet.",
    "zur_ckgezogene_einre": "Zurückgezogene Einreichung",
    "nachweistyp": "Nachweistyp",
    "einstufung": "Einstufung",
    "w_hle_deine_kategori": "Wähle deine Kategorie und dokumentiere deine Tat.",
    "fehlende_nachweise_k": "Fehlende Nachweise kannst du bei der betreffenden Einreichung ergänzen. Bei einer Ablehnung kannst du dort einen begründeten Einspruch einreichen.",
    "zeitpunkt_der_helden": "Zeitpunkt der guten Tat",
    "filterTitle": "Filter & Suche",
    "searchPlaceholder": "Beschreibung oder Titel durchsuchen…",
    "allCategories": "Alle Kategorien",
    "category": "Kategorie",
    "filterDate": "Datum",
    "allDates": "Alle Zeiträume",
    "dateToday": "Heute",
    "dateWeek": "Letzte 7 Tage",
    "dateMonth": "Letzte 30 Tage",
    "dateYear": "Dieses Jahr",
    "dateCustom": "Benutzerdefiniert",
    "dateFrom": "Von",
    "dateTo": "Bis",
    "sort": "Sortierung",
    "sortDateDesc": "Datum (Neueste zuerst)",
    "sortDateAsc": "Datum (Älteste zuerst)",
    "status": "Status",
    "allStatuses": "Alle Status",
    "resetFilters": "Filter zurücksetzen",
    "activeFilters": "Aktive Filter:",
    "filterCount": "{{count}} von {{total}} Einreichungen",
    "noMatchingActions": "Keine Einreichungen entsprechen den ausgewählten Filterkriterien.",
    "calculation": "Berechnung",
    "breakdown": {
      "event": "System-Event",
      "party": "Gruppenbonus",
      "partyTalent": "Gruppentalent",
      "partyCap": "Gruppenbonus auf 50 % begrenzt",
      "reconstructed": "Der persönliche Anteil wurde rekonstruiert; die tatsächliche Gutschrift steht darunter.",
      "personalModifier": "{{name}}: {{percent}} auf den persönlichen Anteil",
      "personalFormula": "Persönliche Rechnung: ⌊{{share}} × (1 + {{percent}} %)⌋",
      "soloFormula": "Rechnung: ⌊{{base}} × {{event}} × (1 + {{percent}} %)⌋"
    }
  },
  "heroicActionXpGuide": {
    "difficulty": "Zeit und Einsatz",
    "complexity": "Planung und Abstimmung",
    "example": "Beispiel",
    "assessment": "Einstufung",
    "reason": "Begründung",
    "footer": "Nicht belohnt werden Spenden- oder Warenwert, gefährliches Verhalten oder ein bestimmtes Ergebnis einer Behördenmeldung. Bewertet werden nur der belegte eigene Einsatz, die nachvollziehbare Durchführung und die erforderliche Planung und Abstimmung. Beweisfotos sollen unbeteiligte Personen, Kennzeichen und private Adressen vermeiden.",
    "simpleDifficulty": "Wie viel Zeit und Einsatz?",
    "simpleComplexity": "Wie viel Planung und Abstimmung?",
    "assessmentHint": "Wähle die ungefähre Einschätzung. Das Team prüft sie später.",
    "close": "Schließen",
    "groupOnly": "Nur Gruppenaktionen",
    "groupBandTitle": "Gruppenband {{band}}",
    "bandTitle": "Band {{band}}",
    "groupExamples": [
      {
        "title": "Gemeinsam einen kleinen Parkabschnitt säubern",
        "difficulty": "LOW",
        "complexity": "SIMPLE",
        "rationale": "Kurze gemeinsame Aufgabe mit dokumentiertem Ergebnis.",
        "band": 1
      },
      {
        "title": "Als Team einen Nachbarschaftsgarten pflegen",
        "difficulty": "MEDIUM",
        "complexity": "SIMPLE",
        "rationale": "Spürbarer gemeinsamer Einsatz ohne aufwendige Abstimmung.",
        "band": 2
      },
      {
        "title": "Lebensmittel gemeinsam abholen und verteilen",
        "difficulty": "MEDIUM",
        "complexity": "COORDINATED",
        "rationale": "Abholung, Helfende und Übergabe werden abgestimmt.",
        "band": 3
      },
      {
        "title": "Einen gemeinsamen Reparaturtag vorbereiten",
        "difficulty": "HIGH",
        "complexity": "COORDINATED",
        "rationale": "Mehrstündige Teamarbeit mit Material und abgestimmtem Ablauf.",
        "band": 4
      },
      {
        "title": "Eine größere Sammelaktion mit Transport durchführen",
        "difficulty": "HIGH",
        "complexity": "COMPLEX",
        "rationale": "Mehrere Zuständigkeiten, Wege und Empfänger müssen zusammenpassen.",
        "band": 5
      },
      {
        "title": "Ein längerfristiges Hilfsprojekt als Team durchführen",
        "difficulty": "EXCEPTIONAL",
        "complexity": "COMPLEX",
        "rationale": "Mehrere Tage oder Termine mit dokumentierten Beiträgen und Planung.",
        "band": 6
      },
      {
        "title": "Eine Gemeinschaftsfläche an mehreren Arbeitstagen aufwerten",
        "difficulty": "EXTENSIVE",
        "complexity": "COMPLEX",
        "rationale": "Umfangreicher belegter Einsatz des Teams mit Material- und Arbeitsplanung.",
        "band": 7
      },
      {
        "title": "Ein mehrphasiges Gemeinschaftsprojekt mit mehreren Stellen abschließen",
        "difficulty": "EXTENSIVE",
        "complexity": "MULTISTAGE",
        "rationale": "Erheblicher Einsatz mit abhängigen Phasen, mehreren Teams und belegten Übergaben.",
        "band": 8
      }
    ]
  },
  "guild_administration": {
    "name_placeholder": "z. B. Schattenwächter des Nordens",
    "latitude": "Breitengrad (Lat)",
    "longitude": "Längengrad (Lng)",
    "latitude_placeholder": "z. B. 48.2082",
    "longitude_placeholder": "z. B. 16.3738",
    "saving": "Wird gespeichert...",
    "save_profile": "Stammdaten & Standort speichern",
    "latitude_invalid": "Bitte gib einen gültigen Breitengrad (-90 bis 90) an.",
    "longitude_invalid": "Bitte gib einen gültigen Längengrad (-180 bis 180) an.",
    "save_failed": "Speichern fehlgeschlagen.",
    "forging": "Schmiede...",
    "discard_emblem_changes": "Änderungen verwerfen",
    "forge_shop_link": "Erweiterung im Shop ansehen",
    "theme_current": "Aktuelle Ansicht",
    "theme_in_use": "In Verwendung",
    "theme_to_shop": "Im Shop ansehen",
    "theme_select": "Stil verwenden",
    "theme_default": "Standard-Feste",
    "theme_forest_description": "Eine warme Halle zwischen Bäumen und moosigen Mauern.",
    "theme_celestial_description": "Ein prachtvoller Raum voller Licht und Sternenglanz.",
    "active": "Aktiv",
    "available_default": "Verfügbar (Standard)",
    "unlocked": "Freigeschaltet",
    "locked": "Gesperrt",
    "applications_title": "Offene Beitritts-Bewerbungen ({{count}})",
    "no_applications": "Keine offenen Bewerbungen vorhanden.",
    "application_approved": "Bewerbung von \"{{name}}\" wurde angenommen.",
    "application_denied": "Bewerbung von \"{{name}}\" wurde abgelehnt.",
    "application_blocked": "Bewerbung von \"{{name}}\" wurde dauerhaft blockiert.",
    "action_failed": "Aktion fehlgeschlagen.",
    "submitted_at": "Eingereicht: {{date}}",
    "block_user_title": "Benutzer dauerhaft sperren",
    "banned_since": "Gesperrt seit: {{date}}",
    "unbanning": "Wird entsperrt...",
    "unban": "Sperre aufheben",
    "ban_failed": "Bann fehlgeschlagen.",
    "unban_success": "Sperre für \"{{name}}\" wurde erfolgreich aufgehoben.",
    "unban_failed": "Entbannen fehlgeschlagen."
  },
  "guildDetail": {
    "heroic_actions": "Gute Taten",
    "member_directory": "Mitglieder-Verzeichnis",
    "roster_flyout": "Mitglieder ({{count}})",
    "roster_page": "{{count}} Mitglieder · Seite {{page}} / {{total}}",
    "lade_verbannungen": "Lade Verbannungen...",
    "lade_bewerbungen": "Lade Bewerbungen...",
    "nachfolger_ernennen": "Nachfolger ernennen",
    "keine_offenen_bewerb": "Keine offenen Bewerbungen.",
    "abbrechen": "Abbrechen",
    "anpassen": "Anpassen",
    "kicken": "Kicken",
    "bannen": "Bannen",
    "annehmen": "Annehmen",
    "blockieren": "Blockieren",
    "mitglieder_suchen": "Mitglieder suchen",
    "keine_mitglieder_gef": "Keine Mitglieder gefunden.",
    "ablehnen": "Ablehnen",
    "name_eingeben_placeholder": "Name eingeben"
  },
  "adminClassCategoryManager": {
    "noch_keine_perks_zug": "Noch keine Perks zugewiesen.",
    "lucide_icon_name": "Lucide Icon Name",
    "perk_speichern": "Perk Speichern",
    "lade_kategorien": "Lade Kategorien...",
    "abbrechen": "Abbrechen",
    "speichern": "Speichern",
    "alle_kategorien": "Alle Kategorien",
    "keine_kategorien_vor": "Keine Kategorien vorhanden.",
    "anzeigename": "Anzeigename",
    "neue_kategorie": "Neue Kategorie",
    "inaktiv": "Inaktiv",
    "beschreibung": "Beschreibung",
    "perk_hinzuf_gen": "Perk hinzufügen",
    "entfernen": "Entfernen",
    "aktiv_im_system": "Aktiv im System",
    "einmalige_reparatur": "Einmalige Reparatur",
    "beschreibung_was_zu_placeholder": "Beschreibung was zu dieser Kategorie gehört...",
    "shield_compass_zap_placeholder": "Shield, Compass, Zap..."
  },
  "gameMechanics": {
    "how": "How",
    "goodvale": "Goodvale",
    "verschl_sselt": "Verschlüsselt",
    "works": "Works",
    "zum_dashboard": "Zum Dashboard",
    "kein_geldwert": "Kein Geldwert",
    "keine_tokens": "Keine Tokens",
    "unabh_ngig": "Unabhängig",
    "fristgerechte_l_schu": "Fristgerechte Löschung",
    "jetzt_registrieren": "Jetzt registrieren",
    "mehrheitsbeschluss": "Mehrheitsbeschluss",
    "nicht_kommerziell": "Nicht-kommerziell",
    "so_funktioniert": "So funktioniert",
    "perk": "Perk",
    "einspruchsrecht": "Einspruchsrecht",
    "keine_bezahlten_auft": "Keine bezahlten Aufträge",
    "rein_dekorativ": "Rein dekorativ",
    "nulltoleranz_f_r_man": "Nulltoleranz für Manipulation",
    "heldentat_starten": "Gute Tat starten"
  },
  "guildMembersAdmin": {
    "fehler_beim_laden": "Fehler beim Laden",
    "lade_offene_bewerbun": "Lade offene Bewerbungen...",
    "abbrechen": "Abbrechen",
    "blockieren": "Blockieren",
    "kicken": "Kicken",
    "mitglieder": "Mitglieder",
    "ablehnen": "Ablehnen",
    "bannen": "Bannen",
    "annehmen": "Annehmen",
    "keine_offenen_bewerb": "Keine offenen Bewerbungen"
  },
  "systemEvents": {
    "status_start": "Beginn",
    "status_end": "Ende",
    "status_on_day": "Läuft",
    "erneut_versuchen": "Erneut versuchen",
    "keine_passenden_even": "Keine passenden Events verfügbar. Du kannst jederzeit eine freie gute Tat dokumentieren.",
    "alle_kategorien": "Alle Kategorien",
    "events_konnten_nicht": "Events konnten nicht geladen werden.",
    "current_system_events": "Aktuelle System-Events",
    "title": "Event-Kalender & System-Events",
    "subtitle": "Übersicht aller weltweiten Kampagnen, Boni und Termine",
    "show_all_events": "Alle Events anzeigen →",
    "tab_all": "Alle Events",
    "tab_active": "Jetzt Aktiv",
    "tab_upcoming": "Demnächst",
    "tab_past": "Beendet",
    "category_select_label": "Event-Kategorie",
    "loading": "Events werden geladen …",
    "prev_month": "Vorheriger Monat",
    "next_month": "Nächster Monat",
    "today_button": "Heute: {{date}}",
    "legend_start": "Start",
    "legend_end": "Ende",
    "legend_active": "Aktiv",
    "weekdays": [
      "Mo",
      "Di",
      "Mi",
      "Do",
      "Fr",
      "Sa",
      "So"
    ],
    "today": "Heute",
    "today_upper": "HEUTE",
    "more_events": "+{{count}} weitere",
    "click_for_day": "Klicken für Tagesübersicht →",
    "today_selected": "✦ Heute ausgewählter Tag",
    "selected_date": "Ausgewähltes Datum",
    "active_events_count_one": "1 Event aktiv",
    "active_events_count_other": "{{count}} Events aktiv",
    "marked_in_calendar": "Im Kalender markiert",
    "clear_mark": "Markierung aufheben",
    "highlighted_badge": "Markiert",
    "details": "Details →",
    "no_events_on_day": "An diesem Tag finden keine aktiven System-Events statt.",
    "back_to_today": "Zurück zum heutigen Tag ({{date}}) →",
    "status_active": "Aktiv",
    "status_upcoming": "Bald",
    "status_ended": "Beendet",
    "page_title": "Events",
    "page_subtitle": "Gemeinsam etwas bewegen.",
    "page_description": "Entdecke aktuelle Aktionen, ihre Bedingungen und die Möglichkeiten, einen Beitrag zu leisten.",
    "back_to_all_events": "← Alle Events",
    "back_to_heroic_actions": "← Gute Tat",
    "event_load_error": "Dieses Event konnte nicht geladen werden.",
    "event_loading": "Event wird geladen …",
    "your_task": "Deine Aufgabe",
    "reward_and_participation": "Belohnung & Teilnahme",
    "max_submissions": "Maximal {{count}} Einreichungen pro Person.",
    "terms_apply": "Teilnahme gemäß den Eventbedingungen.",
    "notes_and_evidence": "Hinweise & Nachweis",
    "default_safety_rules": "Dokumentiere deinen eigenen Beitrag nachvollziehbar. Die Einreichung wird geprüft.",
    "verification_method": "Nachweisverfahren",
    "evidence_review": "Prüfung der eingereichten Nachweise",
    "submit_action_for_event": "Gute Tat einreichen →",
    "participation_starts_at_date": "Die Teilnahme beginnt zum angegebenen Starttermin.",
    "event_is_ended": "Dieses Event ist beendet."
  },
  "worldMapView": {
    "mitglieder": "Mitglieder",
    "legende": "Legende",
    "ber_diesen_ort": "Über diesen Ort",
    "alle": "Alle",
    "kategorie": "Kategorie",
    "einige_kartenkacheln": "Einige Kartenkacheln konnten nicht geladen werden. Prüfe deine Verbindung und verschiebe oder vergrößere die Karte, um weitere Kacheln zu laden.",
    "kartenfilter": "Kartenfilter",
    "keine": "Keine",
    "openstreetmap": "OpenStreetMap",
    "partners": "Partner",
    "locating": "Standort wird ermittelt …",
    "location_centered": "Karte auf deinen Standort zentriert.",
    "location_unavailable": "Standort nicht verfügbar. Du kannst die Karte weiterhin frei bewegen.",
    "my_location": "Mein Standort",
    "locations_count": "{{count}} Orte",
    "partner_offer_type": "Partnerangebot",
    "partner_offers_at_location": "Angebote an diesem Standort",
    "offer_by": "Angebot von: {{name}}",
    "requirements": "Freischaltbedingungen",
    "leader_prefix": "Leitung: {{name}}",
    "no_description": "Für diesen Ort ist noch keine Beschreibung hinterlegt.",
    "interactive_map": "Interaktive Weltkarte",
    "map_tools": "Karteninformationen und Filter",
    "location_details": "Ortsdetails",
    "close_details": "Ortsdetails schließen",
    "discover_world": "Entdecke die Welt",
    "view_partner": "Partnerseite & Angebote ansehen"
  },
  "partnerDetail": {
    "offer_unavailable": "Angebot oder Partnerbetrieb existiert nicht oder ist derzeit inaktiv.",
    "onsite_only": "Dieses Angebot unterstützt keine digitale Einlösung (nur Vor-Ort).",
    "opening_contact_notice": "Es gelten die Öffnungszeiten des Partners. Bitte nimm bei Bedarf selbst Kontakt auf.",
    "title": "Partnerbetrieb",
    "digital_error": "Einlösung fehlgeschlagen.",
    "redeem_digital_btn": "Digital einlösen",
    "digital_redemption_title": "Digitale Einlösung",
    "redeeming": "Gutschein wird eingelöst …",
    "redeem_failed": "Einlösung nicht möglich",
    "close": "Schließen",
    "redeem_success": "Erfolgreich eingelöst!",
    "your_coupon_code": "Dein Gutscheincode",
    "copied": "Kopiert!",
    "copy_code": "Code kopieren",
    "instructions": "Einlösehinweise",
    "open_webshop": "Webshop / Website öffnen",
    "done": "Fertig",
    "back": "Zurück",
    "back_to_map": "Zur Weltkarte",
    "loading": "Lade Partnerdetails …",
    "load_error": "Partnerbetrieb konnte nicht geladen werden.",
    "not_found_title": "Partner nicht gefunden",
    "not_found_desc": "Dieser Partnerbetrieb existiert nicht oder ist derzeit inaktiv.",
    "verified_partner": "Verifizierter Partnerbetrieb",
    "view_on_map": "Auf der Weltkarte anzeigen",
    "show_qr_pass": "Mein QR-Pass",
    "partner_since": "Partner seit {{date}}",
    "no_offers_title": "Keine aktiven Angebote",
    "no_offers_desc": "Dieser Partnerbetrieb hat zurzeit keine aktiven Angebote oder Rabattaktionen eingestellt. Schau bald wieder vorbei!",
    "location": "Standort & Anfahrt",
    "coordinates": "Koordinaten",
    "open_google_maps": "In externen Karten öffnen",
    "how_to_redeem_title": "Angebot vor Ort einlösen",
    "open_pass_btn": "QR-Pass anzeigen"
  },
  "heroicOverview": {
    "all_submissions": "Alle Einreichungen",
    "drafts": "Entwürfe",
    "draft": "Entwurf",
    "no_submissions": "Noch keine Einreichungen vorhanden.",
    "no_drafts": "Keine Entwürfe vorhanden.",
    "show_drafts": "Entwürfe anzeigen",
    "letzte_heldentaten": "Letzte gute Taten",
    "keine_heldentaten": "Noch keine bestätigten guten Taten vorhanden.",
    "alle_heldentaten_a": "Alle bestätigten guten Taten anzeigen",
    "offene_einreichungen_anzeigen": "Offene Einreichungen anzeigen",
    "nachweise_sorgf_ltig": "Nachweise sorgfältig auswählen",
    "lade_deinen_nachweis": "Lade deinen Nachweis zur passenden guten Tat hoch. Wähle dafür eine offene Einreichung aus.",
    "erhaltene_belohnunge": "Erhaltene Belohnungen",
    "offene_einreichungen": "Offene Einreichungen",
    "alle_einreichungen_a": "Alle Einreichungen anzeigen",
    "r_ckfragen_zur_pr_fu": "Rückfragen zur Prüfung beantworten",
    "keine_offenen_einrei": "Keine offenen Einreichungen. Bereit für deine nächste gute Tat?",
    "alle_regeln_anzeigen": "Alle Regeln anzeigen",
    "nachweis_hochladen": "Nachweis hochladen",
    "eigene_beitr_ge_doku": "Eigene Beiträge dokumentieren",
    "loading_submissions": "Einreichungen werden geladen …",
    "awaiting_evidence": "Nachweis erforderlich",
    "pending_review": "In Prüfung",
    "upload_evidence": "Nachweis hochladen",
    "progress_loading": "Fortschritt wird geladen.",
    "confirmed_actions_count": "{{count}} bestätigte gute Taten. Jeder Beitrag zählt.",
    "guidance_and_rules": "Hinweise & Regeln"
  },
  "guild_overview": {
    "announcements_and_actions": "Ankündigungen & Gute Taten",
    "show_all": "Alle anzeigen →",
    "loading_announcements": "Ankündigungen werden geladen …",
    "no_announcements": "Noch keine Ankündigungen.",
    "max_stage_reached": "Eure Halle hat ihre höchste Ausbaustufe erreicht.",
    "view_stages_decorations": "Ausbaustufen & Dekorationen ansehen",
    "group_activity": "Gruppenaktivität",
    "filter_total": "Gesamt",
    "filter_year": "Dieses Jahr",
    "filter_week": "Diese Woche",
    "heroic_actions": "Gute Taten",
    "group_heroic_actions": "Gruppenaktionen",
    "all_members_total": "Bestätigte Beiträge gesamt.",
    "year_members_total": "Bestätigte Beiträge in diesem Jahr.",
    "week_members_total": "Bestätigte Beiträge seit Montag.",
    "show_all_members": "Alle Mitglieder anzeigen →",
    "loading": "Wird geladen …",
    "retry": "Erneut versuchen",
    "ep_boost_level": "Stufe {{level}}",
    "ep_boost_stage": "Stufe {{current}} von {{max}}"
  },
  "guild_hall_stage": {
    "default_theme": "Feste",
    "default_theme_tooltip": "Standardhalle",
    "forest_theme": "Wald",
    "celestial_theme": "Sterne",
    "notice_board_aria": "Anschlagtafel: Ankündigungen und gute Taten",
    "notice_board_sprite_alt": "Anschlagtafel",
    "notice_board_title": "Anschlagtafel",
    "profile_wall_sprite_alt": "Profilwand",
    "profile_wall_title": "Mitglieder ({{count}})",
    "trophy_shelf_aria": "Trophäenregal",
    "trophy_shelf_sprite_alt": "Trophäenregal",
    "trophy_shelf_unlocked": "Trophäenkammer",
    "chest_sprite_alt": "Schatztruhe",
    "shop_stall_sprite_alt": "Kaufmannsstand",
    "stammtisch_sprite_alt": "Stammtisch",
    "group_table_aria": "Konferenztisch für Gruppenaktionen",
    "group_table_sprite_alt": "Konferenztisch",
    "admin_desk_sprite_alt": "Verwaltungspult"
  },
  "system_admin": {
    "console_title": "System-Admin Konsole",
    "system_admin": "Systemadministration",
    "admin_view": "Admin-Ansicht"
  },
  "partner_portal": {
    "pos": "Einlösen",
    "manage_offers": "Angebote verwalten",
    "redemptions": "Einlösungshistorie",
    "my_profile": "Partner-Profil",
    "settings": "Einstellungen",
    "categorization": "Kategorisierung",
    "b2b_dashboard": "Partner-Dashboard",
    "verified_partner": "Verifizierter Partner",
    "partner_view": "Partner-Ansicht",
    "console_title": "Partner-Dashboard"
  },
  "partner_redemptions": {
    "title": "Einlösungshistorie",
    "load_error": "Einlösungshistorie konnte nicht geladen werden.",
    "loading": "Lade Einlösungen …",
    "stat_total": "Gesamte Einlösungen",
    "stat_onsite": "Vor Ort (POS)",
    "stat_digital": "Remote / Digital",
    "filter_all": "Alle",
    "filter_onsite": "Vor Ort",
    "filter_digital": "Digital",
    "mode_onsite": "Vor Ort (POS)",
    "mode_digital": "Remote / Digital",
    "code_label": "Code",
    "status_confirmed": "Bestätigt",
    "no_matching_results": "Keine Einlösungen für diese Filter gefunden.",
    "try_reset_filter": "Passe deine Suchbegriffe an oder wähle einen anderen Filter.",
    "no_redemptions_yet": "Noch keine Einlösungen vorhanden."
  },
  "partner_profile": {
    "title": "Partner-Profil & Standort",
    "subtitle": "Verwalte dein Unternehmensprofil, Logo, Banner und Standort auf der Weltkarte.",
    "view_public_page": "Öffentliche Ansicht",
    "view_on_map": "Auf Karte zeigen",
    "change_banner": "Banner ändern",
    "reset_banner": "Standardbanner",
    "banner_saved": "Banner erfolgreich gespeichert.",
    "banner_reset": "Standardbanner wiederhergestellt.",
    "banner_error": "Banner konnte nicht geändert werden.",
    "change_logo": "Logo ändern",
    "verified_partner": "Verifizierter Partnerbetrieb",
    "pending_review": "In Prüfung (Wartet auf Freischaltung)",
    "partner_since": "Partner seit {{date}}",
    "company_default": "Partnerbetrieb",
    "basic_info": "Unternehmensdaten & Branche",
    "company_name": "Firmenname / Geschäftsname *",
    "company_required": "Bitte gib einen Firmennamen an.",
    "category": "Hauptbranche / Kategorie *",
    "vat_id": "UID / Steuernummer (optional)",
    "partner_id": "Partner-Kennung",
    "bio": "Über dieses Unternehmen / Beschreibung",
    "location_title": "Standort auf der Weltkarte",
    "location_desc": "Bestimmt, wo dein Partnerbetrieb und deine Angebote auf der interaktiven Weltkarte angezeigt werden.",
    "latitude": "Breitengrad (Latitude)",
    "longitude": "Längengrad (Longitude)",
    "invalid_lat": "Ungültiger Breitengrad (-90 bis 90).",
    "invalid_lng": "Ungültiger Längengrad (-180 bis 180).",
    "saved_success": "Partnerprofil erfolgreich gespeichert.",
    "save_failed": "Partnerprofil konnte nicht gespeichert werden.",
    "save_changes": "Änderungen speichern",
    "saving": "Speichert …",
    "loading": "Lade Partner-Profil …",
    "load_error": "Partnerprofil konnte nicht geladen werden."
  },
  "partner_settings": {
    "title": "Partner-Einstellungen",
    "subtitle": "Sicherheit, Passwort, Sprache, Farbschema und Datenverwaltung für dein Partnerkonto.",
    "password_desc": "Aktualisiere das Passwort für deinen B2B-Partnerzugang.",
    "preferences_desc": "Passe die Benutzeroberfläche und die Sprache an deine Wünsche an.",
    "data_rights_desc": "Exportiere deine Daten oder schließe dein Partnerkonto dauerhaft.",
    "delete_account": "Partnerkonto schließen & löschen",
    "delete_confirm": "Möchtest du dieses Partner-Konto wirklich dauerhaft schließen und anonymisieren? Alle erstellten Angebote werden gelöscht.",
    "saving": "Wird geändert …",
    "exporting": "Exportiere …",
    "deleting": "Wird gelöscht …"
  },
  "mapPage": {
    "loading": "Karte wird geladen …",
    "error": "Die Orte konnten nicht geladen werden.",
    "retry": "Erneut versuchen"
  },
  "audit_ui": {
    "banner_saved": "Banner gespeichert.",
    "banner_save_error": "Banner konnte nicht gespeichert werden.",
    "banner_reset": "Standardbanner wiederhergestellt.",
    "banner_reset_error": "Banner konnte nicht zurückgesetzt werden.",
    "history_error": "Die Chronik konnte nicht geladen werden.",
    "saving": "Wird gespeichert …",
    "banner_change": "Banner ändern",
    "reset": "Zurücksetzen",
    "cancelConfirmTitle": "Aktion abbrechen?",
    "cancelConfirm": "Möchtest du „{{title}}“ wirklich abbrechen?",
    "delete": "Löschen",
    "deleteConfirmTitle": "Löschen?",
    "deleteConfirm": "Möchtest du „{{title}}“ wirklich löschen? Dieser Schritt kann nicht rückgängig gemacht werden.",
    "changing": "Wird geändert …",
    "close_hall_image": "Bild schließen",
    "member": "Mitglied",
    "members": "Mitglieder",
    "noticeboard": "Am schwarzen Brett",
    "news_loading": "Aushänge werden geladen …",
    "news_error": "Aushänge sind gerade nicht verfügbar.",
    "news_empty": "Platz für eure nächste Geschichte.",
    "unavailable": "Derzeit nicht verfügbar",
    "community": "Ein Zuhause für eure Gemeinschaft",
    "together": "Gemeinsam mehr erleben",
    "unlockable": "Freischaltbar",
    "shop_description": "Neue Räume, Hallendesigns und gemeinsame Vorteile entdecken.",
    "to_shop": "Zum Shop",
    "manage": "Verwaltung",
    "meet_members": "{{count}} Mitglieder kennenlernen",
    "room": {
      "news": {
        "title": "Anschlagtafel"
      },
      "stammtisch": {
        "title": "Stammtisch",
        "description": "Ankommen, austauschen, gemeinsam planen"
      },
      "roster": {
        "title": "Mitgliedergalerie"
      },
      "bounties": {
        "title": "Planungsraum",
        "description": "Gemeinsam gute Taten vollbringen"
      },
      "trophies": {
        "description": "Was ihr zusammen erreicht habt"
      },
      "design": {
        "description": "Raumstile ansehen und auswählen"
      },
      "settings": {
        "title": "Verwaltung"
      }
    },
    "name": "Name",
    "selected_title": "Gewählter Titel",
    "joined": "Beitritt",
    "motto": "Motto",
    "save": "Speichern",
    "cancel": "Abbrechen",
    "no_motto": "Noch kein Motto hinterlegt.",
    "edit_motto": "Motto bearbeiten",
    "avatar_change": "Avatar ändern",
    "story_subtitle": "Mehr als ein Name. Eine Geschichte.",
    "story_description": "Deine Taten erzählen deine Geschichte.",
    "personal_data": "Persönliche Daten",
    "profile_image": "Profilbild ändern",
    "copy_key": "Schlüssel kopieren",
    "specialization": "Kategorien & Spezialisierung",
    "first_deeds": "Mit deinen ersten guten Taten wächst deine Spezialisierung.",
    "chronicle": "Chronik – Letzte gute Taten",
    "show_all": "Alle anzeigen →",
    "chronicle_empty": "Deine bestätigten guten Taten erzählen hier deine Geschichte."
  },
  "categories_guide": {
    "title": "Die zehn Kategorien",
    "assessment": "Wie eine konkrete gute Tat bewertet wird, hängt von Einsatz und Aufwand ab."
  },
  "category_showcase": {
    "gallery_label": "Kategorie entdecken",
    "eyebrow": "Dein Einsatz zählt",
    "descriptions": {
      "MOBILITY_OUTDOOR": "Begleite Menschen auf Wegen, hilf bei Fahrten oder unterstütze sichere Bewegung draußen.",
      "HEALTH_WELLNESS": "Unterstütze Wohlbefinden und Gesundheit im Alltag, ohne eine medizinische Behandlung zu ersetzen.",
      "ENTERTAINMENT_GASTRO": "Schaffe Begegnungen, gestalte ein gemeinsames Erlebnis oder organisiere eine gemeinnützige Veranstaltung.",
      "HARDWARE_FITNESS": "Hilf bei Bewegung, Training oder dem sinnvollen Einsatz von Sportausrüstung.",
      "ECO_NATURE": "Setze dich für Natur, saubere Orte und einen sorgsamen Umgang mit Ressourcen ein.",
      "TECH_EDUCATION": "Erkläre Technik, teile Wissen oder begleite jemanden beim Lernen.",
      "CRAFTING_REPAIR": "Repariere, baue oder erhalte etwas, das anderen Menschen nützt.",
      "FOOD_GROCERIES": "Hilf beim Einkaufen, Kochen oder bei der Weitergabe von Lebensmitteln.",
      "LOGISTICS_RETAIL": "Organisiere, transportiere oder verteile Dinge, die für eine gute Tat gebraucht werden.",
      "SOCIAL_COMMUNITY": "Unterstütze andere mit verlässlicher Begleitung und praktischer Hilfe im Alltag."
    }
  },
  "landing_classes": {
    "perks_unavailable": "Die aktuellen Perks sind gerade nicht erreichbar.",
    "select_class": "{{name}} auswählen",
    "preview_hint": "Entdecke deinen Weg. Wähle ein Emblem für die Vorschau."
  },
  "good_deed_examples": {
    "title": "Beispiele für gute Taten",
    "example": "Beispiel",
    "assessment": "Einstufung",
    "reason": "Begründung",
    "categories_link": "Die Kategorien entdecken",
    "ratings": {
      "low_simple": "Gering · Einfach",
      "medium_simple": "Mittel · Einfach",
      "medium_coordinated": "Mittel · Mit Absprachen",
      "high_coordinated": "Hoch · Mit Absprachen",
      "high_planned": "Hoch · Viel geplant",
      "very_high_planned": "Sehr hoch · Viel geplant"
    },
    "rating_by_row": [
      "low_simple",
      "low_simple",
      "low_simple",
      "low_simple",
      "low_simple",
      "low_simple",
      "low_simple",
      "low_simple",
      "low_simple",
      "low_simple",
      "medium_simple",
      "medium_simple",
      "medium_simple",
      "medium_simple",
      "medium_simple",
      "medium_coordinated",
      "medium_coordinated",
      "medium_coordinated",
      "medium_coordinated",
      "high_coordinated",
      "high_coordinated",
      "high_coordinated",
      "high_coordinated",
      "high_coordinated",
      "high_coordinated",
      "high_planned",
      "high_planned",
      "high_planned",
      "high_planned",
      "very_high_planned",
      "very_high_planned",
      "very_high_planned",
      "very_high_planned",
      "very_high_planned",
      "very_high_planned",
      "very_high_planned",
      "medium_simple",
      "medium_simple",
      "medium_coordinated",
      "medium_coordinated",
      "medium_simple",
      "high_coordinated",
      "medium_coordinated",
      "high_planned",
      "high_coordinated",
      "medium_coordinated",
      "medium_simple",
      "low_simple",
      "medium_coordinated",
      null,
      null,
      "medium_coordinated",
      "high_coordinated",
      "high_planned",
      "medium_simple",
      "high_coordinated",
      "medium_coordinated",
      "high_coordinated",
      "medium_coordinated",
      "high_coordinated",
      "medium_coordinated",
      null,
      "high_coordinated",
      "medium_coordinated",
      "medium_simple",
      "medium_coordinated",
      "high_planned",
      "medium_simple",
      "high_coordinated",
      "high_planned",
      "medium_coordinated",
      "high_coordinated",
      "medium_coordinated",
      "high_coordinated",
      "medium_simple",
      "medium_coordinated",
      "high_coordinated",
      "medium_simple",
      "medium_coordinated",
      "high_coordinated",
      "medium_simple",
      "medium_coordinated",
      "high_coordinated",
      "medium_simple",
      "medium_coordinated",
      "high_planned",
      "medium_simple",
      "medium_coordinated",
      "medium_coordinated",
      "high_coordinated",
      "high_planned"
    ],
    "rows": [
      {
        "title": "Gefahrenstelle (z. B. Glasscherben) auf Spielplatz oder Radweg beseitigen",
        "reason": "Kurze, nachweisbare Handlung, die aktiv Verletzungen oder Schäden verhindert.",
        "xp": "1–40"
      },
      {
        "title": "Umweltproblem mit Foto und Standort melden",
        "reason": "Kurze, konkrete Meldung mit prüfbarem Nachweis.",
        "xp": "1–40"
      },
      {
        "title": "Schlagloch bei der Gemeinde melden",
        "reason": "Lokaler Hinweis mit geringem Zeitaufwand.",
        "xp": "1–40"
      },
      {
        "title": "Illegale Müllablagerung melden",
        "reason": "Einzelmeldung mit Standort und Foto.",
        "xp": "1–40"
      },
      {
        "title": "Barriere auf einem Gehweg dokumentieren",
        "reason": "Nützlicher, schnell erstellter Hinweis.",
        "xp": "1–40"
      },
      {
        "title": "Eigene Fotos ausdrucken und jemandem schenken",
        "reason": "Auswahl, Vorbereitung und persönliche Übergabe zählen, nicht der Materialwert.",
        "xp": "1–40"
      },
      {
        "title": "Ein selbstgemachtes Bild oder eine kleine Portion selbstgekochtes Essen weitergeben",
        "reason": "Kleine kreative oder praktische Geste mit eigenem Einsatz.",
        "xp": "1–40"
      },
      {
        "title": "Eine Zeichnung oder ein kleines Porträt anfertigen und verschenken",
        "reason": "Persönlich angefertigtes Geschenk mit überschaubarem Zeitaufwand.",
        "xp": "1–40"
      },
      {
        "title": "Eine handgeschriebene Karte mit persönlichen Worten verschenken",
        "reason": "Individuelle Aufmerksamkeit mit geringem Zeit- und Materialaufwand.",
        "xp": "1–40"
      },
      {
        "title": "Einen selbst gezogenen Pflanzenableger verschenken",
        "reason": "Kleine persönliche Geste; bewertet wird die eigene Pflege und Übergabe.",
        "xp": "1–40"
      },
      {
        "title": "Einen Sack Müll in der Umgebung sammeln",
        "reason": "Sichtbarer eigener Einsatz mit überschaubarem Umfang.",
        "xp": "40–80"
      },
      {
        "title": "Futterspende beim lokalen Tierheim abgeben",
        "reason": "Bewertet werden Aufwand und belegte Übergabe, ausdrücklich nicht der Warenwert.",
        "xp": "40–80"
      },
      {
        "title": "Einkauf für eine benachbarte Person erledigen",
        "reason": "Direkte Nachbarschaftshilfe mit persönlichem Zeitaufwand.",
        "xp": "40–80"
      },
      {
        "title": "Gratis Nachhilfe für eine Stunde geben",
        "reason": "Abgegrenzte Wissensvermittlung ohne größere Vorbereitung.",
        "xp": "40–80"
      },
      {
        "title": "Kleines defektes Alltagsgerät für jemanden reparieren",
        "reason": "Praktische Hilfe mit Werkzeug und Fachkenntnis.",
        "xp": "40–80"
      },
      {
        "title": "Lebensmittel bei einer Rettungsstelle abholen und verteilen",
        "reason": "Abstimmung mit einer Stelle und verlässliche Übergabe.",
        "xp": "80–150"
      },
      {
        "title": "Nachbarschaftshilfe bei Gartenarbeit oder Umzug",
        "reason": "Mehrstündige körperliche oder organisatorische Unterstützung.",
        "xp": "80–150"
      },
      {
        "title": "Vorbereiteten Wissensworkshop durchführen",
        "reason": "Vorbereitung, Terminabstimmung und Vermittlung an mehrere Personen.",
        "xp": "80–150"
      },
      {
        "title": "Als Imker-Pate einen betreuten Praxistermin durchführen",
        "reason": "Spezialwissen, Verantwortung und längerer persönlicher Einsatz.",
        "xp": "80–150"
      },
      {
        "title": "Kleine gemeinsame Müllsammelaktion organisieren",
        "reason": "Teilnehmende, Material und Entsorgung müssen abgestimmt werden.",
        "xp": "150–250"
      },
      {
        "title": "Hilfsgüter für eine lokale Einrichtung sortieren",
        "reason": "Mehrstündige Arbeit in Abstimmung mit der Einrichtung.",
        "xp": "150–250"
      },
      {
        "title": "Fahrrad-Reparaturhilfe für mehrere Personen anbieten",
        "reason": "Fachwissen, Material und mehrere Empfänger.",
        "xp": "150–250"
      },
      {
        "title": "Barrierefreiheit eines ganzen Straßenabschnitts erfassen",
        "reason": "Systematische Dokumentation und strukturierte Weitergabe.",
        "xp": "150–250"
      },
      {
        "title": "Erste-Hilfe-Auffrischung in einer Gruppe organisieren",
        "reason": "Organisation mit qualifizierter Leitung; keine medizinischen Eigenleistungen bewerten.",
        "xp": "150–250"
      },
      {
        "title": "Mehrteilige Lernbegleitung übernehmen",
        "reason": "Wiederholte Termine, Vorbereitung und dokumentierter Lernfortschritt.",
        "xp": "150–250"
      },
      {
        "title": "Spendenaktion für ein Tierheim koordinieren",
        "reason": "Mehrere Beteiligte, Sammlung, Logistik und dokumentierte Übergabe.",
        "xp": "250–500"
      },
      {
        "title": "Öffentlichen Reparatur-Nachmittag mitorganisieren",
        "reason": "Raum, Helfende, Material und Ablauf werden koordiniert.",
        "xp": "250–500"
      },
      {
        "title": "Größere Aufräumaktion mit Entsorgung organisieren",
        "reason": "Hoher Aufwand mit Genehmigung, Team und geregelter Entsorgung.",
        "xp": "250–500"
      },
      {
        "title": "Mehrwöchige Imker- oder Handwerks-Patenschaft",
        "reason": "Nachhaltige Begleitung mit mehreren dokumentierten Terminen.",
        "xp": "250–500"
      },
      {
        "title": "Lokales Bildungsprogramm über mehrere Termine durchführen",
        "reason": "Konzept, Materialien, mehrere Termine und messbare Wirkung.",
        "xp": "500–800"
      },
      {
        "title": "Regelmäßige Lebensmittelrettung für eine Einrichtung aufbauen",
        "reason": "Dauerhafte Abläufe zwischen mehreren Stellen werden geschaffen.",
        "xp": "500–800"
      },
      {
        "title": "Gemeinschaftsfläche mit Zustimmung nachhaltig aufwerten",
        "reason": "Planung, Erlaubnis, Teamarbeit und langfristiges Ergebnis.",
        "xp": "500–800"
      },
      {
        "title": "Nachbarschaftliches Hilfsnetzwerk aufbauen",
        "reason": "Mehrwöchige Organisation mit mehreren Helfenden und Empfängern.",
        "xp": "500–800"
      },
      {
        "title": "Große Sachspendenlogistik für mehrere Einrichtungen koordinieren",
        "reason": "Viele Beteiligte, Transport, Sortierung und belegte Übergaben.",
        "xp": "500–800"
      },
      {
        "title": "Mehrmonatige Lern- oder Berufspatenschaft abschließen",
        "reason": "Langfristige Verantwortung und dokumentierte, nachhaltige Wirkung.",
        "xp": "500–800"
      },
      {
        "title": "Gemeinnützige digitale Lösung entwickeln und einführen",
        "reason": "Konzeption, Umsetzung, Einführung und nachhaltige Nutzung.",
        "xp": "500–800"
      },
      {
        "title": "Einer Person beim Training helfen",
        "reason": "Persönliche Unterstützung bei einer abgegrenzten Trainingseinheit.",
        "xp": "40–80"
      },
      {
        "title": "Gemeinsame Fitnessrunde durchführen",
        "reason": "Eine gemeinsame Bewegungsrunde anleiten und andere aktiv unterstützen.",
        "xp": "40–80"
      },
      {
        "title": "Laufgruppe organisieren",
        "reason": "Route, Termin und Teilnehmende abstimmen und den Lauf begleiten.",
        "xp": "80–150"
      },
      {
        "title": "Kostenloses Fitnesstraining anbieten",
        "reason": "Eine kostenlose Einheit vorbereiten und auf die Teilnehmenden abstimmen.",
        "xp": "80–150"
      },
      {
        "title": "Sportausrüstung für andere aufbereiten",
        "reason": "Ausrüstung reinigen, aufbereiten und zur Nutzung übergeben; der Warenwert zählt nicht.",
        "xp": "40–80"
      },
      {
        "title": "Kostenlosen Fitnesskurs für mehrere Personen durchführen",
        "reason": "Übungen vorbereiten, die Gruppe anleiten und auf unterschiedliche Voraussetzungen eingehen.",
        "xp": "150–250"
      },
      {
        "title": "Trainingsbegleitung übernehmen",
        "reason": "Eine längere Trainingseinheit abstimmen und eine Person verlässlich begleiten.",
        "xp": "80–150"
      },
      {
        "title": "Gemeinnützige Sportaktion organisieren",
        "reason": "Ort, Material, Helfende und Ablauf einer größeren gemeinnützigen Sportaktion planen.",
        "xp": "250–500"
      },
      {
        "title": "Gemeinschaftliches Training leiten",
        "reason": "Eine längere Gruppeneinheit planen, leiten und mehrere Teilnehmende betreuen.",
        "xp": "150–250"
      },
      {
        "title": "Sportausrüstung reparieren und bereitstellen",
        "reason": "Defekte beheben, die Nutzbarkeit prüfen und die Übergabe organisieren.",
        "xp": "80–150"
      },
      {
        "title": "Eine Person auf Wunsch zu einem Gesundheitstermin begleiten",
        "reason": "Persönliche Begleitung und Wartezeit erleichtern den Zugang zum Termin.",
        "xp": "40–80"
      },
      {
        "title": "Informationen zu barrierefreien Beratungsstellen für jemanden zusammenstellen",
        "reason": "Eine kurze, gezielte Recherche mit verständlicher Weitergabe unterstützt bei der Orientierung.",
        "xp": "1–40"
      },
      {
        "title": "Einen gemeinsamen Spaziergang gegen Einsamkeit organisieren und begleiten",
        "reason": "Termin, Bedürfnisse und eine passende Strecke werden mit den Teilnehmenden abgestimmt.",
        "xp": "80–150"
      },
      null,
      null,
      {
        "title": "Einen kostenlosen Spiele- oder Vorlesenachmittag für die Nachbarschaft durchführen",
        "reason": "Vorbereitung, Einladung und Begleitung einer Gruppe zählen zum persönlichen Einsatz.",
        "xp": "80–150"
      },
      {
        "title": "Einen kleinen kostenlosen Musik- oder Theaterabend für eine Einrichtung organisieren",
        "reason": "Programm, Mitwirkende, Raum und Ablauf werden mit der Einrichtung abgestimmt.",
        "xp": "150–250"
      },
      {
        "title": "Eine mehrteilige kreative Werkstatt für eine offene Gruppe durchführen",
        "reason": "Mehrere vorbereitete Termine, Materialorganisation und Anleitung bedeuten anhaltenden Einsatz.",
        "xp": "250–500"
      },
      {
        "title": "Kleidung für eine andere Person flicken oder passend ändern",
        "reason": "Handwerkliche Arbeit verlängert die Nutzbarkeit; bewertet wird der Einsatz statt des Warenwerts.",
        "xp": "40–80"
      },
      {
        "title": "Ein gespendetes Möbelstück reparieren und für eine Einrichtung aufbereiten",
        "reason": "Schadensprüfung, Reparatur und Übergabe erfordern Werkzeug, Zeit und Abstimmung.",
        "xp": "150–250"
      },
      {
        "title": "Eine gemeinsame Mahlzeit für eine Nachbarschaftsgruppe vorbereiten und ausgeben",
        "reason": "Bedarf, Einkauf, Zubereitung und Ausgabe werden abgestimmt; der Warenwert zählt nicht.",
        "xp": "80–150"
      },
      {
        "title": "Eine Schicht bei einer Lebensmittelausgabe ehrenamtlich unterstützen",
        "reason": "Mehrstündiges Sortieren, Portionieren und Ausgeben erfolgt in Abstimmung mit der Einrichtung.",
        "xp": "150–250"
      },
      {
        "title": "Eine Person auf einer barrierearmen Alltagsroute begleiten",
        "reason": "Strecke und Unterstützungsbedarf werden vorab abgestimmt und die Begleitung tatsächlich durchgeführt.",
        "xp": "80–150"
      },
      {
        "title": "Transport und Übergabe gespendeter Möbel für eine soziale Einrichtung organisieren",
        "reason": "Abholtermine, Helfende und Transport müssen koordiniert und die Übergabe belegt werden.",
        "xp": "150–250"
      },
      {
        "title": "Einen offenen Nachbarschaftstreff für neue Bewohner organisieren",
        "reason": "Einladung, Raum und persönliche Begleitung fördern konkrete Begegnungen im Wohnumfeld.",
        "xp": "80–150"
      },
      null,
      {
        "title": "Eine kostenlose Orientierungstour für neu zugezogene Menschen durchführen",
        "reason": "Route, hilfreiche Anlaufstellen und verständliche Erklärungen werden vorbereitet.",
        "xp": "150–250"
      },
      {
        "title": "Bei einem Vereinsausflug die Begleitung von Teilnehmenden übernehmen",
        "reason": "Absprachen zu Treffpunkten, Weg und individuellen Bedürfnissen ermöglichen die Teilnahme.",
        "xp": "80–150"
      },
      {
        "title": "Einer vorübergehend erkrankten Person vereinbarte Alltagserledigungen abnehmen",
        "reason": "Konkrete Erledigungen entlasten die Person; bewertet wird die tatsächlich geleistete Zeit.",
        "xp": "40–80"
      },
      {
        "title": "Einen kostenlosen ruhigen Begegnungsnachmittag gegen Einsamkeit gestalten",
        "reason": "Raum, Einladung und eine aufmerksame Begleitung der Teilnehmenden erfordern Vorbereitung.",
        "xp": "80–150"
      },
      {
        "title": "Einen Begleitdienst zu Terminen mit einer sozialen Einrichtung aufbauen",
        "reason": "Freiwillige, Zuständigkeiten und mehrere tatsächlich durchgeführte Begleitungen werden koordiniert.",
        "xp": "250–500"
      },
      {
        "title": "Bei einer kostenlosen Veranstaltung für Kinder vorlesen",
        "reason": "Auswahl und Vorbereitung der Geschichten sowie die tatsächliche Vorlesezeit zählen.",
        "xp": "40–80"
      },
      {
        "title": "Bei einem gemeinnützigen Fest eine kostenlose Kreativstation betreuen",
        "reason": "Material, Aufbau und die Betreuung mehrerer Gäste erfordern eigenen Einsatz.",
        "xp": "150–250"
      },
      {
        "title": "Eine öffentliche Büchertauschaktion vorbereiten und durchführen",
        "reason": "Sammlung, Sortierung, Standortabstimmung und die Durchführung werden gemeinsam organisiert.",
        "xp": "250–500"
      },
      {
        "title": "Eine kostenlose Bewegungs- und Spielrunde für Kinder betreuen",
        "reason": "Altersgerechte Spiele, Material und Absprachen mit den Verantwortlichen werden vorbereitet.",
        "xp": "80–150"
      },
      {
        "title": "Bei einem gemeinnützigen inklusiven Sporttag Teilnehmende und Stationen betreuen",
        "reason": "Einweisung, Abstimmung und mehrstündige Begleitung unterstützen die Teilnahme am Sportangebot.",
        "xp": "150–250"
      },
      {
        "title": "Mit Erlaubnis eine heimische Blühfläche anlegen und pflegen",
        "reason": "Standortabstimmung, geeignete Pflanzen und tatsächlich geleistete Pflanz- und Pflegearbeit zählen.",
        "xp": "80–150"
      },
      {
        "title": "Bei einer betreuten Pflegeaktion für Hecken oder Streuobstwiesen mithelfen",
        "reason": "Mehrstündige praktische Arbeit wird mit der verantwortlichen Naturschutzgruppe abgestimmt.",
        "xp": "150–250"
      },
      {
        "title": "Einer Person grundlegende Smartphone-Funktionen erklären",
        "reason": "Gemeinsames Üben von Nachrichten, Einstellungen oder Videoanrufen vermittelt alltagstaugliches Wissen.",
        "xp": "40–80"
      },
      {
        "title": "Eine kostenlose Einführung zu sicheren Passwörtern und Betrugsnachrichten geben",
        "reason": "Verständliche Beispiele und gemeinsame Übungen werden für die Teilnehmenden vorbereitet.",
        "xp": "80–150"
      },
      {
        "title": "Gebrauchte Computer für eine gemeinnützige Einrichtung einrichten",
        "reason": "Abgestimmte Datenlöschung, Installation und Funktionsprüfung erfordern Zeit und technisches Können.",
        "xp": "150–250"
      },
      {
        "title": "Spielzeug für eine andere Familie reparieren und aufbereiten",
        "reason": "Fehlersuche, Reparatur und Prüfung der Nutzbarkeit zählen statt des Materialwerts.",
        "xp": "40–80"
      },
      {
        "title": "Werkzeug für eine gemeinschaftliche Ausleihe warten und sortieren",
        "reason": "Werkzeuge werden geprüft, gepflegt und mit der Ausleihstelle übersichtlich bereitgestellt.",
        "xp": "80–150"
      },
      {
        "title": "Eine einfache Reparatur unter Anleitung gemeinsam mit anderen durchführen",
        "reason": "Vorbereitung und praktische Wissensweitergabe helfen mehreren Personen, Dinge selbst zu erhalten.",
        "xp": "150–250"
      },
      {
        "title": "Überschüssige Ernte mit einer vereinbarten Abgabestelle teilen",
        "reason": "Ernten, Sortieren und die dokumentierte Übergabe zählen; der Warenwert bestimmt die Punkte nicht.",
        "xp": "40–80"
      },
      {
        "title": "Einen gemeinschaftlichen Lebensmittel-Fairteiler reinigen und betreuen",
        "reason": "Reinigung, Bestandskontrolle und Absprachen mit dem verantwortlichen Team erfordern regelmäßigen Einsatz.",
        "xp": "80–150"
      },
      {
        "title": "Einen kostenlosen Kochabend zur Resteverwertung durchführen",
        "reason": "Rezepte, Zutatenabsprachen und praktische Anleitung vermitteln mehreren Personen alltagstaugliche Fähigkeiten.",
        "xp": "150–250"
      },
      {
        "title": "Gut erhaltene Kleidung für eine soziale Kleiderausgabe sortieren",
        "reason": "Prüfen, Falten und übersichtliches Einordnen unterstützen die spätere Ausgabe.",
        "xp": "40–80"
      },
      {
        "title": "Bei einem gemeinnützigen Basar Aufbau und Ausgabe übernehmen",
        "reason": "Materialaufbau und eine verlässliche Schicht werden mit dem Organisationsteam abgestimmt.",
        "xp": "80–150"
      },
      {
        "title": "Ein übersichtliches Lager- und Ausgabesystem für Sachspenden einführen",
        "reason": "Bestandsaufnahme, Kennzeichnung und die Einführung mit dem Team schaffen dauerhaft nutzbare Abläufe.",
        "xp": "250–500"
      },
      {
        "title": "Jemandem beim Verstehen und Sortieren von Behördenbriefen helfen",
        "reason": "Gemeinsames Lesen und Ordnen erleichtern die Orientierung bei konkreten Alltagsschritten.",
        "xp": "40–80"
      },
      {
        "title": "Eine kostenlose Sprach-Tandemrunde für Nachbarn organisieren",
        "reason": "Abgestimmte Termine und vorbereitete Gesprächsimpulse unterstützen den gegenseitigen Austausch.",
        "xp": "80–150"
      },
      {
        "title": "Eine vereinbarte Kinderbetreuung zur Entlastung einer Familie übernehmen",
        "reason": "Verlässliche Betreuung mit den nötigen Absprachen ermöglicht der Familie einen konkreten Freiraum.",
        "xp": "80–150"
      },
      {
        "title": "Bei einem Nachbarschaftstreffen eine Kinder- oder Spielecke betreuen",
        "reason": "Vorbereitung und mehrstündige Betreuung werden mit den Verantwortlichen abgestimmt.",
        "xp": "150–250"
      },
      {
        "title": "Eine Nachbarschafts-Tauschbörse vorbereiten und durchführen",
        "reason": "Bedarf, Raum, Helfende und tatsächliche Übergaben werden für mehrere Haushalte organisiert.",
        "xp": "250–500"
      }
    ]
  },
  "email_confirmation": {
    "title": "E-Mail bestätigen",
    "intro": "Bestätige deine E-Mail-Adresse, um dich anmelden zu können.",
    "confirm": "E-Mail-Adresse bestätigen",
    "success": "Deine E-Mail-Adresse ist bestätigt. Du kannst dich jetzt anmelden. Partnerkonten benötigen zusätzlich die Freigabe durch den Admin.",
    "resend_link": "Bestätigungslink erneut anfordern",
    "resend": "Bestätigungsmail senden",
    "sent": "Falls für diese Adresse eine Bestätigung aussteht, wurde eine E-Mail gesendet. Bitte warte eine Minute vor einer weiteren Anfrage.",
    "registered": "Bitte bestätige deine E-Mail-Adresse über den Link in der E-Mail. Erst danach kannst du dich anmelden.",
    "registered_partner": "Bitte bestätige deine E-Mail-Adresse über den Link in der E-Mail. Dein Partnerkonto benötigt außerdem die Freigabe durch den Admin.",
    "registered_local": "Dein lokales Konto ist erstellt. Du kannst dich jetzt anmelden.",
    "registered_partner_local": "Dein lokales Partnerkonto ist erstellt. Es benötigt noch die Freigabe durch den Admin."
  },
  "guildHeroicActions": {
    "backToActions": "Zurück zu den Gruppenaktionen",
    "category": "Kategorie",
    "milestones": "Neue Kategorie-Meilensteine",
    "category_level": "Kategorie-Level {{level}} erreicht",
    "badge_label": "Abzeichen {{category}}, Level {{level}}",
    "invite": "Einladen",
    "chooseMember": "Mitglied auswählen",
    "memberOption": "Mitglied",
    "invited": "Einladung gesendet. Das Mitglied kann sich freiwillig anmelden.",
    "title": "Gruppenaktionen",
    "announce": "Gute Tat ausrufen",
    "loadError": "Gruppenaktionen konnten nicht geladen werden.",
    "actionError": "Aktion fehlgeschlagen.",
    "evidenceRequired": "Bitte gemeinsame Beweisdatei auswählen und Datenschutz bestätigen.",
    "titlePlaceholder": "Titel",
    "descriptionPlaceholder": "Was soll die Gruppe gemeinsam tun?",
    "declaration": "Verbindliche Organisator-Erklärung",
    "declarations": [
      [
        "voluntaryParticipationConfirmed",
        "Die Teilnahme ist freiwillig; Abmeldung ist ohne Sanktion möglich."
      ],
      [
        "nonCommercialPurposeConfirmed",
        "Die gute Tat dient dem Gemeinwohl und keinem kommerziellen Betriebszweck."
      ],
      [
        "noPaidWorkReplacementConfirmed",
        "Sie ersetzt keine bezahlte Stelle, Schicht oder reguläre Dienstleistung."
      ],
      [
        "safetyResponsibilityConfirmed",
        "Erforderliche Erlaubnisse, sichere Durchführung und Entsorgung sind organisiert."
      ]
    ],
    "scheduled": "Termin",
    "deadline": "Anmeldeschluss",
    "maxParticipants": "Max. Teilnehmende",
    "announcing": "Wird ausgerufen…",
    "scheduledFuture": "Der Termin muss in der Zukunft liegen.",
    "deadlineFuture": "Der Anmeldeschluss muss in der Zukunft liegen.",
    "deadlineAfterSchedule": "Der Anmeldeschluss darf nicht nach dem Termin liegen.",
    "loading": "Lade Gruppenaktionen…",
    "empty": "Noch keine Gruppenaktion ausgerufen.",
    "registered": "angemeldet",
    "confirmed": "bestätigt",
    "groupRange": "Richtwert für die gesamte Gruppe",
    "register": "Anmelden",
    "allocationHint": "Verteile 100 % in ganzen Prozent auf die bestätigten Teilnehmenden. Niemand darf mehr als 50 % erhalten.",
    "allocationInvalid": "Verteile genau 100 % in ganzen Prozent. Pro bestätigter Person sind 0 bis 50 % erlaubt; mindestens zwei Personen brauchen einen positiven Anteil.",
    "confirm": "Teilnahme bestätigen",
    "withdraw": "Abmelden",
    "cancel": "Absagen",
    "cancelConfirmTitle": "Gruppenaktion absagen?",
    "cancelConfirm": "Möchtest du „{{title}}“ wirklich absagen? Einladungsbenachrichtigungen werden entfernt; angemeldete Mitglieder erhalten eine Absagebenachrichtigung.",
    "delete": "Löschen",
    "deleteConfirmTitle": "Gruppenaktion löschen?",
    "deleteConfirm": "Möchtest du die abgesagte Gruppenaktion „{{title}}“ löschen? Sie verschwindet aus der Liste. Dieser Schritt kann nicht rückgängig gemacht werden.",
    "privacy": "Der Beweis zeigt keine unbeteiligten Personen, Kennzeichen, privaten Adressen oder sensiblen Dokumente.",
    "uploadLater": "Beweis nachreichen",
    "statuses": {
      "Announced": "Anmeldung offen",
      "AwaitingEvidence": "Beweis fehlt",
      "Returned": "Zur Überarbeitung zurückgeschickt",
      "Approved": "Bestätigt",
      "Rejected": "Abgelehnt",
      "Cancelled": "Abgesagt"
    },
    "returnReason": "Grund für die Rückgabe",
    "allocationTotal": "Verteilt: {{total}} / 100 %",
    "chat": {
      "announced": "[GUTE TAT] {{title}} wurde für {{date}} ausgerufen. Mitglieder können sich jetzt anmelden.",
      "awaitingEvidence": "[GUTE TAT] {{title}} wurde mit {{count}} bestätigten Teilnehmenden abgeschlossen. Der gemeinsame Nachweis wird noch hochgeladen."
    }
  },
  "groupActionGuide": {
    "back": "Zurück zu den Gruppenaktionen",
    "title": "Eine Gruppenaktion mit fünf Personen",
    "contents": "Inhalt des Leitfadens",
    "flowTitle": "Vom Plan zur geprüften guten Tat",
    "absenceTitle": "Wenn Eva nicht erscheint",
    "rules": [
      "Genau 100 % insgesamt, nur ganze Prozent zwischen 0 und 50 je bestätigter Person.",
      "Mindestens zwei positive Anteile. Bei drei Personen ist der gleichmäßige Vorschlag 34 / 33 / 33 %.",
      "Die 50-%-Grenze gilt vor persönlichen Boni. Sie begrenzt nicht den Anteil an der Summe aller endgültigen Gutschriften."
    ],
    "tableLabel": "Beispielauszahlung nach erfolgreicher Freigabe",
    "buffsTitle": "Welche Boni zusammenwirken",
    "outcomesTitle": "Rückgabe, Ablehnung und Abschluss",
    "assessmentTitle": "Zusätzliche Stufen für große Gruppenprojekte",
    "assessmentIntro": "Gruppenaktionen haben je eine zusätzliche höchste Stufe. Die Teilnehmerzahl allein rechtfertigt keine höhere Einstufung. Bewertet werden belegter gemeinsamer Einsatz und tatsächlich erforderliche Organisation.",
    "assessmentLevels": [
      {
        "title": "Umfangreicher Gemeinschaftseinsatz",
        "text": "Nur Gruppen: erheblicher gemeinsamer Einsatz über mehrere Arbeitstage oder wiederkehrende Termine mit belegten Beiträgen. Die Gruppengröße allein genügt nicht."
      },
      {
        "title": "Mehrstufige Organisation",
        "text": "Nur Gruppen: mehrere Teams oder Stellen, aufeinander aufbauende Phasen, klare Zuständigkeiten und abgestimmte Übergaben."
      }
    ],
    "poolComparisonTitle": "Eigene Bänder für Gruppenpools",
    "poolComparisonColumns": [
      "Band",
      "Einzelaktion",
      "Gemeinsamer Gruppenpool"
    ],
    "poolComparisonIntro": "Die folgenden Standardwerte gelten vor Boni und Verteilung. Gruppenpools sind zum Start fünfmal so hoch wie die bisherigen Bandwerte und werden unabhängig von Einzelaktionen konfiguriert. Sie wachsen nicht automatisch mit der Teilnehmerzahl. Bei gleicher Verteilung auf fünf Personen entspricht der Basisanteil ungefähr dem bisherigen Einzelwert; Gruppenbuffs kommen hinzu. Bei größeren Gruppen sinkt der Anteil pro Person."
  },
  "heroicActionXpGuideData": {
    "difficulty": {
      "LOW": [
        "Gering",
        "Kurze Aufgabe, meist bis 30 Minuten; wenig körperlicher oder persönlicher Einsatz."
      ],
      "MEDIUM": [
        "Mittel",
        "Etwa 30 Minuten bis 2 Stunden oder spürbarer persönlicher Einsatz."
      ],
      "HIGH": [
        "Hoch",
        "Mehrere Stunden, besonderes Können oder viel Verantwortung."
      ],
      "EXCEPTIONAL": [
        "Sehr hoch",
        "Mehrere Tage Einsatz oder ein längerfristiger Beitrag. Dafür ist kein Risiko nötig."
      ],
      "EXTENSIVE": [
        "Umfangreicher Gemeinschaftseinsatz",
        "Nur Gruppen: erheblicher gemeinsamer Einsatz über mehrere Arbeitstage oder wiederkehrende Termine mit belegten Beiträgen. Die Gruppengröße allein genügt nicht."
      ]
    },
    "complexity": {
      "SIMPLE": [
        "Einfach",
        "Du kannst direkt loslegen und die Aufgabe allein erledigen."
      ],
      "COORDINATED": [
        "Mit Absprachen",
        "Du brauchst etwas Vorbereitung oder musst dich mit anderen abstimmen."
      ],
      "COMPLEX": [
        "Viel geplant",
        "Mehrere Personen, Termine oder Schritte müssen zusammenpassen."
      ],
      "MULTISTAGE": [
        "Mehrstufige Organisation",
        "Nur Gruppen: mehrere Teams oder Stellen, aufeinander aufbauende Phasen, klare Zuständigkeiten und abgestimmte Übergaben."
      ]
    },
    "titles": {
      "Gefahrenstelle (z. B. Glasscherben) auf Spielplatz oder Radweg beseitigen": "Gefahrenstelle (z. B. Glasscherben) auf Spielplatz oder Radweg beseitigen",
      "Umweltproblem mit Foto und Standort melden": "Umweltproblem mit Foto und Standort melden",
      "Schlagloch bei der Gemeinde melden": "Schlagloch bei der Gemeinde melden",
      "Illegale Müllablagerung melden": "Illegale Müllablagerung melden",
      "Barriere auf einem Gehweg dokumentieren": "Barriere auf einem Gehweg dokumentieren",
      "Einen Sack Müll in der Umgebung sammeln": "Einen Sack Müll in der Umgebung sammeln",
      "Futterspende beim lokalen Tierheim abgeben": "Futterspende beim lokalen Tierheim abgeben",
      "Einkauf für eine benachbarte Person erledigen": "Einkauf für eine benachbarte Person erledigen",
      "Eine Stunde Nachhilfe geben": "Eine Stunde Nachhilfe geben",
      "Kleines defektes Alltagsgerät für jemanden reparieren": "Kleines defektes Alltagsgerät für jemanden reparieren",
      "Lebensmittel bei einer Rettungsstelle abholen und verteilen": "Lebensmittel bei einer Rettungsstelle abholen und verteilen",
      "Nachbarschaftshilfe bei Gartenarbeit oder Umzug": "Nachbarschaftshilfe bei Gartenarbeit oder Umzug",
      "Vorbereiteten Wissensworkshop durchführen": "Vorbereiteten Wissensworkshop durchführen",
      "Als Imker-Pate einen betreuten Praxistermin durchführen": "Als Imker-Pate einen betreuten Praxistermin durchführen",
      "Kleine gemeinsame Müllsammelaktion organisieren": "Kleine gemeinsame Müllsammelaktion organisieren",
      "Hilfsgüter für eine lokale Einrichtung sortieren": "Hilfsgüter für eine lokale Einrichtung sortieren",
      "Fahrrad-Reparaturhilfe für mehrere Personen anbieten": "Fahrrad-Reparaturhilfe für mehrere Personen anbieten",
      "Barrierefreiheit eines ganzen Straßenabschnitts erfassen": "Barrierefreiheit eines ganzen Straßenabschnitts erfassen",
      "Erste-Hilfe-Auffrischung in einer Gruppe organisieren": "Erste-Hilfe-Auffrischung in einer Gruppe organisieren",
      "Mehrteilige Lernbegleitung übernehmen": "Mehrteilige Lernbegleitung übernehmen",
      "Spendenaktion für ein Tierheim koordinieren": "Spendenaktion für ein Tierheim koordinieren",
      "Öffentlichen Reparatur-Nachmittag mitorganisieren": "Öffentlichen Reparatur-Nachmittag mitorganisieren",
      "Größere Aufräumaktion mit Entsorgung organisieren": "Größere Aufräumaktion mit Entsorgung organisieren",
      "Mehrwöchige Imker- oder Handwerks-Patenschaft": "Mehrwöchige Imker- oder Handwerks-Patenschaft",
      "Lokales Bildungsprogramm über mehrere Termine durchführen": "Lokales Bildungsprogramm über mehrere Termine durchführen",
      "Regelmäßige Lebensmittelrettung für eine Einrichtung aufbauen": "Regelmäßige Lebensmittelrettung für eine Einrichtung aufbauen",
      "Gemeinschaftsfläche mit Zustimmung nachhaltig aufwerten": "Gemeinschaftsfläche mit Zustimmung nachhaltig aufwerten",
      "Nachbarschaftliches Hilfsnetzwerk aufbauen": "Nachbarschaftliches Hilfsnetzwerk aufbauen",
      "Große Sachspendenlogistik für mehrere Einrichtungen koordinieren": "Große Sachspendenlogistik für mehrere Einrichtungen koordinieren",
      "Mehrmonatige Lern- oder Berufspatenschaft abschließen": "Mehrmonatige Lern- oder Berufspatenschaft abschließen",
      "Gemeinnützige digitale Lösung entwickeln und einführen": "Gemeinnützige digitale Lösung entwickeln und einführen"
    },
    "rationale": [
      "Kurzer, überprüfbarer Beitrag mit begrenztem Aufwand.",
      "Klarer persönlicher Einsatz mit überprüfbarem Ergebnis.",
      "Mittlerer Aufwand oder Koordinationsbedarf mit Nachweisen.",
      "Hoher Aufwand oder komplexe Durchführung mit Nachweisen.",
      "Sehr anspruchsvoller oder mehrtägiger Beitrag mit klarer Wirkung.",
      "Außergewöhnliches, dauerhaftes Gemeinschaftsprojekt mit dokumentierter Wirkung."
    ]
  },
  "presentation": {
    "welcome": "Willkommen bei Goodvale",
    "gameMode": "Darstellung",
    "gateNames": { "community": "Realistisch", "fantasy": "Fantasy" },
    "gateHint": "Einmal klicken oder tippen zum Entdecken. Ein zweites Mal bestätigt deine Wahl.",
    "previewMode": "{{mode}} entdecken",
    "confirmMode": "{{mode}} bestätigen",
    "discoverMode": "Entdecken",
    "confirmPreview": "Noch einmal zum Bestätigen",
    "previewSelected": "{{mode}} vergrößert. Klicke oder tippe erneut auf diesen Modus, um ihn zu bestätigen.",
    "title": "Wie möchtest du Goodvale erleben?",
    "hint": "Du kannst die Darstellung jederzeit ändern.",
    "label": "Darstellung",
    "community": "Realistisch",
    "fantasy": "Fantasy",
    "communityDescription": "Gemeinsam Gutes tun. Klare Kategorien, Gruppen und persönliche Fortschritte.",
    "fantasyDescription": "Erlebe gute Taten als Abenteuer mit Klassen, Gilden und Fantasy-Motiven.",
    "saving": "Darstellung wird gespeichert …",
    "error": "Die Darstellung gilt auf diesem Gerät. Die Kontospeicherung ist noch ausstehend.",
    "retry": "Erneut speichern",
    "unsupported": "Diese Darstellung ist hier noch nicht verfügbar. Du siehst vorübergehend den realistischen Modus; deine Kontowahl bleibt erhalten.",
    "loading": "Darstellung wird geladen …",
    "invalid": "Diese Darstellung ist nicht verfügbar.",
    "saved": "Darstellung gespeichert.",
    "choose": "Darstellung auswählen",
    "login": "Anmelden",
    "legal": "Rechtliche Informationen",
    "loadError": "Deine Kontowahl konnte nicht geladen werden. Bitte versuche es erneut.",
    "reload": "Erneut laden"
  },
  "systemCopy": {
    "05b1b5e96c06": "Tailwind Farb-Klasse"
  },
  "effectDescriptions": {
    "ParallelHeroicActionSlot": "{{value}} zusätzlicher paralleler Einreichungsplatz.",
    "HeroicActionCooldownReduction": "{{percent}} % kürzere Wartezeit zwischen Einreichungen.",
    "WeeklyCooldownSkip": "Einmal pro Kalenderwoche die Wartezeit überspringen. Ein freier Einreichungsplatz bleibt erforderlich.",
    "HeroicActionRepair": "Eine eigene abgelehnte Einzelaktion einmal überarbeiten und erneut prüfen lassen."
  },
  "effectTitles": {
    "CategoryRewardBonus": "Kategoriebonus",
    "CategoryExperienceBonus": "Kategorie-Erfahrung",
    "GuildGildexContributionBonus": "Gruppenbeitrag",
    "HeroicActionXpBonus": "Erfahrungsbonus",
    "PartyBuff": "Gruppenbonus",
    "ParallelHeroicActionSlot": "Zusätzlicher Platz",
    "HeroicActionCooldownReduction": "Kürzere Wartezeit",
    "KarmaBonus": "Vertrauensbonus",
    "GroupKarmaBonus": "Gruppenvertrauen",
    "KarmaRecoveryBonus": "Vertrauen aufbauen",
    "OtherCategoryExperienceBonus": "Vielseitigkeit",
    "WeeklyCooldownSkip": "Wartezeit überspringen",
    "WeeklyExperienceElixir": "Erfahrungsbonus",
    "HeroicActionRepair": "Einmalig überarbeiten",
    "ClassKarmaRecovery": "Vertrauen aufbauen"
  },
  "unlocks": {
    "TROPHY_ROOM": {
      "description": "Schaltet eine interne Galerie für erfolgreich abgeschlossene und bestätigte Gruppenaktionen frei."
    }
  },
  "classAvailability": {
    "contacts": "Gute Kontakte",
    "repair": "Einmalig überarbeiten",
    "available": "Verfügbar",
    "unavailable": "Nicht verfügbar",
    "used": "Verbraucht",
    "again": "Wieder verfügbar",
    "how": "So funktioniert {{label}}",
    "contactsHelp": [
      "Einmal pro Kalenderwoche einen Slot mit laufender Wartezeit freigeben.",
      "Unter „Meine Slots“ bei der Wartezeit auf „Slot freigeben“ tippen.",
      "Der Slot ist sofort frei. Die Woche beginnt montags um 00:00 UTC."
    ],
    "bonusHelp": [
      "Einmal pro Kalenderwoche {{percent}} % zusätzliche Gesamt- und Kategorie-Erfahrungspunkte für eine bestätigte Einzelaktion.",
      "Im letzten Schritt oder bei der Schnelleinreichung auswählen.",
      "Beim Einreichen verbraucht, auch bei späterer Ablehnung. Die Woche beginnt montags um 00:00 UTC."
    ],
    "repairHelp": [
      "Eine eigene abgelehnte Einzelaktion einmal überarbeiten und erneut prüfen lassen.",
      "In der Detailansicht die Überarbeitung wählen.",
      "Beschreibung oder Nachweis ändern; ein freier Slot ist nötig. Andere abgelehnte Taten bleiben überarbeitbar."
    ]
  },
  "category_detail": {
    "subtitle": "Dein Einsatz in dieser Kategorie",
    "intro": "Entdecke deine Einreichungen und Ideen für deine nächste gute Tat mit passenden XP-Richtwerten.",
    "back": "Zurück zum Dashboard",
    "submissions": "Deine Einreichungen",
    "all": "Alle anzeigen",
    "empty": "Du hast in dieser Kategorie noch keine guten Taten eingereicht. Lass dich von den Beispielen inspirieren.",
    "pagination": "Einreichungen durchblättern",
    "previous": "Zurück",
    "next": "Weiter",
    "page": "Seite {{page}} von {{pages}}"
  }
}
